var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ChangeDetectorRef, ElementRef, EventEmitter } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Http } from '@angular/http';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { isEqual, orderBy } from 'lodash';
import * as moment from 'moment';
import { MaskPipe } from 'ngx-mask';
import { Modal } from 'ngx-modal';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { ApiUrlConstants } from '../../common/constants/api.constants';
import { AccessLevel } from '../../common/enums/access-level.enum';
import { Permission } from '../../common/enums/permission.enum';
import { CurrencyTransformPipe } from '../../common/pipes/currency-format.pipe';
import { TitleCasePipe } from '../../common/pipes/title-case.pipe';
import { MemberActivityLogType } from '../../shared/common/enumerations';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { CommonConstant } from '../../shared/constants/common.constants';
import { CacheService } from '../../shared/services/cache.service';
import { CommonService } from '../../shared/services/common.service';
import { DataShareService } from '../../shared/services/data.service';
import { EnrollmentCommonService } from '../../shared/services/enrollment-common.service';
import { MemberDisplayPriceConfigService } from '../../shared/services/member-display-price-config.service';
import { MessageService } from '../../shared/services/message.service';
import { CustomValidators } from '../../shared/Utils/custom-validator';
import { Utils } from '../../shared/Utils/utils';
import { Constants, DelivaryOptionType, IsoCodeThree } from '../common/constants';
import { DeliveryPreference, MemberLevel, OrderType, ProductType, PromotionOrderType } from '../common/enumerations';
import { DateConstants } from '../constants/date.constants';
import { MemberTypeId } from '../constants/member-type-id.enum';
import { PaymentMethodTypeConstants } from '../constants/payment-method-types.constants';
import { PaymentModeConstants } from '../constants/payment-mode.constants';
import { PaymentConstants } from '../constants/payment.constants';
import { PhoneCodesConstants } from '../constants/phone-codes.constant';
import { PortalDisplayPage } from '../constants/portal-display-page.enum';
import { Translations } from '../constants/translations.constants';
import { EcheckPhoneNumberValidation } from '../directive/echeck-phone-validation';
import { BonusPaymentOption } from '../enums/bonus-payment-option.enum';
import { BeneluxCountries } from '../enums/countries.enums';
import { DisplaySectionId, DocumentLibraryMemberId, Portal } from '../enums/document-library-member-id.enum';
import { AccountType } from '../enums/echeck-accounttypes.enum';
import { EcheckPortalTypes } from '../enums/echeck-portal-types.enum';
import { ImageType } from '../enums/image-type.enum';
import { MemberOrderType } from '../enums/member-order-type.enum';
import { MemberTypeEnum } from '../enums/member-type.enum';
import { MessageTypeEnum } from '../enums/message-type.enums';
import { NotificationType } from '../enums/notification-types.enum';
import { OrderSourceType, AddressType, OrderStatus, PaymentType, PurchaseFlows, PurchaseFlowType, ShippingOrderType, ShippingType, PaymentMethodTypes, Source } from '../enums/order-source-type';
import { OrderSourceTypes } from '../enums/order-source.enum';
import { ProductMetatDataValue } from '../enums/product-metadata.enum';
import { SelectEnum } from '../enums/selection.enum';
import { ShippingMemberType } from '../enums/shipping-member-type.enum';
import { ValueType } from '../enums/value-type.enum';
import { TaxType } from '../interface/tax-type.interface';
import { OrderInfoTab } from '../models/order-info-tab-model';
import { PaymentComponentSettings } from '../models/payments/payment.model';
import { AchService } from '../services/ach.service';
import { AppConfigService } from '../services/app-config.service';
import { CheckoutConfigService } from '../services/checkout-config.service';
import { ConfigurationService } from '../services/configuration.service';
import { AddressService } from '../services/address.service';
import { CustomerService } from '../services/customer.service';
import { DocumentService } from '../services/document.service';
import { EcheckService } from '../services/echeck.service';
import { EnrollmentMessageService } from '../services/enrollment-message.service';
import { EnrollService } from '../services/enrollment.service';
import { OrderService } from '../services/order.service';
import { PayvisionService } from '../services/payvision.service';
import { PersonalInfoConfigService } from '../services/personal-info-config.service';
import { PersonalMessageService } from '../services/personal-schema-form.service';
import { ShippingAddressInfoConfigService } from '../services/shipping-config.service';
import { CustomValidator } from './customvalidation.component';
import { ImpersonateUserConstants } from '../constants/impersonate-user.constants';
import { ProductSource } from '../common/constants';
import { PaymentProcessorAlias } from '../enums/payment-processor-alias.enum';
import { BankWireTransferConstants } from '../constants/bank-wire-transfer-configuration.constants';
var Randomize = require('randomatic');
var OrderCreateFBOComponent = /** @class */ (function () {
    function OrderCreateFBOComponent(_orderService, _sanitizer, _formbuilder, _http, _commonService, _translatePipe, _documentService, _currencyPipe, _cacheService, _customerService, messageService, _payvisionService, _titleCase, _maskPipe, _enrollmentMessageService, _enrollService, _shippingAddressInfoConfigService, _checkoutConfigService, _memberDisplayPriceConfigService, _appConfigService, _translateService, _configurationService, _personalMessageService, dataService, _chRef, _personalInfoConfigService, _enrollmentCommonService, _addressService, _achService, _messageService, _echeckService) {
        var _this = this;
        this._orderService = _orderService;
        this._sanitizer = _sanitizer;
        this._formbuilder = _formbuilder;
        this._http = _http;
        this._commonService = _commonService;
        this._translatePipe = _translatePipe;
        this._documentService = _documentService;
        this._currencyPipe = _currencyPipe;
        this._cacheService = _cacheService;
        this._customerService = _customerService;
        this.messageService = messageService;
        this._payvisionService = _payvisionService;
        this._titleCase = _titleCase;
        this._maskPipe = _maskPipe;
        this._enrollmentMessageService = _enrollmentMessageService;
        this._enrollService = _enrollService;
        this._shippingAddressInfoConfigService = _shippingAddressInfoConfigService;
        this._checkoutConfigService = _checkoutConfigService;
        this._memberDisplayPriceConfigService = _memberDisplayPriceConfigService;
        this._appConfigService = _appConfigService;
        this._translateService = _translateService;
        this._configurationService = _configurationService;
        this._personalMessageService = _personalMessageService;
        this.dataService = dataService;
        this._chRef = _chRef;
        this._personalInfoConfigService = _personalInfoConfigService;
        this._enrollmentCommonService = _enrollmentCommonService;
        this._addressService = _addressService;
        this._achService = _achService;
        this._messageService = _messageService;
        this._echeckService = _echeckService;
        this.fboProductsInCart = new EventEmitter();
        this.momentConstructor = moment.default || moment;
        this.memberTypeId = MemberTypeEnum.DISTRIBUTOR;
        this.orderTypeFBO = OrderType.NEW_FBO;
        this.deliveryPreference = DeliveryPreference;
        this.items = [];
        this.countries = [];
        this.states = [];
        this.shipMethodValidation = '';
        this.shippingDeliveryOptionAvailable = false;
        this.pickupDeliveryOptionAvailable = false;
        this.agreementCheckError = true;
        this.defaultCurrency = CommonConstant.Default_Currency;
        this.totalCommissionableVolume = 0;
        this.selectedIsoCountryCode = '';
        this.selectedCountryCodeTwo = '';
        this.shippingMethods = [];
        this.isSubmitted = false;
        this.products = [];
        this.taxableAmount = 0;
        this.shippingCost = 0;
        this.originalShippingCost = 0;
        this.cityList = [];
        this.shipMethod = {};
        this.showSelectedShipMethod = false;
        this.languageCode = 'en-US';
        this.disableDelivery = false;
        this.importFeeValue = 0;
        this.importFeeEnabled = false;
        this.selectEnum = SelectEnum;
        this.paymentComponentSettings = new PaymentComponentSettings();
        this.countryCode = 'USA';
        this.orderSession = {};
        this.isoCountryCode = IsoCodeThree;
        this.isNewCard = false;
        this.itemCount = 0;
        this.personalInfoFormValid = true;
        this.cityListBasedOnState = [];
        this.memberCommunicationPreferences = {
            email: true,
            phone: false
        };
        this.mailAlreadyExist = false;
        this.showMailingAddress = true;
        this.showShippingAddress = true;
        this.paymentTypeEnum = PaymentType;
        this.bankDetailsList = [];
        this.shippingAddressChanged = false;
        this.hasParticipatingCountries = false;
        this.featuredPacks = [];
        this.enrollmentKits = [];
        this.selectedFboEligibleProduct = false;
        this.isFBOEnrollmentEligible = false;
        this.accountVerified = false;
        this.memberShippingDiscountOfferEligible = false;
        this.optionCombinationValues = [];
        this.options = [];
        this.showOptions = false;
        this.optionValues = [];
        this.variableProduct = ProductType.Variable;
        this.disableBonusInfoChecks = false;
        this.displayIBANAckError = false;
        this.isOverrideMinimumLimit = false;
        this.isParticipatingCountrySameAsStore = false;
        this.taxType = TaxType;
        this.bonusPaymentOption = BonusPaymentOption;
        this.promotionModels = [];
        this.clickTimeout = [];
        this.promotionIds = [];
        this.showPudoPickupPersonAddressForm = false;
        this.pudoShippingAddressInfo = null;
        this.selectedPudoCollectionPoint = null;
        this.pudoShippingMethod = null;
        this.pudoLocationsNotFound = false;
        this.pudoCollectionPoints = null;
        this.operatingCountry = [];
        this.overrideMinimumOrderLimitPermissions = [
            Permission.OVERRIDE_MINIMUM_LIMIT
        ];
        this.overrideMinimumLimitIsEnabled = false;
        this.isBeneluxCountry = false;
        this.bonusInfoAgreements = [];
        this.isPayByLinkValid = true;
        this.languageShortCode = 'en';
        this.languageCulture = 'en-US';
        this.payByLinkLanguageShortCode = 'en';
        this.dropShipDeliveryOptionDisabled = false;
        this.hidePudoPickupLocationsButton = true;
        this.showDropShipPersonAddressForm = false;
        this.dropShipOptionAvailable = false;
        this.dropLoactionSelected = false;
        this.depsoitFeeProductsInfo = [];
        this.productAssociationInfo = [];
        this.purchaseFlowType = null;
        this.deliveryPreferenceType = this.deliveryPreference.DELIVERY;
        this.displayStatementForWavePayment = false;
        this.translateOptions = {
            translateText: "checkout.Forever Living Products {{countryName}} GmbH",
            translateParams: { countryName: '' }
        };
        this.enableNexioPaymentForPickUpCenter = environment.enableNexioPaymentForPickUpCenter;
        this.customBankTransferDetailsConfiguration = BankWireTransferConstants.BankTransferCountries;
        this.customWireTransferDetailsConfiguration = BankWireTransferConstants.WireTransferCountries;
        this.showCustomerBankTransferDetails = false;
        this.showCustomerWireTransferDetails = false;
        this.dropshipPudoShippingMethod = null;
        this.isPickUpOptionExist = false;
        this.isDropShipOptionExist = false;
        this.scandinavianCountry = false;
        this.showDistance = false;
        this.setPaymentMethod = function (value) {
            _this.orderFormGroup.controls['paymentSelector'].setValue(value.toString());
            _this.onPaymentMethodChnage();
        };
        /**
        * @param  {any} data
        * @returns SafeHtml
        */
        this.autocompleListFormatter = function (data) {
            var html = "<span>" + data.itemNumber + " - " + _this._titleCase.transform(data.displayName ? data.displayName : data.name) + "</span>";
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        /**
         * Auto Complete Product Search
         */
        this.observableSource = function (keyword, fullSearch) {
            var fpc5PercentEnabled = false;
            if (_this.hasNewFBOOrderPermissions && _this.storeInfo) {
                if (keyword && keyword.length > 1) {
                    if (keyword.indexOf('#') === 0) {
                        keyword = keyword.replace(/#/, '');
                    }
                    if (_this.appConfig && _this.appConfig.fpc5PercentEnabled) {
                        fpc5PercentEnabled = true;
                    }
                    var _itemNumberURL = environment.productsUrl + '/stores/' + _this.storeInfo.id + '/customerservice/products' +
                        '?languageCode=' + _this.storeDefaultLanguage + '&memberTitleId=' + MemberLevel.PREFERREDCUSTOMER +
                        '&countryCode=' + _this.selectedIsoCountryCode
                        + '&pageSize=10&pageNumber=1&wholesaleQualified=false&productWildSearch=' + keyword.trim() +
                        '&source=' + ProductSource.ADMINISTRATION + '&optin=false&taxInclusive=' + _this.storeInfo.taxInclusive;
                    if (fullSearch) {
                        _itemNumberURL += '&searchType=FULL';
                    }
                    return _this._http.get(decodeURIComponent(encodeURIComponent(_itemNumberURL))).map(function (res) {
                        var results = res.json();
                        if (results && results.length > 0) {
                            return results;
                        }
                        else {
                            return [];
                        }
                    });
                }
                else {
                    return Observable.of([]);
                }
            }
            else {
                var notification = void 0;
                if (!_this.storeInfo && !_this.countryCode && !_this.pickupDeliveryOptionAvailable && !_this.shippingDeliveryOptionAvailable) {
                    notification = _this._translatePipe.get('Shipping options not available');
                }
                else if (!_this.storeInfo && !_this.countryCode &&
                    (_this.pickupDeliveryOptionAvailable || _this.shippingDeliveryOptionAvailable)) {
                    notification = _this._translatePipe.get('order.Country Details are Mandatory');
                }
                if (notification) {
                    _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                }
            }
        };
    }
    OrderCreateFBOComponent.prototype.ngOnInit = function () {
        this.dropShipOptionAvailable = false;
        this.showDropShipPersonAddressForm = false;
        this.dropShipDeliveryOptionDisabled = false;
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.orderSession = sessionStorage.getItem(CacheKey.OrderInfo) ? JSON.parse(sessionStorage.getItem(CacheKey.OrderInfo)) : null;
        this.orderSession != null && this.orderSession.isOverrideMinimumLimit === true ? this.isOverrideMinimumLimit = true : this.isOverrideMinimumLimit = false;
        this.showDistance = environment.restrictGoogleMapNavigation;
        this.getFBOPermissions();
        this.buildForm();
        this.buildPayByLinkForm();
        this.getOperatingCountries();
        this.getCountries();
        this.getStates();
        this.getGovtIdentificationTypes();
        sessionStorage.removeItem(CacheKey.OrderInfo);
        this.createOrderInfo = this._cacheService.get('CreateOrderInfo');
        if (this.orderSession) {
            this.pudoAddress = this.orderSession.pudoaddress ? this.orderSession.pudoaddress : this.pudoAddress;
            this.languageCulture = this.orderSession.languageCulture;
        }
        this._cacheService.remove('CreateOrderInfo');
        if (this.createOrderInfo) {
            this.orderFromLookup = true;
        }
        if (this.orderSession) {
            this.memberCartSessionGuid = this.orderSession.memberCartSessionGuid;
            this.minMaxPriceValidation = this.orderSession.minMaxPriceValidation;
        }
        this.isOrderSessionInfo = this.orderSession ? true : false;
        this.bonusInfoBankCode = this.orderSession && this.orderSession.bonusInformation && this.orderSession.bonusInformation.bankcode ? this.orderSession.bonusInformation.bankcode : null;
        this.orderFromLookup || this.isOrderSessionInfo
            ? (document.getElementById('country') ? document.getElementById('country').focus() : null) : null;
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        this.sessionGuid = this._cacheService.getSessionValue(CacheKey.SessionGuid) || this._enrollmentCommonService.getSessionGuid();
        this.accountTypes = [AccountType.Checking, AccountType.Savings];
        this.setPUDOSuggestedAddress();
    };
    /**
     * To Show popup on participating Country Change
     */
    OrderCreateFBOComponent.prototype.showWarningPopup = function (event) {
        var selectedAgreements = this.agreementDocuments.filter(function (agreement) { return agreement.isSelected; });
        if (this.participatingCountry && (this.mailingAddress || this.shippingAddressInfo || this.address || this.personalInformation
            || this.sponsorInformation || (this.products && this.products.length)) || selectedAgreements.length > 0) {
            event.preventDefault ? event.preventDefault() : (event.returnValue = false);
            this.participatingCountryChangeConfirmation.open();
        }
        else {
            this.onSelectParticipatingCountry();
        }
    };
    /**
     * To close popup on participating Country Change
     */
    OrderCreateFBOComponent.prototype.closePopUp = function () {
        if (this.associatedCountry) {
            this.orderFormGroup.controls['participatingCountry'].setValue(this.associatedCountry);
        }
        else {
            this.orderFormGroup.controls['participatingCountry'].setValue('');
        }
        this.participatingCountryChangeConfirmation.close();
    };
    OrderCreateFBOComponent.prototype.buildReferenceNumberForm = function () {
        this.paymentReferenceNumber = this._formbuilder.group({
            referenceNumber: ['']
        });
    };
    OrderCreateFBOComponent.prototype.paymentReferenceNumberFormValidations = function () {
        var paymentSelectorValue = +this.orderFormGroup.controls['paymentSelector'].value;
        this.paymentReferenceNumber.get('referenceNumber').clearValidators();
        if (paymentSelectorValue === this.paymentTypeEnum.Orange_Money) {
            this.paymentReferenceNumber.get('referenceNumber').setValidators([Validators.required, Validators.maxLength(18), Validators.pattern('[O,o]{1}[M,m]{1}[ ]{0,1}[0-9]{1,}')]);
        }
        else if (paymentSelectorValue === this.paymentTypeEnum.Money_order) {
            this.paymentReferenceNumber.get('referenceNumber').setValidators([Validators.required, Validators.maxLength(18), Validators.pattern('[W,w]{1}[A,a]{1}[V,v]{1}[E,e]{1}[ ]{0,1}[0-9]{1,}')]);
        }
    };
    /**
 * On Country Select
 */
    OrderCreateFBOComponent.prototype.onSelectParticipatingCountry = function () {
        this.showAddressForm = false;
        this.displayMailingAddressForm = false;
        var selectedCountryID = this.orderFormGroup && this.orderFormGroup.value ? this.orderFormGroup.value.participatingCountry : null;
        this.associatedCountry = selectedCountryID;
        if (selectedCountryID) {
            this.orderFormGroup.controls['participatingCountry'].disable();
            var countryObj = this.participatingCountries.filter(function (x) { return x.countryId === +selectedCountryID; })[0];
            if (countryObj) {
                this.participatingCountry = countryObj;
                this.constructSchemaFormUrl(countryObj.isocodeThree);
                this.mailingAddress = null;
                this.liveFormAddress = null;
                this._enrollmentMessageService.setParticipatingCountryInfo(countryObj.countryId);
                this.selectedCountry(true);
                if (+this.orderFormGroup.value.countryId === countryObj.countryId) {
                    this.isParticipatingCountrySameAsStore = true;
                }
                else {
                    this.isParticipatingCountrySameAsStore = false;
                }
            }
        }
        else {
            this.participatingCountry = null;
        }
    };
    /**
         * On Country Select
         */
    OrderCreateFBOComponent.prototype.getBeneluxCountry = function (homeCountry) {
        var beneluxCountries = [];
        Object.keys(BeneluxCountries).forEach(function (key) {
            beneluxCountries.push(BeneluxCountries[key]);
        });
        if (beneluxCountries && beneluxCountries.length > 0) {
            if (homeCountry) {
                this.isBeneluxCountry = beneluxCountries.includes(homeCountry) ? true : false;
            }
        }
        return this.isBeneluxCountry;
    };
    OrderCreateFBOComponent.prototype.selectedCountry = function (fromParticipatingCountry) {
        this.showAddressForm = false;
        this.displayMailingAddressForm = false;
        this.isDropShipOptionExist = false;
        this.isPickUpOptionExist = false;
        var selectedCountryID = this.orderFormGroup && this.orderFormGroup.value ? this.orderFormGroup.value.countryId : null;
        if (selectedCountryID) {
            this.orderFormGroup.controls['countryId'].disable();
            var countryObj = this.countries.filter(function (x) { return x.countryId === +selectedCountryID; })[0];
            if (countryObj) {
                this.selectedIsoCountryCode = countryObj.isocodeThree;
                this.isBeneluxCountry = this.getBeneluxCountry(this.selectedIsoCountryCode);
                this.checkoutConfig = this._checkoutConfigService.getSettings(countryObj.isocodeThree, this.memberInfo);
                if (this.checkoutConfig && this.checkoutConfig.displayCityBasedOnState) {
                    this._cacheService.set(CacheKey.COUNTRY_CODE, this.selectedIsoCountryCode);
                    this._cacheService.set(CacheKey.COUNTRY_ID, countryObj.countryId);
                    this.getCitiesByStates();
                }
                else {
                    this._cacheService.remove(CacheKey.COUNTRY_CODE);
                    this._cacheService.remove(CacheKey.COUNTRY_ID);
                }
                this.translateOptions.translateParams.countryName = countryObj.name;
                // this.isWorldPayEnabledCountry = this._configurationService.checkWorldPayEnabledCountry(countryObj.isocodeThree);
                // this.isWorldpayPayment = this.checkoutConfig.isWorldpayPayment;
                // this.isAdyenPayment = this.checkoutConfig.isAdyenPayment;
                // this.isNIPayment = this.checkoutConfig.isNIPayment;
                // this.isNexioPayment = this.checkoutConfig.isNexioPayment;
                this.countryCode = countryObj.isocodeThree;
                this.documentsRequest = null;
                this.orderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
                this.selectedCountryCodeTwo = countryObj.isocodeTwo;
                this.paymentComponentSettings.isoCountryCode = countryObj.isocodeThree;
                this.paymentComponentSettings.isoTwoletterCountryCode = countryObj.isocodeTwo;
                this.paymentComponentSettings.orderTypeId = this._enrollmentCommonService.getOrderTypeId(this.orderFormGroup.controls['orderType'].value);
                this.storeInfo = null;
                this.storeId = 0;
                this.getStoreInfo(countryObj.isocodeThree);
                this.checkoutConfig = this._checkoutConfigService.getSettings(countryObj.isocodeThree, this.memberInfo);
                this.skipAddressVerification = this.checkoutConfig.skipAddressVerification;
                this.clearAllTheForms(false);
                this.orderSession != null && this.orderSession.isOverrideMinimumLimit === true ? this.isOverrideMinimumLimit = true : this.isOverrideMinimumLimit = false;
                this.address = null;
                if (!fromParticipatingCountry) {
                    this.participatingCountry = null;
                }
            }
        }
    };
    /**
     * Get Store Info
     * @param countryCode
     */
    OrderCreateFBOComponent.prototype.getStoreInfo = function (countryCode) {
        var _this = this;
        if (countryCode) {
            this._orderService.getStoreInfo(countryCode).subscribe(function (response) {
                if (response) {
                    var storeInfo = response;
                    _this.getMemberDiscountPercentages(storeInfo);
                    _this.storeId = response.id;
                    _this.countryCode = countryCode;
                    _this.countryTaxInclusive = storeInfo.taxInclusive;
                    _this.distributorMaxCC = storeInfo.distributorMaxCC;
                    _this.shippingAddressInfoConfig = _this._shippingAddressInfoConfigService.getSettings(countryCode);
                    _this.appConfig = _this._appConfigService.getSettings(countryCode, null);
                    if (_this.appConfig.enablePaymentReferenceNumber) {
                        _this.buildReferenceNumberForm();
                    }
                    if (_this.appConfig.isWireTransferLabelWithoutGmbh) {
                        _this.translateOptions.translateText = "checkout.Forever Living Products {{countryName}}";
                    }
                    if (response.languages && response.languages.length > 0) {
                        _this.storeDefaultLanguage = response.languages.find(function (languageCulture) { return languageCulture.default; }).cultureName;
                        _this.languageCulture = _this.storeDefaultLanguage;
                        _this.payByLinkLanguageShortCode = response.languages.find(function (languageCulture) { return languageCulture.default; }).languageCode;
                    }
                    else {
                        _this.storeDefaultLanguage = _this.languageCode;
                        _this.languageCulture = _this.languageCulture;
                        _this.payByLinkLanguageShortCode = _this.payByLinkLanguageShortCode;
                    }
                    if (_this.customBankTransferDetailsConfiguration && _this.customWireTransferDetailsConfiguration && _this.selectedIsoCountryCode) {
                        var language = _this._cacheService.get(CacheKey.Language);
                        _this.showCustomerBankTransferDetails = _this.customBankTransferDetailsConfiguration.includes(_this.selectedIsoCountryCode) && language.toLowerCase() == _this.storeDefaultLanguage.toLowerCase();
                        _this.showCustomerWireTransferDetails = _this.customWireTransferDetailsConfiguration.includes(_this.selectedIsoCountryCode) && language.toLowerCase() == _this.storeDefaultLanguage.toLowerCase();
                    }
                    _this.getParticipatingCountries(_this.storeId);
                    // this.getStorePromotions();
                    _this.loadFBOFlowSettings(response);
                    if (!_this.isOrderSessionInfo) {
                        _this.getFboDocuments();
                        if (_this.isBeneluxCountry) {
                            _this.fetchTermsConditionDocument();
                        }
                    }
                    _this.getFeaturedPacks(response);
                    _this.getEnrollmentKits(response);
                    if (_this.memberInfo) {
                        _this.achToken = '';
                        _this.getSavedAchs();
                    }
                    _this.phoneNumberFormat = _this._commonService.getPhoneNumberFormatByCountryCode(_this.countryCode);
                }
            }, function (error) {
                var notification = _this._translatePipe.get('order.Unable to fetch Store Details');
                _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            });
        }
    };
    /**
 * @description
 * @private
 * @memberof OrderCreateFBOComponent
 */
    OrderCreateFBOComponent.prototype.getParticipatingCountries = function (id) {
        var _this = this;
        this.hasParticipatingCountries = false;
        this.orderFormGroup.controls['participatingCountry'].setValue('');
        this.associatedCountries = [];
        this._customerService.getStoreParticipatingCountries(id)
            .subscribe(function (response) {
            if (response && response.length > 0) {
                _this.participatingCountries = response;
                if (_this.appConfig && _this.appConfig.displayParticipatingCountry) {
                    _this.associatedCountries = response.filter(function (country) { return country.titanPlatformEnabled
                        && country.enrollmentEnabled && country.legacyEnabled; });
                    if (_this.associatedCountries && _this.associatedCountries.length > 0) {
                        _this.hasParticipatingCountries = true;
                        if (_this.participatingCountry) {
                            _this.orderFormGroup.controls['participatingCountry'].setValue(_this.participatingCountry.countryId);
                        }
                        else {
                            var countryObj = _this.associatedCountries.find(function (x) { return x.countryId === +_this.orderFormGroup.value.countryId; });
                            if (countryObj) {
                                _this.participatingCountry = countryObj;
                                _this.associatedCountry = _this.participatingCountry.countryId;
                                _this.isParticipatingCountrySameAsStore = true;
                                _this.orderFormGroup.controls['participatingCountry'].setValue(_this.participatingCountry.countryId);
                            }
                            else {
                                _this.orderFormGroup.controls['participatingCountry'].setValue('');
                            }
                        }
                    }
                }
            }
        });
    };
    /**
        * Clear All the Forms
        * @param clearCountry
        * @param clearShippingAddress
        */
    OrderCreateFBOComponent.prototype.clearAllTheForms = function (clearCountry, clearShippingAddress, clearMember) {
        if (clearCountry === void 0) { clearCountry = true; }
        if (clearShippingAddress === void 0) { clearShippingAddress = true; }
        if (clearMember === void 0) { clearMember = false; }
        this.showSelectedShipMethod = false;
        this.shippingAddressInfo = null;
        this.selectedPayvisionCardInfo = null;
        this.shipMethod = null;
        this.bankDetailsList = [];
        this.shippingCost = 0;
        this.shippingTax = 0;
        this.importFeeValue = 0;
        this.taxableAmount = 0;
        this.retailDeliveryFee = 0;
        this.orderTaxResponse = null;
        this.products = [];
        this.totalCommissionableVolume = 0;
        this.itemCount = 0;
        this.verifiedShippingAddressId = 0;
        this.agreementDocuments = [];
        this.personalInformation = null;
        this.mailingAddress = null;
        this.liveFormAddress = null;
        this.address = null;
        this.sponsorInformation = null;
        this.returningFBOUser = null;
        this.isSubmitted = false;
        this.shippingAddressInfoConfig = null;
        this.orderFormGroup.get('items').reset();
        var arr = this.orderFormGroup.controls.items;
        arr.controls = [];
        this.orderFormGroup.controls['isContactSponsor'].setValue(null);
        this.memberCommunicationPreferences = {
            email: true,
            phone: false
        };
        this.orderFormGroup.patchValue({
            shippingCostSelector: this.selectEnum.firstOption.toString(),
            shippingCostPercentage: 0,
            originalShippingCost: 0,
            paymentSelector: this.selectEnum.firstOption.toString(),
            paymentInstrumentId: '',
            isShippingDiscountApplied: false,
            originalShippingTax: 0
        });
        this.orderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
        if (clearCountry) {
            this.orderFormGroup.controls['countryId'].setValidators([Validators.required]);
            this.orderFormGroup.controls['countryId'].updateValueAndValidity();
            var countryId = this.stores.find(function (store) { return store.isocodeThree.toUpperCase() === IsoCodeThree.USA; }).id || this.stores[0].id;
            this.orderFormGroup.controls['countryId'].setValue(countryId);
        }
        if (clearMember) {
            this.memberInfo = null;
        }
        if (clearShippingAddress) {
            this.orderFormGroup.controls['shippingAddressId'].setValidators([]);
            this.orderFormGroup.controls['shippingAddressId'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingAddressId'].setValue('');
            this.shippingMethods = [];
        }
        this.orderFormGroup.controls['shipMethodId'].setValidators([Validators.required]);
        this.orderFormGroup.controls['shipMethodId'].updateValueAndValidity();
        this.orderFormGroup.controls['shipMethodId'].setValue('');
        this.orderFormGroup.controls['backDateOrder'].setValue(false);
        this.orderFormGroup.controls['itemSearch'].setValue('');
        this.orderFormGroup.markAsUntouched();
        this.updateTotalsAndShipMethod();
        this.orderTaxResponse = null;
        this.signUpEmail = null;
        this.isFBOEnrollmentEligible = false;
        this.fboEligibleProducts = null;
        this.productOptions = null;
        this.orderFormGroup.controls['fboEligibleProducts'].setValue('');
        this.orderFormGroup.controls['productOptions'].setValue('');
        this.featuredPacks = [];
        this.enrollmentKits = [];
        this.associatedCountry = 0;
        this.optionValues = [];
        this.showOptions = false;
        this.selectedPudoCollectionPoint = null;
        this.pudoShippingMethod = null;
        this.pudoLocationsNotFound = false;
        this.pudoCollectionPoints = null;
        this.pudoShippingAddressInfo = null;
        this.showPudoPickupPersonAddressForm = false;
        this.showDropShipPersonAddressForm = false;
        this.pudoAddress = null;
        this.savedPudoAddressId = null;
        this.pudoAddressSubmitted = false;
        this.buildPayByLinkForm();
        this.buildPudoLocationSearchForm();
        this.loadingPudoPickupLocations = false;
        this.displayPudoAddress = false;
        this.isOverrideMinimumLimit = false;
        this.productAssociationInfo = [];
        this.depsoitFeeProductsInfo = [];
    };
    OrderCreateFBOComponent.prototype.getCitiesByStates = function () {
        var _this = this;
        var countryId = this._cacheService.get(CacheKey.COUNTRY_ID);
        this._addressService.getCitiesList(countryId).subscribe(function (response) {
            console.log(response);
            if (response) {
                _this.cityList = response;
                _this._cacheService.set(CacheKey.Cities, response);
            }
        });
    };
    /**
 * @description
 * @private
 * @memberof OrderCreateFBOComponent
 */
    OrderCreateFBOComponent.prototype.getMemberDiscountPercentages = function (storeInfo) {
        var _this = this;
        if (this.taxCalculationStatus) {
            this.updateTotalsAndShipMethod();
        }
        this._commonService.getDiscountPercentages(false, false, this._enrollmentCommonService.getMemberTitleId(this.orderFormGroup.controls['orderType'].value), storeInfo.id).
            subscribe(function (response) {
            _this.memberDiscountPercentage = response;
        });
    };
    OrderCreateFBOComponent.prototype.getMemberTitleId = function () {
        return this._enrollmentCommonService.getMemberTitleId(this.orderFormGroup.controls['orderType'].value);
    };
    OrderCreateFBOComponent.prototype.getPudoPickupPersonAddress = function () {
        var address = null;
        if (!this.pudoShippingAddressInfo) {
            if (this.shippingAddressInfo && this.shippingAddressInfo.countryCode) {
                if ((this.storeInfo.homeIsocodeThree.toLowerCase() == this.shippingAddressInfo.countryCode.toLowerCase())) {
                    address = this.shippingAddressInfo;
                }
            }
            if (!address) {
                var mailingAddress = this.memberInfo && this.memberInfo.address ? this.memberInfo.address : null;
                if (mailingAddress && mailingAddress.countryCode) {
                    if ((this.storeInfo.homeIsocodeThree.toLowerCase() == mailingAddress.countryCode.toLowerCase())) {
                        address = mailingAddress;
                        address.id = null;
                        address.addressTypeId = AddressType.SHIPPING;
                        if (!address.phone) {
                            address.phone = this.userInfo.phone;
                            address.phoneNumber = this.userInfo.phone;
                        }
                        if (!address.email) {
                            address.phone = this.userInfo.email;
                        }
                    }
                }
            }
            this.pudoShippingAddressInfo = address;
        }
        else {
            address = this.pudoShippingAddressInfo;
        }
        this.pudoAddress = this.pudoShippingAddressInfo;
        return address;
    };
    OrderCreateFBOComponent.prototype.preparePudoLocationRequest = function () {
        var _this = this;
        if (!this.countries) {
            this.countries = this._cacheService.get(CacheKey.COUNTRIES);
        }
        var request = null;
        if (this.pudoLocationSearchForm) {
            var pudoLocationSearchFormData = this.pudoLocationSearchForm.value;
            if (this.pudoAddress) {
                this.pudoAddress.zip = this.pudoAddress.zip ? this.pudoAddress.zip : this.pudoAddress.postalCode;
            }
            if (pudoLocationSearchFormData && pudoLocationSearchFormData.zipCode ? true : this.pudoAddress && this.pudoAddress.zip) {
                if (!pudoLocationSearchFormData.zipCode) {
                    this.buildPudoLocationSearchForm(this.pudoAddress.zip, this.pudoAddress.city, this.pudoAddress.addressLine1);
                }
                pudoLocationSearchFormData = this.pudoLocationSearchForm.value;
                if (this.countries && this.storeInfo.homeIsocodeThree && pudoLocationSearchFormData.zipCode) {
                    var country = this.countries.find(function (x) { return x.isocodeThree.toUpperCase() === _this.storeInfo.homeIsocodeThree.toUpperCase(); });
                    request = {
                        countryIsoCode: country.isocodeTwo || '',
                        postalCode: pudoLocationSearchFormData.zipCode || '',
                        storeID: this.storeInfo && this.storeInfo.id || null,
                        // as per centiro api we need to send  . (period) if there is no city
                        city: pudoLocationSearchFormData.city || '.',
                        streetAddress: pudoLocationSearchFormData.addressLine1 || '',
                        languageCode: "en",
                    };
                }
            }
        }
        return request;
    };
    OrderCreateFBOComponent.prototype.getPudoLocationMap = function (geoPoint) {
        if (geoPoint && geoPoint.latitude && geoPoint.longitude) {
            if (environment.restrictGoogleMapNavigation) {
                return ApiUrlConstants.googleMapsUrl + geoPoint.latitude +
                    ',' + geoPoint.longitude;
            }
            else {
                return null;
            }
        }
        return null;
    };
    OrderCreateFBOComponent.prototype.loadPUDOLocations = function () {
        if (!this.skipAddressVerification) {
            this.messageService.setSubmitPudoPickupPersonAddress(true);
        }
        else {
            if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                this.messageService.setSubmitPudoDropShipPersonAddress(true);
            }
            this.getPudoLocations();
        }
    };
    OrderCreateFBOComponent.prototype.getPudoLocations = function () {
        var _this = this;
        var pudoLocationRequest = this.preparePudoLocationRequest();
        if (pudoLocationRequest) {
            this.pudoLocationsNotFound = false;
            this.pudoCollectionPoints = null;
            this.selectedPudoCollectionPoint = null;
            this.loadingPudoPickupLocations = true;
            this._orderService.getPudoLocations(pudoLocationRequest).subscribe(function (res) {
                _this.loadingPudoPickupLocations = false;
                if (res && res.collectionPoints && res.collectionPoints.length) {
                    _this.pudoLocationsNotFound = false;
                    res.collectionPoints.sort(function (x, y) { return x.distance - y.distance; });
                    _this.pudoCollectionPoints = res.collectionPoints;
                    _this.calculateOrderTax();
                    _this.prepareBusinessHours();
                    if (_this.pudoLocationSearchForm && _this.pudoLocationSearchForm.value && _this.pudoLocationSearchForm.value.externalId) {
                        _this.selectedPudoCollectionPoint = _this.pudoCollectionPoints.find(function (x) { return x.externalId == _this.pudoLocationSearchForm.value.externalId; });
                    }
                }
                else {
                    _this.pudoLocationsNotFound = true;
                }
            }, function (error) {
                _this.loadingPudoPickupLocations = false;
                _this.pudoLocationsNotFound = true;
            });
        }
    };
    OrderCreateFBOComponent.prototype.prepareBusinessHours = function () {
        if (this.pudoCollectionPoints && this.pudoCollectionPoints.length) {
            this.pudoCollectionPoints.forEach(function (collectionPoint) {
                if (collectionPoint && collectionPoint.openingHours) {
                    var businessHours_1 = [];
                    collectionPoint.openingHours.forEach(function (opening) {
                        if (opening && opening.hours) {
                            var hours_1 = [];
                            opening.hours.forEach(function (hour) {
                                hours_1.push({ start: hour.opens, end: hour.closes });
                            });
                            var businessHour = {
                                available: true,
                                day: opening.dayText,
                                hours: hours_1
                            };
                            businessHours_1.push(businessHour);
                        }
                    });
                    collectionPoint.businessHours = businessHours_1;
                }
            });
        }
    };
    OrderCreateFBOComponent.prototype.getPudoShippingMethods = function (shippingOptions, shippingMethods, mappingRequired) {
        var _this = this;
        if (mappingRequired === void 0) { mappingRequired = true; }
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
            if ((shippingOptions && shippingOptions.toAddress && shippingOptions.toAddress.countryCode && this.storeInfo && this.storeInfo.homeIsocodeThree)) {
                if (this.storeInfo.homeIsocodeThree.toUpperCase() != shippingOptions.toAddress.countryCode.toUpperCase()) {
                    shippingOptions.toAddress = this._enrollmentCommonService.getWarehouseAddress(this.storeInfo, this.selectedIsoCountryCode);
                }
            }
            else {
                shippingOptions.toAddress = this._enrollmentCommonService.getWarehouseAddress(this.storeInfo, this.selectedIsoCountryCode);
            }
            shippingOptions.shippingTypeId = ShippingType.DELIVERY;
            this._orderService.getShipmentService(shippingOptions).subscribe(function (response) {
                if (response && response.shippingMethods && response.shippingMethods.length > 0) {
                    _this.pudoShippingMethod = response.shippingMethods.find(function (x) { return x.pudoEnabled; });
                    if (mappingRequired) {
                        if (_this.pudoShippingMethod) {
                            _this.pudoShippingMethod.pickUpLocation = shippingMethods[0].pickUpLocation;
                        }
                        _this.getPudoLocations();
                    }
                }
            }, function (error) {
            });
        }
    };
    OrderCreateFBOComponent.prototype.prepareShippingOptionsRequest = function () {
        var shippingOptions = {
            productModels: this._enrollmentCommonService.getProductModels(this.products),
            orderSourceId: OrderSourceType.Web,
            languageCode: this.languageCode,
            orderTypeId: ShippingOrderType.Personal,
            fromAddress: this._enrollmentCommonService.getWarehouseAddress(this.storeInfo, this.selectedIsoCountryCode),
            toAddress: this.orderFormGroup.value.deliveryPreference ===
                this.deliveryPreference.DELIVERY ? this._enrollmentCommonService.getShippingAddress(this.shippingAddressInfo, this.pudoShippingAddressInfo, this.selectedCountryCodeTwo, this.orderFormGroup.value, this.countries, this.storeInfo.foreverDirectEnabled) : (this.shippingAddressInfoConfig.dropShipLocationsEnabled
                && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) ? this.getPudoDropShipPersonAddress() : this.gtePudoPickupPersonAddress(),
            storeId: this.storeInfo.id,
            requestID: 2,
            memberTypeId: ShippingMemberType.DISTRIBUTOR,
            priceTypeId: this._enrollmentCommonService.getPriceTypeId(),
            memberLevelId: this.getMemberTitleId(),
            orderSubTotal: this.calculateItemsSubTotal(this.storeInfo),
            orderTaxInclusiveSubTotal: this._commonService.getProductsTotalTax(this.products, this.calculateItemsSubTotal(this.storeInfo), this.storeInfo),
            orderCaseCredits: this.totalCommissionableVolume,
            purchaseFlowId: PurchaseFlowType.WholeSale,
            shippingTypeId: this.orderFormGroup.value.deliveryPreference ===
                this.deliveryPreference.DELIVERY ? ShippingType.DELIVERY : (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP ? ShippingType.DROPSHIP : ShippingType.PICKUP),
            storeHomeCountryCode: this.selectedIsoCountryCode,
            initialOrder: true,
            vatRegistered: false
        };
        //order source only for AUT && DEU Country
        if (this.shippingAddressInfoConfig.sendSourceToShippingOptions) {
            shippingOptions.source = Source.CSP;
        }
        return shippingOptions;
    };
    OrderCreateFBOComponent.prototype.gtePudoPickupPersonAddress = function () {
        var address = null;
        if (!this.pudoShippingAddressInfo) {
            if (this.shippingAddressInfo && this.shippingAddressInfo.countryCode) {
                if ((this.storeInfo.homeIsocodeThree.toLowerCase() == this.shippingAddressInfo.countryCode.toLowerCase())) {
                    address = this.shippingAddressInfo;
                }
            }
            if (!address) {
                var mailingAddress = this.memberInfo && this.memberInfo.address ? this.memberInfo.address : null;
                if (mailingAddress && mailingAddress.countryCode) {
                    if ((this.storeInfo.homeIsocodeThree.toLowerCase() == mailingAddress.countryCode.toLowerCase())) {
                        address = mailingAddress;
                        address.id = null;
                        address.addressTypeId = AddressType.SHIPPING;
                        if (!address.phone) {
                            address.phone = this.userInfo.phone;
                            address.phoneNumber = this.userInfo.phone;
                        }
                        if (!address.email) {
                            address.phone = this.userInfo.email;
                        }
                    }
                }
            }
            this.pudoShippingAddressInfo = address;
        }
        else {
            address = this.pudoShippingAddressInfo;
        }
        this.pudoAddress = this.pudoShippingAddressInfo;
        return address;
    };
    /**
     * Decrement the item Quantity
     * @returns void
     */
    OrderCreateFBOComponent.prototype.decrementQuantity = function (index) {
        var _this = this;
        this.taxCalculationStatus = true;
        var items = this.orderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo) {
            if (items.controls[index].controls['quantity'].value > 1) {
                items.controls[index].controls['quantity'].setValue(+items.controls[index].controls['quantity'].value - 1);
                items.controls[index].controls['quantity'].updateValueAndValidity();
                items.controls[index].controls['disableIncrement'].setValue(false);
            }
            if (items.controls[index].controls['quantity'].value === 1) {
                items.controls[index].controls['disableIncrement'].setValue(false);
            }
            clearTimeout(this.clickTimeout[items.controls[index].controls['productId'].value]);
            this.setFocusbyID('quantity-' + (index));
            if (this.productAssociationInfo) {
                var productid_1 = items.value[index].productId;
                var associateProduct_1 = this.productAssociationInfo.find(function (x) { return x.productId === productid_1; });
                var product = items.controls[index].controls['productItem'].value;
                if (associateProduct_1) {
                    var sameProductIndex = items.controls.findIndex(function (item) { return item.controls['productId'].value === associateProduct_1.depositFeeProductId; });
                    if (sameProductIndex >= 0) {
                        this.decrementQuantity(sameProductIndex);
                    }
                }
            }
            this.updateTotalsAndShipMethod(false);
            this.clickTimeout[items.controls[index].controls['productId'].value] =
                setTimeout(function () {
                    //New logic to bind promtoion product from promotion engine
                    var freeProductsInfo = _this.validatePromotionCriteria(items);
                    var productIds = _this._commonService.updateCartAfterPromotion(freeProductsInfo, items, _this.orderFormGroup, _this.promotionIds);
                    _this._commonService.removeNonPromotionProducts(freeProductsInfo, items);
                    if (productIds && productIds.length) {
                        _this.addPromotionEngineProducts(productIds, freeProductsInfo);
                    }
                    else {
                        _this.updateTotalsAndShipMethod();
                    }
                }, 500);
        }
    };
    OrderCreateFBOComponent.prototype.allowOnlyNumbers = function (event) {
        this.isFocused = false;
        if (event.keyCode !== 8) {
            var value = (event.key ? event.key : '');
            var pattern = /^[0-9]*$/;
            if (!new RegExp(pattern).test(value)) {
                event.preventDefault();
            }
        }
    };
    /**
    * Increment the item Quantity
    * @returns void
    */
    OrderCreateFBOComponent.prototype.incrementQuantity = function (index) {
        var _this = this;
        this.taxCalculationStatus = true;
        var items = this.orderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo) {
            items.controls[index].controls['quantity'].setValue(+items.controls[index].controls['quantity'].value + 1);
            var product_1 = items.controls[index].controls['productItem'].value;
            if ((items.controls[index].controls['quantity'].value > product_1.stockQuantity && product_1.manageStock) && !(product_1.stockAvailable && !product_1.manageStock)) {
                items.controls[index].controls['quantity'].setValue(product_1.stockQuantity);
                var cartStockErrors = this._translatePipe.get('stockError.No Stock Available');
                this._commonService.createNotification('', cartStockErrors.value, NotificationType.ERROR);
                items.controls[index].controls['disableIncrement'].setValue(true);
            }
            else {
                items.controls[index].controls['disableIncrement'].setValue(false);
            }
            var quantityFieldLength = items.controls[index].controls['quantity'].value ? items.controls[index].controls['quantity'].value.toString().length : 0;
            if (quantityFieldLength > 3) {
                items.controls[index].controls['disableIncrement'].setValue(true);
                items.controls[index].controls['quantity'].setValue(+items.controls[index].controls['quantity'].value - 1);
            }
            clearTimeout(this.clickTimeout[items.controls[index].controls['productId'].value]);
            items.controls[index].controls['disableDecrement'].setValue(false);
            items.controls[index].controls['quantity'].updateValueAndValidity();
            this.setFocusbyID('quantity-' + (index));
            if (this.productAssociationInfo) {
                var productid_2 = items.value[index].productId;
                var associateProduct_2 = this.productAssociationInfo.find(function (x) { return x.productId === productid_2; });
                if (associateProduct_2) {
                    var sameProductIndex = items.controls.findIndex(function (item) { return item.controls['productId'].value === associateProduct_2.depositFeeProductId; });
                    if (sameProductIndex >= 0) {
                        this.incrementQuantity(sameProductIndex);
                    }
                }
            }
            this.updateTotalsAndShipMethod(false);
            this.clickTimeout[items.controls[index].controls['productId'].value] =
                setTimeout(function () {
                    //New logic to bind promtoion product from promotion engine
                    var freeProductsInfo = _this.validatePromotionCriteria(product_1);
                    var productIds = _this._commonService.updateCartAfterPromotion(freeProductsInfo, items, _this.orderFormGroup, _this.promotionIds);
                    if (productIds && productIds.length) {
                        _this.addPromotionEngineProducts(productIds, freeProductsInfo);
                    }
                    else {
                        _this.updateTotalsAndShipMethod();
                    }
                }, 500);
        }
    };
    OrderCreateFBOComponent.prototype.quantityChange = function (event, index) {
        var items = this.orderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo) {
            this.isFocused = false;
            items.controls[index].controls['quantity'].setValue(+items.controls[index].controls['quantity'].value);
            items.controls[index].controls['quantity'].updateValueAndValidity();
        }
    };
    /**
    * @param  {number} index
    * @returns void
    */
    OrderCreateFBOComponent.prototype.updateQuantity = function (event, index) {
        var _this = this;
        if (!this.isRestrictionPopupOpened && !this.addNewCardClicked) {
            var items_1 = this.orderFormGroup.get('items');
            var product = items_1.controls[index].controls['productItem'].value;
            if (items_1 && items_1.length > 0 && this.storeInfo) {
                var quantity = event.target ? +event.target.value : event;
                if (!items_1.controls[index].controls['quantity'].dirty && event.target) {
                    return;
                }
                items_1.controls[index].controls['quantity'].markAsPristine();
                var previousProductQty = product.quantity;
                if (items_1.controls[index].controls['quantity'].value > 1 ||
                    (quantity && parseInt(quantity, 10))) {
                    if (product && quantity > product.stockQuantity && product.manageStock) {
                        items_1.controls[index].controls['quantity'].setValue(product.stockQuantity);
                        var cartStockErrors = this._translatePipe.get('stockError.No Stock Available');
                        this._commonService.createNotification('', cartStockErrors.value, NotificationType.ERROR);
                        items_1.controls[index].controls['disableIncrement'].setValue(true);
                    }
                    else {
                        items_1.controls[index].controls['quantity'].setValue(quantity);
                        items_1.controls[index].controls['disableIncrement'].setValue(false);
                    }
                    items_1.controls[index].controls['disableDecrement'].setValue(false);
                    items_1.controls[index].controls['quantity'].updateValueAndValidity();
                }
                if (items_1.controls[index].controls['quantity'].value === 0) {
                    items_1.controls[index].controls['quantity'].setValue(1);
                    quantity = 1;
                    items_1.controls[index].controls['quantity'].updateValueAndValidity();
                    items_1.controls[index].controls['disableIncrement'].setValue(false);
                }
                if (this.productAssociationInfo) {
                    var productid_3 = items_1.value[index].productId;
                    var associateProduct_3 = this.productAssociationInfo.find(function (x) { return x.productId === productid_3; });
                    if (associateProduct_3) {
                        var sameProductIndex = items_1.controls.findIndex(function (item) { return item.controls['productId'].value === associateProduct_3.depositFeeProductId; });
                        if (sameProductIndex >= 0) {
                            var depositFeeProductQuantity = +items_1.value[sameProductIndex].quantity;
                            depositFeeProductQuantity = depositFeeProductQuantity - previousProductQty;
                            depositFeeProductQuantity = depositFeeProductQuantity + quantity;
                            if (depositFeeProductQuantity > 0) {
                                this.updateQuantity(depositFeeProductQuantity, sameProductIndex);
                            }
                        }
                    }
                }
                if (!this.isFocused) {
                    this.updateTotalsAndShipMethod(false);
                }
                this.isFocused = false;
                this.clickTimeout[items_1.controls[index].controls['productId'].value] =
                    setTimeout(function () {
                        //New logic to bind promtoion product from promotion engine
                        var freeProductsInfo = _this.validatePromotionCriteria(items_1);
                        var productIds = _this._commonService.updateCartAfterPromotion(freeProductsInfo, items_1, _this.orderFormGroup, _this.promotionIds);
                        _this._commonService.removeNonPromotionProducts(freeProductsInfo, items_1);
                        if (productIds && productIds.length) {
                            _this.addPromotionEngineProducts(productIds, freeProductsInfo);
                        }
                        else {
                            _this.updateTotalsAndShipMethod();
                        }
                    }, 700);
            }
        }
    };
    /**
     * @description open/close when restricted products shown
     * @param {boolean} isOpen
     * @memberof OrderCreateFBOComponent
     */
    OrderCreateFBOComponent.prototype.restrictionPopupOpen = function (isOpen) {
        this.isRestrictionPopupOpened = isOpen;
    };
    /**
     * disabling Submit button
     */
    OrderCreateFBOComponent.prototype.disableSubmitButton = function () {
        this.taxCalculationStatus = true;
    };
    /**
     * @returns void
     */
    OrderCreateFBOComponent.prototype.deleteItem = function (index) {
        var _this = this;
        var items = this.orderFormGroup.get('items');
        var product = items.controls[index].controls['productItem'].value;
        var productQuantity = +items.controls[index].controls['quantity'].value;
        this.orderFormGroup.controls['fboEligibleProducts'].setValue('');
        this.isFBOEnrollmentEligible = false;
        this.selectedFboEligibleProduct = false;
        for (var i = 0; i < items.controls.length; i++) {
            var item = items.controls[i].value;
            if (item && item.productId != product.id) {
                this.isFBOEnrollmentEligible = this.isFBOEnrollmentEligible ?
                    this.isFBOEnrollmentEligible : item.productItem.display.fboEligible;
                this.selectedFboEligibleProduct = this.selectedFboEligibleProduct ? this.selectedFboEligibleProduct : item.productItem.display.fboEligible;
            }
        }
        // if (product && product.display && product.display.fboEligible) {
        //     this.isFBOEnrollmentEligible = false;
        //     this.selectedFboEligibleProduct = false;
        // }
        if (items && items.length > 0) {
            if (this.productAssociationInfo.length > 0) {
                var depositFeeEnabledCount = this._commonService.depositFeeEnabledProducts(items);
                var productId_1 = items.value[index].productId;
                var parentProduct_1 = this.productAssociationInfo.find(function (x) { return x.productId === productId_1; });
                if (parentProduct_1) {
                    // remove the parent product
                    items.removeAt(index);
                    var depositFeeProductIndex = items.controls.findIndex(function (item) { return item.controls['productId'].value === parentProduct_1.depositFeeProductId; });
                    if (depositFeeEnabledCount > 1) {
                        if (depositFeeProductIndex > -1) {
                            var depositFeeProductQuantity = +items.value[depositFeeProductIndex].quantity;
                            depositFeeProductQuantity = depositFeeProductQuantity - productQuantity;
                            if (depositFeeProductQuantity > 0) {
                                items.value[depositFeeProductIndex].quantity = depositFeeProductQuantity;
                                items.setValue(items.value);
                            }
                            else {
                                items.removeAt(depositFeeProductIndex);
                            }
                        }
                    }
                    else {
                        if (depositFeeProductIndex > -1) {
                            items.removeAt(depositFeeProductIndex);
                            var productIndex = this.productAssociationInfo.findIndex(function (x) { return x.productId === productId_1; });
                            if (productIndex != -1) {
                                this.productAssociationInfo.splice(productIndex, 1);
                            }
                        }
                    }
                }
                else {
                    items.removeAt(index);
                }
            }
            else {
                items.removeAt(index);
            }
        }
        setTimeout(function () {
            if (_this.itemLevelSearch && _this.itemLevelSearch.nativeElement) {
                _this.itemLevelSearch.nativeElement.focus();
            }
        }, 500);
        if (this.clickTimeout[product]) {
            clearTimeout(this.clickTimeout[product]);
            this.updateTotalsAndShipMethod(false);
            this.clickTimeout[product] =
                setTimeout(function () {
                    var freeProductsInfo = _this.validatePromotionCriteria(items);
                    var productIds = _this._commonService.updateCartAfterPromotion(freeProductsInfo, items, _this.orderFormGroup, _this.promotionIds);
                    _this._commonService.removeNonPromotionProducts(freeProductsInfo, items);
                    if (productIds && productIds.length) {
                        _this.addPromotionEngineProducts(productIds, freeProductsInfo);
                    }
                    else {
                        _this.updateTotalsAndShipMethod();
                    }
                }, 500);
        }
        else {
            this.updateTotalsAndShipMethod(false);
            var freeProductsInfo = this.validatePromotionCriteria(items);
            var productIds = this._commonService.updateCartAfterPromotion(freeProductsInfo, items, this.orderFormGroup, this.promotionIds);
            this._commonService.removeNonPromotionProducts(freeProductsInfo, items);
            if (productIds && productIds.length) {
                this.addPromotionEngineProducts(productIds, freeProductsInfo);
            }
            else {
                this.updateTotalsAndShipMethod();
            }
        }
    };
    /**
 * @description
 * @param {number} index
 * @memberof OrderCreateFBOComponent
 */
    OrderCreateFBOComponent.prototype.checkFboDocumentSelection = function (index) {
        this.agreementDocuments[index].isSelected = !this.agreementDocuments[index].isSelected;
        this.agreementCheckError = this._enrollmentCommonService.validateAgreementSelection(this.agreementDocuments);
    };
    /**
     * update Totals and ShipMethod
     */
    OrderCreateFBOComponent.prototype.updateTotalsAndShipMethod = function (isShippingMethod) {
        var _this = this;
        if (isShippingMethod === void 0) { isShippingMethod = true; }
        this.taxCalculationStatus = true;
        this.shippingCost = 0;
        this.importFeeValue = 0;
        this.taxableAmount = 0;
        this.retailDeliveryFee = 0;
        this.orderTaxResponse = null;
        this.products = [];
        this.totalCommissionableVolume = 0;
        this.itemCount = 0;
        var items = this.orderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo) {
            var _loop_1 = function (index) {
                var product = items.controls[index].controls['productItem'].value;
                var quantity = items.controls[index].controls['quantity'].value;
                if (product && quantity) {
                    var existProduct_1 = this_1.products.filter(function (productObj) { return productObj.id === product.id; })[0];
                    if (!existProduct_1) {
                        product.quantity = quantity;
                        this_1.products.push(product);
                        this_1.fboProductsInCart.emit(this_1.products && this_1.products.length);
                    }
                    else {
                        var productIndex = this_1.products.findIndex(function (item) { return item.id === existProduct_1.id; });
                        this_1.products[productIndex].quantity = this_1.products[productIndex].quantity + quantity;
                    }
                    if (this_1.shippingAddressInfoConfig && this_1.shippingAddressInfoConfig.isWaiveShippingCost) {
                        this_1.memberShippingDiscountOfferEligible = true;
                    }
                    else {
                        this_1.memberShippingDiscountOfferEligible = false;
                    }
                    var shippingAddress_1 = this_1._enrollmentCommonService.getShippingAddress(this_1.shippingAddressInfo, this_1.pudoShippingAddressInfo, this_1.selectedCountryCodeTwo, this_1.orderFormGroup.value, this_1.countries);
                    if (shippingAddress_1 && shippingAddress_1.countryId && this_1.countries && this_1.countries.length > 0) {
                        var country = this_1.countries.find(function (x) { return x.countryId === shippingAddress_1.countryId; });
                        this_1.countryTaxInclusive = this_1._enrollmentCommonService.getCountryTaxInclusiveInfo(country);
                    }
                    var isEnableVATCalculation = this_1.appConfig && this_1.appConfig.enableVATCalculation;
                    var taxCalculated = this_1.appConfig.displayTaxInclusivePrice ? false : true;
                    this_1.displayPriceConfig = this_1._memberDisplayPriceConfigService
                        .getDisplayPriceConfig(PortalDisplayPage.PlaceOrder, this_1.storeInfo.taxInclusive, null, taxCalculated, this_1.countryTaxInclusive, this_1.storeInfo.homeIsocodeThree, isEnableVATCalculation, this_1.iscalculateTax);
                    var price = this_1.countryTaxInclusive ? product.applicablePrice : product.catalogPrice;
                    var retailPrice = product.retailPrice;
                    if (this_1.displayPriceConfig) {
                        price = this_1.displayPriceConfig.displayApplicablePrice ? product.applicablePrice :
                            (this_1.displayPriceConfig.displayComputedTaxInclusivePrice ? product.computedTaxInclusivePrice
                                : product.catalogPrice);
                        retailPrice = this_1.displayPriceConfig.displayRetailPrice ? product.retailPrice :
                            (this_1.displayPriceConfig.displayBaseRetailPrice ? product.baseRetailPrice : product.retailPrice);
                    }
                    this_1.totalCommissionableVolume = this_1.totalCommissionableVolume + (product.commissionableVolume * +quantity);
                    this_1.itemCount += +product.quantity;
                }
            };
            var this_1 = this;
            for (var index = 0; index < items.length; index++) {
                _loop_1(index);
            }
            if (this.orderRules && (this.orderRules.valueType === ValueType.CC || this.orderRules.valueType === ValueType.PRICE)) {
                if ((this.totalCommissionableVolume < this.distributorMaxCC) && !this.selectedFboEligibleProduct) {
                    clearTimeout(this.cartMessageID);
                    var cartMinimumLimit_1 = this._translatePipe.get('To continue, either add any of the 2CC eligible product from dropdown or make sure a minimum of 2 Total CC is reached');
                    this.cartMessageID = setTimeout(function () {
                        _this._commonService.createNotification('', cartMinimumLimit_1.value, NotificationType.ERROR, 0, Constants.MIN_LIMIT);
                    }, 100);
                    this.isFBOEnrollmentEligible = false;
                }
                else {
                    this._commonService.removeNotification(Constants.MIN_LIMIT);
                    this.isFBOEnrollmentEligible = true;
                }
            }
            if (this.orderRules && this.orderRules.valueType === ValueType.PRICE && (this.appConfig.enableValidateProductTypes || !(this.orderRules.validateProductTypes
                && this.orderRules.validateProductTypes.length))) {
                var subTotal = this.calculateItemsSubTotal(this.storeInfo);
                var literatureItems = this._enrollmentCommonService.getLiteratureItems(this.products, this.orderRules);
                if (!((subTotal >= this.orderRules.minValue && subTotal <= this.orderRules.maxValue)
                    || (this.orderRules.includeLiterature && literatureItems && literatureItems.length === this.products.length
                        && subTotal <= this.orderRules.maxValue))) {
                    if (this.appConfig && this.appConfig.orderMinMaxPriceValidation) {
                        this.minMaxPriceValidation = true;
                    }
                    if (subTotal > this.orderRules.maxValue) {
                        clearTimeout(this.cartMessageID);
                        var cartValueExceeded = this._translatePipe.get('order.The order amount not including your discounts must not exceed');
                        var maxValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.maxValue, this.storeInfo);
                        var cartValueExceededNotification_1 = cartValueExceeded.value + ' <b class="helvetica-bold">' +
                            maxValue + '</b>';
                        if (this.appConfig && this.appConfig.displayPurchaseLimitationMessage) {
                            this.cartMessageID = setTimeout(function () {
                                _this._commonService.createNotification('', cartValueExceededNotification_1, NotificationType.ERROR, 0, Constants.MAX_EXCEEDED);
                            }, 100);
                        }
                    }
                    else if (subTotal < this.orderRules.minValue && !this.selectedFboEligibleProduct && !this.isOverrideMinimumLimit) {
                        clearTimeout(this.cartMessageID);
                        if (this.overrideMinimumLimitIsEnabled) {
                            var cartMinimumLimit = this._translatePipe.get('order.To register as an FBO the order must meet a minimum of');
                            var overrideLimitLink = this._translatePipe.get("order.To Override Minimum Limit,click <a id='more-options'>here</a>");
                            var minValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.minValue, this.storeInfo);
                            var cartMinimumLimitNotification_1 = cartMinimumLimit.value + ' <b class="helvetica-bold">' +
                                minValue + '</b>.<b>' + overrideLimitLink.value + '</b>';
                            this.cartMessageID = setTimeout(function () {
                                var toast = _this._commonService.createNotification('', cartMinimumLimitNotification_1, NotificationType.ERROR, 0, Constants.MIN_LIMIT);
                                toast.click.subscribe(function (event) {
                                    if (event.target.getAttribute(ImpersonateUserConstants.ID) === ImpersonateUserConstants.MORE_OPTIONS) {
                                        _this.overrideMinimumLimit.open();
                                    }
                                });
                            }, 100);
                        }
                        else {
                            var cartMinimumLimit = this._translatePipe.get('order.To register as an FBO the order must meet a minimum of');
                            var minValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.minValue, this.storeInfo);
                            var cartMinimumLimitNotification_2 = cartMinimumLimit.value + ' <b class="helvetica-bold">' +
                                minValue + '</b>';
                            this.cartMessageID = setTimeout(function () {
                                _this._commonService.createNotification('', cartMinimumLimitNotification_2, NotificationType.ERROR, 0, Constants.MIN_LIMIT);
                            }, 100);
                        }
                        this.isFBOEnrollmentEligible = false;
                    }
                    else {
                        this._commonService.removeNotification(Constants.MIN_LIMIT);
                        this._commonService.removeNotification(Constants.MAX_EXCEEDED);
                    }
                }
                else {
                    this.minMaxPriceValidation = false;
                    if (!(this.totalCommissionableVolume < this.distributorMaxCC)) {
                        this.isFBOEnrollmentEligible = true;
                    }
                    else if (!this.selectedFboEligibleProduct) {
                        this.isFBOEnrollmentEligible = false;
                    }
                }
            }
            else {
                this.itemCount = 0;
            }
            this.validateOrderLimit(true);
            if (isShippingMethod) {
                this.getShipMethods();
            }
        }
        else {
            this.isFBOEnrollmentEligible = false;
            this.gstTax = 0;
            this.pstTax = 0;
            this.shippingCost = 0;
            this.shippingTax = 0;
            this.importFeeValue = 0;
            this.fboProductsInCart.emit(this.products && this.products.length);
        }
    };
    OrderCreateFBOComponent.prototype.getOverrideMinimumLimit = function () {
        if (this.userInfo && this.userInfo.allowedOperatingCountries && this.storeInfo && this.storeInfo.operatingCountry && !this.userInfo.hasSystemRole && this.operatingCountry) {
            var isoCodeThree_1 = this.storeInfo.operatingCountry;
            var allowedCountryIds = [];
            var operatingCountryId = this.operatingCountry.filter(function (operatingCountry) { return operatingCountry.value == isoCodeThree_1; });
            allowedCountryIds = this.userInfo.allowedOperatingCountries.split(",");
            if (operatingCountryId && operatingCountryId.length > 0) {
                return allowedCountryIds.includes(operatingCountryId[0].id.toString()) && this.hasMinimumOverrideLimit;
            }
            else {
                return false;
            }
        }
        return this.userInfo && this.userInfo.hasSystemRole === true ? true : false;
    };
    OrderCreateFBOComponent.prototype.closeOverrideMinimumLimit = function () {
        this.isOverrideMinimumLimit = false;
        this.overrideMinimumLimit.close();
    };
    OrderCreateFBOComponent.prototype.overrideMinimumLimitValueCheck = function (event) {
        this.isOverrideMinimumLimit = event.currentTarget.checked;
    };
    OrderCreateFBOComponent.prototype.getOperatingCountries = function () {
        var _this = this;
        this._customerService.getOperatingCountries().subscribe(function (response) {
            if (response) {
                _this.operatingCountry = response;
            }
        }, function (err) {
            console.log(err);
        });
    };
    OrderCreateFBOComponent.prototype.closeNotification = function () {
        this._commonService.removeNotification(Constants.MIN_LIMIT);
        this.overrideMinimumLimit.close();
    };
    /**
     * Get Total CartItems Cost.
     */
    OrderCreateFBOComponent.prototype.calculateItemsSubTotal = function (store) {
        var isVATRegistered = (this.bonusInformation && this.bonusInformation.vatId) || (this.checkoutConfig && this.checkoutConfig.vatInPersonalInfo && this.personalInformation && this.personalInformation.vatId) ? true : false;
        var isEnableVATCalculation = this.appConfig && this.appConfig.enableVATCalculation;
        this.itemSubTotal = this._enrollmentCommonService.calculateItemsSubTotal(store, this.countryTaxInclusive, this.products, this.checkoutConfig, isVATRegistered, isEnableVATCalculation, this.appConfig, this.iscalculateTax);
        return this.itemSubTotal;
    };
    /**
* @description This method used to load default settings for FBO flow
* loadFBOFlowSettings()
* @returns void
*/
    OrderCreateFBOComponent.prototype.loadFBOFlowSettings = function (response) {
        var _this = this;
        this.getOrderRules();
        this.shippingDeliveryOptionAvailable = false;
        this.pickupDeliveryOptionAvailable = false;
        this.loadPreferences(response);
        this.getPaymentMethodsByStore(this.memberTypeId);
        this.loadDeliveryOptions();
        if (this.isOrderSessionInfo) {
            this.rebindSponsorData = this.orderSession.rebindSponsorData;
            this.sponsorInformation = this.orderSession.sponsorInformation;
        }
        this.storeId = response.id;
        this.storeInfo = response;
        this._enrollmentMessageService.setStoreInfo(this.storeInfo);
        this.storeLanguages = response.languages;
        this.overrideMinimumLimitIsEnabled = this.getOverrideMinimumLimit();
        this.paymentComponentSettings.languageCode = this.languageCode;
        this.paymentComponentSettings.storeId = this.storeInfo.id;
        this.paymentComponentSettings.currencyCode = this.storeInfo.currencyCode;
        this.paymentComponentSettings.numberDecimals = this.storeInfo.numberDecimals;
        this.paymentComponentSettings.isoCountryCode = this.storeInfo.homeIsocodeThree;
        this.storeInfo.ccNumberDecimals = 3;
        this.storeInfo.ccNumberFormat = 'CR';
        this.storeInfo.ccSymbol = 'CC';
        if (this.orderSession && this.orderSession.deliveryPreference === DeliveryPreference.DROPSHIP) {
            this.orderFormGroup.controls['deliveryPreference'].setValue(this.orderSession.deliveryPreference);
            this.orderFormGroup.controls['deliveryPreference'].updateValueAndValidity();
            this.validationsOnDeliveryPreference();
        }
        if (response.languages && response.languages.length > 0) {
            this.storeDefaultLanguage = this.storeLanguages.find(function (languageCulture) {
                return languageCulture.default;
            }).cultureName || this.storeLanguages[0].cultureName;
        }
        this.isOrderSessionInfo ?
            this.orderFormGroup.controls['language'].setValue(this.orderSession.language)
            : this.orderFormGroup.controls['language'].setValue(this.storeLanguages.find(function (item) { return item.default; }).cultureName);
        var langCultureID = this.storeLanguages && this.storeLanguages.length > 0 && this.orderFormGroup.controls['language'].value ?
            this.storeLanguages.find(function (item) { return item.cultureName.toLowerCase() == _this.orderFormGroup.controls['language'].value.toLowerCase(); }).cultureId : null;
        this.getStorePromotions(langCultureID);
        this.orderFormGroup.controls['countryId'].enable();
        if (this.isOrderSessionInfo) {
            this.updateTotalsAndShipMethod();
        }
        if (!this.participatingCountry) {
            this.constructSchemaFormUrl(this.countryCode);
        }
        else {
            this.constructSchemaFormUrl(this.participatingCountry.isocodeThree);
            this._enrollmentMessageService.setParticipatingCountryInfo(this.participatingCountry.countryId);
        }
        if (this.isOrderSessionInfo) {
            this.loadOrderFromSession();
        }
        else {
            this.documentsRequest = this._enrollmentCommonService.prepareAgreementDocumentsRequest(this.orderFormGroup.controls['orderType'].value, this.countryCode, this.orderFormGroup.value.language);
        }
        if (this.orderSession && this.orderSession.deliveryPreference === this.deliveryPreference.DROPSHIP
            && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
            this.getPudoLocations();
        }
    };
    OrderCreateFBOComponent.prototype.getFeaturedPacks = function (storeInfo) {
        var _this = this;
        this._orderService.getFeaturedPacks(this.storeDefaultLanguage, this.storeInfo.homeIsocodeThree, storeInfo.id, storeInfo.taxInclusive)
            .subscribe(function (response) {
            if (response && response.length > 0) {
                response.forEach(function (product) {
                    var fboEligibilty = product.productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.DISTRIBUTORELIGIBLE; });
                    if (fboEligibilty && fboEligibilty.metaKeyWords === '1') {
                        product.display.fboEligible = true;
                    }
                    var freeProduct = product.productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.FREE_PRODUCT_ELIGIBLE; });
                    if (freeProduct && freeProduct.metaKeyWords === '1') {
                        product.display.freeProduct = true;
                    }
                    var isStockAvailable = _this._enrollmentCommonService.stockAvailable(product);
                    if (isStockAvailable && (product.display && !product.display.freeProduct)) {
                        _this.featuredPacks = _this.featuredPacks.concat(product);
                    }
                });
            }
        }, function (error) {
        });
    };
    OrderCreateFBOComponent.prototype.getEnrollmentKits = function (storeInfo) {
        var _this = this;
        this._orderService.getEnrollmentkits(this.storeDefaultLanguage, this.storeInfo.homeIsocodeThree, storeInfo.id, storeInfo.taxInclusive)
            .subscribe(function (response) {
            if (response && response.body && response.body.length > 0) {
                response.body.forEach(function (product) {
                    var fboEligibilty = product.productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.DISTRIBUTORELIGIBLE; });
                    if (fboEligibilty && fboEligibilty.metaKeyWords === '1') {
                        product.display.fboEligible = true;
                    }
                    var freeProduct = product.productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.FREE_PRODUCT_ELIGIBLE; });
                    if (freeProduct && freeProduct.metaKeyWords === '1') {
                        product.display.freeProduct = true;
                    }
                    var isStockAvailable = _this._enrollmentCommonService.stockAvailable(product);
                    if (isStockAvailable) {
                        _this.enrollmentKits = _this.enrollmentKits.concat(product);
                    }
                });
            }
        }, function (error) {
        });
    };
    /**
 * @description This method used to load FBO data from order session
 * loadOrderFromSession()
 * @returns void
 */
    OrderCreateFBOComponent.prototype.loadOrderFromSession = function () {
        if (this.isOrderSessionInfo) {
            this.personalInformation = this.orderSession.personalInformation;
            this.participatingCountry = this.orderSession.participatingCountry ? this.orderSession.participatingCountry : null;
            if (this.participatingCountry) {
                this.orderFormGroup.controls['participatingCountry'].setValue(this.participatingCountry.countryId);
                this.associatedCountry = this.participatingCountry.countryId;
            }
            this.fboEligibleProducts = this.orderSession.fboEligibleProducts ? this.orderSession.fboEligibleProducts : null;
            if (this.fboEligibleProducts) {
                this.orderFormGroup.controls['fboEligibleProducts'].setValue(this.fboEligibleProducts.id);
            }
            this.mailAlreadyExist = this.orderSession.mailAlreadyExist;
            this.accountVerified = this.orderSession.accountVerified;
            this.mailingAddress = this.orderSession.mailingAddress;
            this.memberCommunicationPreferences = this.orderSession.memberCommunicationPreferences;
            this.liveFormAddress = this.orderSession.liveFormAddress;
            this.orderFormGroup.controls['isContactSponsor'].setValue(this.memberCommunicationPreferences.email);
            this.returningFBOUser = this.orderSession.returningFBOUser;
            this.agreementDocuments = this.orderSession.documents;
            this.bonusInfoAgreements = this.orderSession.bonusInfoDocuments;
            this.disableBonusInfoChecks = this.orderSession.disableBonusInfoChecks;
            this.isFBOEnrollmentEligible = this.orderSession.isFBOEnrollmentEligible;
            this.selectedFboEligibleProduct = this.orderSession.selectedFboEligibleProduct;
            this.bonusPaymentOptionType = this.orderSession.bonusPaymentOptionType;
            this.bonusInformation = this.orderSession.bonusInformation ? this.orderSession.bonusInformation : null;
            this.orderFormGroup.controls['language'].setValue(this.orderSession.language);
            this.orderFormGroup.controls['saveForFutureUse'].setValue(this.orderSession.saveForFutureUse);
            this.agreementCheckError = this._enrollmentCommonService.validateAgreementSelection(this.agreementDocuments);
            if (this.orderSession.shippingAddressId || this.orderSession.shippingAddressInfo || this.orderSession.pudoaddress) {
                this.address = this.orderSession.shippingAddressInfo;
                if (this.orderSession && this.orderSession.deliveryPreference === DeliveryPreference.DROPSHIP) {
                    this.address = this.orderSession.pudoaddress;
                    this.pudoAddress = this.address;
                    this.pudoShippingAddressInfo = this.address;
                }
                this.orderFormGroup.controls['shippingAddressId'].setValue(this.orderSession.shippingAddressId, { onlySelf: true });
                if (this.address) {
                    if (this.orderSession && this.orderSession.deliveryPreference === DeliveryPreference.DROPSHIP) {
                        this.pudoAddress = this.orderSession.pudoaddress;
                    }
                    this.shippingAddressInfo = this.address;
                    this.savedAddressId = this.address.id;
                    if (!this.participatingCountry) {
                        this.constructSchemaFormUrl(this.countryCode);
                    }
                    else {
                        this.constructSchemaFormUrl(this.participatingCountry.isocodeThree);
                    }
                    this.address.isSavedAddress = this.orderSession.isSavedAddress;
                    this.address.id = this.orderSession.shippingAddressId;
                    this.pudoAddress = this.address;
                    this.pudoShippingAddressInfo = this.address;
                }
            }
            else {
                if (!this.participatingCountry) {
                    this.constructSchemaFormUrl(this.countryCode);
                }
                else {
                    this.constructSchemaFormUrl(this.participatingCountry.isocodeThree);
                }
            }
            if (this.orderSession.deliveryPreference === DeliveryPreference.PICKUP || (this.orderSession.deliveryPreference === DeliveryPreference.DROPSHIP && this.shippingAddressInfoConfig.dropShipLocationsEnabled)) {
                this.orderFormGroup.controls['deliveryPreference'].setValue(this.orderSession.deliveryPreference);
                this.orderFormGroup.controls['deliveryPreference'].updateValueAndValidity();
                this.validationsOnDeliveryPreference();
            }
            this.businessInformation = this.orderSession.businessInformation;
            // check for shpping address when order info is in cache
            this.loadproductsFromSession();
        }
    };
    /**
     *load procducts from session
     */
    OrderCreateFBOComponent.prototype.loadproductsFromSession = function () {
        var _this = this;
        this.orderSession.products.forEach(function (product) {
            _this.addItemNumber();
            var items = _this.orderFormGroup.get('items');
            if (items && items.length > 0) {
                var index = (items.length - 1);
                if (product) {
                    var itemValue = product.itemNumber + ' - ' + product.name;
                    items.controls[index].controls['itemNumber'].setValue(itemValue);
                    var itemImage = (product.imageModelList && product.imageModelList.length > 0)
                        ? (product.imageModelList[0].details.find(function (imageDetail) { return imageDetail.type === ImageType.Thumbnail; })) : '';
                    var imageUrl = (itemImage && itemImage.url) ? (environment.cdnURL + '/' + itemImage.url)
                        : (environment.uiTemplateBaseUrl + '/images/no_image.png');
                    var isDepositFeeProduct = product.productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_PRODUCT && x.metaKeyWords === '1'; });
                    var depositFeeEnabled = product.productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED && x.metaKeyWords === '1'; });
                    items.controls[index].controls['productImage'].setValue(imageUrl);
                    items.controls[index].controls['productNumber'].setValue(product.itemNumber);
                    items.controls[index].controls['productName'].setValue(product.displayName ? product.displayName : product.name);
                    items.controls[index].controls['productId'].setValue(product.id);
                    items.controls[index].controls['productItem'].setValue(product);
                    items.controls[index].controls['quantity'].setValidators([Validators.required]);
                    items.controls[index].controls['quantity'].updateValueAndValidity();
                    items.controls[index].controls['quantity'].setValue(product.quantity);
                    items.controls[index].controls['isDepositFeeProduct'].setValue(!!isDepositFeeProduct);
                    items.controls[index].controls['depositFeeEnabled'].setValue(!!depositFeeEnabled);
                    if (product.promoProduct || (_this.appConfig && _this.appConfig.displayOnlyEnrollmentItem)) {
                        items.controls[index].controls['disableIncrement'].setValue(true);
                        items.controls[index].controls['disableDecrement'].setValue(true);
                        items.controls[index].controls['disableDelete'].setValue(true);
                    }
                    else {
                        items.controls[index].controls['disableIncrement'].setValue(false);
                        items.controls[index].controls['disableDelete'].setValue(false);
                        if (product.quantity == 1) {
                            items.controls[index].controls['disableDecrement'].setValue(true);
                        }
                        else {
                            items.controls[index].controls['disableDecrement'].setValue(false);
                        }
                    }
                    if (depositFeeEnabled) {
                        _this.getDepositFeeProduct(product, true);
                    }
                }
            }
        });
        this.updateTotalsAndShipMethod();
    };
    /**
 * @description This method used to load delivery options based on member type
 * loadDeliveryOptions()
 * @returns void
 */
    OrderCreateFBOComponent.prototype.loadDeliveryOptions = function () {
        var _this = this;
        var getDeliveryOptionsRequest = {
            memberTypeId: this._enrollmentCommonService.getMemberTypeId(this.orderFormGroup.controls['orderType'].value),
            memberType: this._enrollmentCommonService.getMemberType(this.orderFormGroup.controls['orderType'].value),
            source: Source.CSP,
            countryCode: this.countryCode,
            purchaseFlow: this._enrollmentCommonService.getPurchaseFlow(this.orderFormGroup.controls['orderType'].value),
            storeId: this.storeId
        };
        this.shippingDeliveryOptionAvailable = false;
        this.pickupDeliveryOptionAvailable = false;
        this._orderService.getDeliveryOptions(this.countryCode, getDeliveryOptionsRequest).subscribe(function (res) {
            if (res && res.length > 0) {
                _this.dropShipDeliveryOptionDisabled = false;
                res.forEach(function (option) {
                    if (option.optionValue === DelivaryOptionType.Delivery) {
                        _this.shippingDeliveryOptionAvailable = true;
                    }
                    if (option.optionValue === DelivaryOptionType.Pickup) {
                        _this.pickupDeliveryOptionAvailable = true;
                    }
                    if (option.optionValue === DelivaryOptionType.Dropship) {
                        if (option.optionDisabled) {
                            _this.dropShipDeliveryOptionDisabled = true;
                        }
                        else if (_this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                            _this.dropShipOptionAvailable = true;
                        }
                        else {
                            _this.pickupDeliveryOptionAvailable = true;
                        }
                    }
                });
                var isDropShip = res.find(function (x) { return x.optionValue == DelivaryOptionType.Dropship; });
                var isPickUp = res.find(function (x) { return x.optionValue == DelivaryOptionType.Pickup; });
                if (environment.scandinavianCountries && _this.countryCode) {
                    var scandinavianCountries = environment.scandinavianCountries;
                    _this.scandinavianCountry = scandinavianCountries.split(",").find(function (country) { return country === _this.countryCode; });
                }
                // For Scandian country checking for Pickup
                if (_this.scandinavianCountry && isPickUp) {
                    _this.isPickUpOptionExist = true;
                }
                // For Non-Scandian country checking for DropShip
                if (!_this.scandinavianCountry && isDropShip && !_this.shippingAddressInfoConfig.dropShipLocationsEnabled && !_this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                    _this.isDropShipOptionExist = true;
                }
                // For Non-Scandian country checking for PickUp
                if (!_this.scandinavianCountry && isPickUp && _this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                    _this.isPickUpOptionExist = true;
                }
                if (!_this.scandinavianCountry && isPickUp && !_this.shippingAddressInfoConfig.dropShipLocationsEnabled && _this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                    _this.isPickUpOptionExist = true;
                }
                _this.loadSavedCardsForMemberId(0, _this.selectedIsoCountryCode);
            }
        });
    };
    OrderCreateFBOComponent.prototype.loadSavedCardsForMemberId = function (memberId, countryCode) {
        var _this = this;
        var paymentStatus = this._cacheService.get(CacheKey.PaymentStatus);
        if (paymentStatus) {
            var newCardError = this._translatePipe.get('order.Payment gateway not responding');
            this._commonService.createNotification('', newCardError.value, NotificationType.ERROR);
            this._cacheService.remove(CacheKey.PaymentStatus);
        }
        var paymentInstrumentId = this._cacheService.get(CacheKey.PaymentInstrumentId);
        this._payvisionService.getSavedPayvisonCards(memberId, countryCode, paymentInstrumentId).subscribe(function (savedCardResponse) {
            if (savedCardResponse && savedCardResponse.savedCards && savedCardResponse.savedCards.length > 0) {
                _this.paymentComponentSettings.savedCards = savedCardResponse.savedCards;
                _this.paymentComponentSettings.savedCards.forEach(function (card) {
                    card.notes = card.defaultCard ? PaymentConstants.default : '';
                });
                if (paymentInstrumentId) {
                    var selectedCard = _this.paymentComponentSettings.savedCards.find(function (x) { return x.id === paymentInstrumentId; });
                    if (selectedCard) {
                        var indexPostion = _this.paymentComponentSettings.savedCards.findIndex(function (x) { return x.id === paymentInstrumentId; });
                        _this.paymentComponentSettings.savedCards.splice(indexPostion, 1);
                        _this.paymentComponentSettings.savedCards.unshift(selectedCard);
                        _this.selectedPayvisionCardInfo = selectedCard;
                    }
                    _this.orderFormGroup.controls['paymentInstrumentId'].setValue(paymentInstrumentId);
                    _this._cacheService.remove(CacheKey.PaymentInstrumentId);
                }
                else {
                    if (_this.paymentComponentSettings.savedCards && _this.paymentComponentSettings.savedCards.length > 0) {
                        var isDefaultCard_1 = false;
                        _this.paymentComponentSettings.savedCards.forEach(function (card) {
                            if (card.expired === false && isDefaultCard_1 === false) {
                                isDefaultCard_1 = true;
                                _this.orderFormGroup.controls['paymentInstrumentId'].setValue(card.id);
                                _this.selectSavedCard(card);
                            }
                        });
                    }
                    else {
                        _this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
                        _this.orderFormGroup.controls['paymentInstrumentId'].setValidators([Validators.required]);
                        _this.orderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
                    }
                }
            }
            else {
                _this.paymentComponentSettings.savedCards = [];
            }
        }, function (error) {
            _this.paymentComponentSettings.isAddNewCard = false;
        });
    };
    OrderCreateFBOComponent.prototype.savedCardInfo = function (savedcardDetails) {
        this._cacheService.remove(CacheKey.IsRefreshed);
        sessionStorage.removeItem(CacheKey.OrderInfo);
        if (savedcardDetails) {
            this.paymentComponentSettings.savedCards.unshift(savedcardDetails);
            this.showNexioPopup.close();
            this.showNexioPayment = false;
            if (this.paymentComponentSettings.savedCards && this.paymentComponentSettings.savedCards.length) {
                var savedCard = this.paymentComponentSettings.savedCards[0];
                if (savedCard && savedCard.id === savedcardDetails.id) {
                    this.orderFormGroup.controls['paymentInstrumentId'].setValue(savedCard.id);
                }
                else {
                    this.orderFormGroup.controls['paymentInstrumentId'].setValue(this.paymentComponentSettings.savedCards[0].id);
                }
                this.selectedPayvisionCardInfo = savedcardDetails;
            }
        }
    };
    /**
         * On change of card
         */
    OrderCreateFBOComponent.prototype.selectSavedCard = function (cardDetails, isNewCard) {
        // if(isNewCard && this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled && this.orderFormGroup.value.deliveryPreference===this.deliveryPreference.DROPSHIP && !this.isnewcardAdded){
        //     this.messageService.setSubmitPudoPickupPersonAddress(true);
        // }else{
        this._cacheService.set(CacheKey.IsRefreshed, true);
        this.addNewCardClicked = false;
        this.mapBillingAddress();
        this.mapShippingAddress();
        if (isNewCard) {
            this._personalMessageService.setSubmitPersonalinfoForm(true);
            this._personalMessageService.setSubmitBusinessInfo(true);
            if (this.shippingAddressChanged) {
                this.showVerifyAddressMessage();
                return;
            }
            this.addOrderInfoToSession();
            if (this.isWorldpayPayment) {
                this.showWorldpayXml = true;
                this.showWorldPayXMLPopup.open();
            }
            else if (this.isAdyenPayment) {
                this.showAdyenPayment = true;
                this.showAdyenPaymentPopup.open();
            }
            else if (this.isNIPayment) {
                this.showNIPayment = true;
                this.showNIPopup.open();
            }
            else if (this.isNexioPayment) {
                this.showNexioPayment = true;
                this.showNexioPopup.open();
            }
            else {
                this.addNewPayvisionCard = true;
                this.payvisionPayment.open();
            }
        }
        else {
            this.selectedPayvisionCardInfo = cardDetails;
            this.addNewPayvisionCard = false;
            this.showWorldpayXml = false;
            this.showNIPayment = false;
            this.showAdyenPayment = false;
        }
    };
    OrderCreateFBOComponent.prototype.showVerifyAddressMessage = function () {
        var verifyAddressError = this._translatePipe.get('order.Shipping Address must be verified. Please click on VERIFY ADDRESS');
        this._commonService.createNotification('', verifyAddressError.value, NotificationType.ERROR);
    };
    OrderCreateFBOComponent.prototype.showVerifyBonusInfoMessage = function () {
        var verifyAddressError = this._translatePipe.get('order.Bonus Information  must be verified. Please click on Mailing address VERIFY ADDRESS Button');
        this._commonService.createNotification('', verifyAddressError.value, NotificationType.ERROR);
    };
    OrderCreateFBOComponent.prototype.addOrderInfoToSession = function () {
        sessionStorage.removeItem(CacheKey.OrderInfo);
        var formValues = this.orderFormGroup.value;
        if (this.personalInformation && this.personalInformation.dateOfBirth) {
            this.personalInformation.dateOfBirth = moment(this.personalInformation.dateOfBirth, DateConstants.DateFormat).format(DateConstants.DOBFormat);
        }
        var OrderInfo = {
            products: this.products,
            countryId: formValues.countryId,
            deliveryPreference: formValues.deliveryPreference,
            memberInfo: formValues.memberInfo,
            orderType: formValues.orderType,
            paymentSelector: formValues.paymentSelector,
            shippingAddressId: this.shippingAddressInfo && this.shippingAddressInfo.id ? this.shippingAddressInfo.id : 0,
            shippingAddressInfo: this.shippingAddressInfo,
            shipMethodId: formValues.shipMethodId,
            shippingCost: this.memberShippingDiscountOfferEligible ? 0 : formValues.shippingCost,
            shippingCostPercentage: this.memberShippingDiscountOfferEligible ? 0 : formValues.shippingCostPercentage,
            shippingCostSelector: formValues.shippingCostSelector,
            verifiedShippingAddressId: this.verifiedShippingAddressId,
            shippingCostValue: this.memberShippingDiscountOfferEligible ? 0 : this.shippingCost,
            orderFromLookup: this.orderFromLookup,
            saveForFutureUse: this.orderFormGroup.value.saveForFutureUse,
            isSavedAddress: this.address ? this.address.isSavedAddress : null,
            savePaymentMethod: this.savePaymentMethod ? this.savePaymentMethod : false,
            memberCartSessionGuid: this.memberCart
                && this.memberCart.sessionGuid ? this.memberCart.sessionGuid :
                this.memberCartSessionGuid ? this.memberCartSessionGuid : null,
            personalInformation: this.personalInformation,
            returningFBOUser: this.returningFBOUser,
            documents: this.agreementDocuments,
            bonusInfoDocuments: this.bonusInfoAgreements,
            disableBonusInfoChecks: this.disableBonusInfoChecks,
            language: this.orderFormGroup.value.language,
            languageCulture: this.languageCulture,
            mailingAddress: this.mailingAddress,
            rebindSponsorData: this.rebindSponsorData,
            sponsorInformation: this.sponsorInformation,
            memberCommunicationPreferences: this.memberCommunicationPreferences,
            liveFormAddress: this.liveFormAddress,
            mailAlreadyExist: this.mailAlreadyExist,
            isShippingDiscountApplied: this.orderFormGroup.value.isShippingDiscountApplied,
            minMaxPriceValidation: this.minMaxPriceValidation,
            participatingCountry: this.participatingCountry ? this.participatingCountry : null,
            isFBOEnrollmentEligible: this.isFBOEnrollmentEligible,
            selectedFboEligibleProduct: this.selectedFboEligibleProduct ? this.selectedFboEligibleProduct : false,
            fboEligibleProducts: this.fboEligibleProducts ? this.fboEligibleProducts : null,
            accountVerified: this.accountVerified,
            bonusInformation: this.bonusInformation ? this.bonusInformation : null,
            bonusPaymentOptionType: this.bonusPaymentOptionType,
            selectPudoCollectionPoint: this.selectedPudoCollectionPoint ? this.selectedPudoCollectionPoint : null,
            buildPudoLocationSearchForm: this.pudoLocationSearchForm.value,
            pudoShippingMethod: this.pudoShippingMethod ? this.pudoShippingMethod : null,
            pudoaddress: this.pudoAddress ? this.pudoAddress : null,
            businessInformation: this.businessInformation,
            isOverrideMinimumLimit: this.isOverrideMinimumLimit,
            pudoShippingAddressInfo: this.pudoShippingAddressInfo && this.shippingAddressInfoConfig.dropShipLocationsEnabled ? this.pudoShippingAddressInfo : null
        };
        sessionStorage.setItem(CacheKey.OrderInfo, JSON.stringify(OrderInfo));
    };
    OrderCreateFBOComponent.prototype.loadPreferences = function (response) {
        var memberTypeId = this._enrollmentCommonService.getMemberTypeId(this.orderFormGroup.controls['orderType'].value);
        var preferenceConfig;
        preferenceConfig = response && response.storePreferenceModels ? response.storePreferenceModels.find(function (config) {
            return config.memberTypeId === memberTypeId;
        }) : null;
        if (preferenceConfig) {
            if (preferenceConfig.value === Constants.YES || preferenceConfig.value === Constants.DEFAULT) {
                this.orderFormGroup.controls['isContactSponsor'].setValue(true);
                this.checkContactSponsor();
            }
            else if (preferenceConfig.value === Constants.NO) {
                this.orderFormGroup.controls['isContactSponsor'].setValue(false);
                this.checkContactSponsor();
            }
        }
    };
    // getPaymentMethod by Store
    OrderCreateFBOComponent.prototype.getPaymentMethodsByStore = function (memberTypeId) {
        var _this = this;
        var fpc5PercentEnabled = false;
        if (this.appConfig && this.appConfig.fpc5PercentEnabled) {
            fpc5PercentEnabled = true;
        }
        this.credit_Card_show = this.money_Order_show = this.cash_on_delivery_show = this.orange_money_show = this.ach_show = this.wire_Transfer_show
            = this.bank_transfer_show = this.echeck_show = this.misterCash_and_maestro_show = this.banContact_misterCash_and_maestro_show = this.pay_by_link_show = false;
        this._orderService.getPaymentMethodsByStore(this.storeId, this.countryCode, this.storeDefaultLanguage ? this.storeDefaultLanguage : this.languageCode, null, false, fpc5PercentEnabled, true).subscribe(function (response) {
            if (response) {
                if (response.find(function (x) { return x.paymentMethodName === PaymentMethodTypes.Credit_Card && x.paymentProcessor === PaymentProcessorAlias.ADYEN; })) {
                    _this._commonService.getPaymentMethodsSourceConfiguration().subscribe(function (paymentMethodSourceConfigurations) {
                        if (paymentMethodSourceConfigurations && paymentMethodSourceConfigurations.length > 0 && response && response.length > 0) {
                            var paymentmethodsConfig = paymentMethodSourceConfigurations.find(function (paymentMethodSourceConfiguration) { return paymentMethodSourceConfiguration && paymentMethodSourceConfiguration.country == _this.selectedIsoCountryCode; });
                            if (paymentmethodsConfig) {
                                response = _this._commonService.filterPaymentMethods(paymentmethodsConfig, response, _this.orderFormGroup.value.orderType);
                            }
                        }
                        _this.updatePaymentMethodsDisplayStatus(response);
                    }, function (error) {
                        _this.updatePaymentMethodsDisplayStatus(response);
                    });
                }
                else {
                    _this.updatePaymentMethodsDisplayStatus(response);
                }
            }
        });
    };
    OrderCreateFBOComponent.prototype.updatePaymentMethodsDisplayStatus = function (response) {
        var _this = this;
        this.storePaymentInfo = response;
        this.initializePaymentMethods();
        this.storePaymentInfo.forEach(function (paymentMethod) {
            if (paymentMethod.paymentMethodId === PaymentType.Credit_Card) {
                _this.credit_Card_show = true;
                if (paymentMethod.paymentProcessor === PaymentProcessorAlias.NEXIO) {
                    _this.isNexioPayment = true;
                }
                else if (paymentMethod.paymentProcessor === PaymentProcessorAlias.ADYEN) {
                    _this.isAdyenPayment = true;
                }
                else if (paymentMethod.paymentProcessor === PaymentProcessorAlias.NI) {
                    _this.isNIPayment = true;
                }
                else if (paymentMethod.paymentProcessor === PaymentProcessorAlias.WPAYXML) {
                    _this.isWorldpayPayment = true;
                }
            }
            else if (paymentMethod.paymentMethodId === PaymentType.Money_order) {
                _this.displayStatementForWavePayment = _this.appConfig.displayStatementForWavePayment;
                if (_this.displayStatementForWavePayment) {
                    _this.money_Order_show = true;
                    _this.displayStatementForWavePayment = _this.appConfig.displayStatementForWavePayment;
                }
                else {
                    _this.money_Order_show = true;
                    _this.getBankDetailsByCountry(_this.countryCode, PaymentModeConstants.Money_Order);
                }
                // } else if (paymentMethod.paymentMethodId === PaymentType.eCheck) {
                //     this.echeck_show = true;
            }
            else if (paymentMethod.paymentMethodId === PaymentType.Bank_Transfer) {
                _this.bank_transfer_show = true;
                _this.getBankDetailsByCountry(_this.countryCode);
            }
            else if (paymentMethod.paymentMethodId === PaymentType.Cash_On_Delivery) {
                _this.cash_on_delivery_show = true;
            }
            else if (paymentMethod.paymentMethodId === PaymentType.Orange_Money) {
                _this.orange_money_show = true;
            }
            else if (paymentMethod.paymentMethodId === PaymentType.eCheck) {
                _this.ach_show = true;
            }
            else if (paymentMethod.paymentMethodId === PaymentType.Pay_By_Link) {
                _this.pay_by_link_show = true;
            }
            else if (paymentMethod.paymentMethodId === PaymentType.Wire_Transfer) {
                _this.wire_Transfer_show = true;
                _this.getBankDetailsByCountry(_this.countryCode, PaymentModeConstants.Wire_Transfer);
            }
        });
        var option = this.credit_Card_show ? this.paymentTypeEnum.Credit_Card : this.money_Order_show ? this.paymentTypeEnum.Money_order
            : this.bank_transfer_show ? this.paymentTypeEnum.Bank_Transfer : this.cash_on_delivery_show ? this.paymentTypeEnum.Cash_On_Delivery
                : this.ach_show ? this.paymentTypeEnum.eCheck : this.banContact_misterCash_and_maestro_show ? this.paymentTypeEnum.BanContact_MisterCash_and_Maestro
                    : this.misterCash_and_maestro_show ? this.paymentTypeEnum.MisterCash_and_Maestro : this.pay_by_link_show ? this.paymentTypeEnum.Pay_By_Link : this.wire_Transfer_show ? this.paymentTypeEnum.Wire_Transfer : this.orange_money_show ? this.paymentTypeEnum.Orange_Money : null;
        if (option) {
            this.setPaymentMethod(option);
        }
        this.savePaymentMethod = this.orderSession && this.orderSession.savePaymentMethod ?
            this.orderSession.savePaymentMethod : false;
    };
    OrderCreateFBOComponent.prototype.initializePaymentMethods = function () {
        this.isWorldpayPayment = false;
        this.isAdyenPayment = false;
        this.isNIPayment = false;
        this.isNexioPayment = false;
    };
    /**
 * @description To get Bank Details for Bank Transfer Payment method.
 * getBankDetails()
 * @memberof OrderCreateFBOComponent
 */
    OrderCreateFBOComponent.prototype.getBankDetails = function () {
        var bankDetails = this._translateService.get(PaymentConstants.BankTransfer)['value'];
        if (bankDetails !== PaymentConstants.BankTransfer) {
            for (var key in bankDetails) {
                if (key.indexOf(PaymentConstants.BankDetails) > -1) {
                    this.bankDetailsList.push(bankDetails[key]);
                }
            }
        }
    };
    /**
     * @description constructing the schema form url
     * @memberof OrderCreateFBOComponent
     */
    OrderCreateFBOComponent.prototype.constructSchemaFormUrl = function (countryCode) {
        var _this = this;
        //To fetch personal schema form on country change
        this.personalInfoSchemaUrl = '';
        this._configurationService.setStoreID(this.storeId);
        this._configurationService.setEnrollCountry(countryCode);
        this.storeSettings = this._personalInfoConfigService.getSettings(this.countryCode);
        if (this.storeSettings.joinTypePersanalInfoSchemaForm) {
            this.personalInfoSchemaUrl = countryCode.toLowerCase() + '-personal-info-fbo-new.json?templateVersion= '
                + environment.templateVersion;
        }
        else {
            this.personalInfoSchemaUrl = countryCode.toLowerCase() + '-personal-info-new.json?templateVersion= '
                + environment.templateVersion;
        }
        this._configurationService.setPersonalInfoSchemaURL(this.personalInfoSchemaUrl);
        this._configurationService.setLanguageCulture(this.storeDefaultLanguage);
        this._personalMessageService.setRebindPersonalinfoForm(true);
        //------------------end----------------
        //To form Bonus schema URL and map schema form
        this.bonusInfoSchemaUrl = '';
        if (this.storeSettings.showBonusInfoSection) {
            if (this.storeSettings.countryCode.toLowerCase() === IsoCodeThree.SWE.toLowerCase() || this.storeSettings.countryCode.toLowerCase() === IsoCodeThree.DEU.toLowerCase() || this.storeSettings.countryCode.toLowerCase() === IsoCodeThree.AUT.toLowerCase()) {
                if (this.bonusInfoBankCode) {
                    this.bonusInfoSchemaUrl = countryCode.toLowerCase() + '-' + this.bonusInfoBankCode.toLowerCase() + '-bonus-info.json?templateVersion= '
                        + environment.templateVersion;
                }
                else {
                    this.bonusInfoSchemaUrl = countryCode.toLowerCase() + '-bankgiro-bonus-info.json?templateVersion= '
                        + environment.templateVersion;
                }
            }
            else {
                this.bonusInfoSchemaUrl = countryCode.toLowerCase() + '-bonus-info.json?templateVersion= '
                    + environment.templateVersion;
            }
            this._configurationService.setBonusInfoSchemaUrl(this.bonusInfoSchemaUrl);
            this._personalMessageService.setRebindBonusinfoForm(true);
            if (this.isOrderSessionInfo) {
                this.disableBonusInfoChecks = this.orderSession.disableBonusInfoChecks;
            }
            else {
                this.disableBonusInfoChecks = true;
            }
        }
        //--------------------END--------------
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.enablePudoShippingSchemaUrl && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-pudo-schema-form.json?templateVersion='
                + environment.templateVersion;
        }
        else {
            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
                + environment.templateVersion;
        }
        this._cacheService.set(CacheKey.COUNTRY_CODE, this.countryCode.toLowerCase());
        /*this.shippingSchemaUrl = countryCode.toLowerCase() + '-schema-form.json?templateVersion='
            + environment.templateVersion;*/
        this.billingSchemaUrl = countryCode.toLowerCase() + '-billing-schema-form.json?templateVersion='
            + environment.templateVersion;
        this.mailingSchemaUrl = countryCode.toLowerCase() + '-mailing-schema-form.json?templateVersion='
            + environment.templateVersion;
        setTimeout(function () {
            _this.address = _this.address;
            _this.mailingAddress = _this.mailingAddress;
            _this.displayMailingAddressForm = true;
            _this.showAddressForm = true;
            _this.shippingDeliveryOptionAvailable = true;
        }, 500);
        this.orderFormGroup.controls['countryId'].enable();
        if (this.hasParticipatingCountries) {
            this.orderFormGroup.controls['participatingCountry'].enable();
        }
    };
    OrderCreateFBOComponent.prototype.getCustomBankTypeSelectOption = function () {
        var _this = this;
        this.customSelectSubscription = this.messageService.getBankTypeChange()
            .subscribe(function (bankCode) {
            if (!_this.bonusInformation || (_this.bonusInformation && _this.bonusInformation.bankCode && _this.bonusInformation.bankCode.toLowerCase() !== bankCode.toLowerCase())) {
                _this.bonusInformation = null;
            }
        });
    };
    /**
     * @description  this method is used to
     * get the verified or sugggested address
     * @param {Address} mailingAddress
     * @memberof OrderCreateFBOComponent
     */
    OrderCreateFBOComponent.prototype.getMailingAddressInfo = function (address) {
        this.mailingAddress = address;
        this.getAddressOnInputChange(address);
        this._personalMessageService.setSubmitPersonalinfoForm(true);
        this.setBonusInformation();
        if (this.storeSettings.showBusinessInfoSection) {
            this.setBusinessInformation();
        }
        this.verifyAccountExistence();
    };
    OrderCreateFBOComponent.prototype.verifyAccountExistence = function () {
        var _this = this;
        if (this.liveFormPersonalInfo && this.mailingAddress) {
            var verifyAccountModel = this._enrollmentCommonService.prepareVerifyAccountRequest(this.liveFormPersonalInfo, this.mailingAddress);
            this._customerService.validateMemberUniqueFieldsWithAddress(verifyAccountModel)
                .subscribe(function (response) {
                if (response && !response.accountExists) {
                    _this.accountVerified = true;
                }
                else if (response && response.accountExists) {
                    _this.accountVerified = false;
                    _this.showAccountExistsMessage();
                }
            }, function (err) { });
        }
    };
    OrderCreateFBOComponent.prototype.pudoAddressInputChange = function (address) {
        if (this.formPickupPersonAddressValid) {
            this.pudoAddress = address;
            this.pudoCollectionPoints = null;
            this.hidePudoPickupLocationsButton = true;
            this.pudoLocationsNotFound = false;
            if (this.pudoAddress) {
                this.buildPudoLocationSearchForm(this.pudoAddress.zip, this.pudoAddress.city, this.pudoAddress.addressLine1);
            }
        }
    };
    /**
     * @description this method will fire when we change textbox value
     * in address block
     * @memberof OrderCreateFBOComponent
     */
    OrderCreateFBOComponent.prototype.getAddressOnInputChange = function (address) {
        if (!this.sponsorInformation) {
            this.liveFormAddress = address;
            this._enrollmentMessageService.setSponsorPreference(this.liveFormAddress);
        }
        if (this.mailingAddress) {
            if ((!this.participatingCountry || this.isParticipatingCountrySameAsStore) || this.checkoutConfig.isParticipatingCountryShippingEnabled) {
                this.prepopulateShippingAddress();
            }
            else {
                this.prePopulateDetails();
            }
        }
        var isAddressEqual = false;
        if (this.mailingAddress) {
            var verifyAddress = {
                addressLine1: this.mailingAddress.addressLine1 ? this.mailingAddress.addressLine1 : '',
                addressLine2: this.mailingAddress.addressLine2 ? this.mailingAddress.addressLine2 : '',
                city: this.mailingAddress.city ? this.mailingAddress.city : '',
                state: this.mailingAddress.state ? this.mailingAddress.state : '',
                postalCode: this.mailingAddress.postalCode ? this.mailingAddress.postalCode : '',
            };
            var unVerifiedAddress = {
                addressLine1: address.addressLine1 ? address.addressLine1 : '',
                addressLine2: address.addressLine2 ? address.addressLine2 : '',
                city: address.city ? address.city : '',
                state: address.state ? address.state : '',
                postalCode: address.postalCode ? address.postalCode : '',
            };
            isAddressEqual = isEqual(verifyAddress, unVerifiedAddress);
        }
        if (this.mailingAddress && this.mailingAddress.addressVerified && !isAddressEqual && !address.addressVerified) {
            this.mailingAddress.addressVerified = false;
        }
        else if ((this.participatingCountry || !this.isParticipatingCountrySameAsStore) && this.mailingAddress) {
            this.mailingAddress.addressVerified = true;
        }
    };
    OrderCreateFBOComponent.prototype.addressChangedByUser = function (changed) {
        this.shippingAddressChanged = changed;
        if (changed) {
            this.selectedPudoCollectionPoint = null;
        }
    };
    /**
     * @description this method will prepopulate shipping address
     * @param {string} sponsorId
     * @memberof OrderCreateFBOComponent
     */
    OrderCreateFBOComponent.prototype.prepopulateShippingAddress = function () {
        var _this = this;
        if (this.appConfig && this.appConfig.skipAddressVerification && this.mailingAddress) {
            this.mailingAddress.addressVerified = true;
        }
        var schemaCountryCode;
        if (this.checkoutConfig.isParticipatingCountryShippingEnabled && !this.isParticipatingCountrySameAsStore) {
            schemaCountryCode = this.participatingCountry.isocodeThree;
        }
        else {
            schemaCountryCode = this.countryCode;
        }
        var address = this.mailingAddress;
        if (this.liveFormPersonalInfo) {
            address.firstName = this.liveFormPersonalInfo.firstName;
            address.lastName = this.liveFormPersonalInfo.lastName;
            address.middleName = this.liveFormPersonalInfo.middleName;
            address.phoneNumber = this.liveFormPersonalInfo.phoneNumber || this.liveFormPersonalInfo.phone;
            address.phoneType = this.liveFormPersonalInfo.phoneType;
            address.email = this.liveFormPersonalInfo.email;
        }
        this.address = address;
        this.showAddressForm = false;
        this.displayPudoAddress = false;
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.enablePudoShippingSchemaUrl && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-pudo-schema-form.json?templateVersion='
                + environment.templateVersion;
        }
        else {
            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
                + environment.templateVersion;
        }
        /*this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
            + environment.templateVersion;*/
        setTimeout(function () {
            _this.address = _this.address;
            _this.showAddressForm = true;
            _this.pudoAddress = _this.address;
            _this.pudoShippingAddressInfo = _this.address;
            _this.displayPudoAddress = true;
            if (_this.orderFormGroup.value.deliveryPreference === _this.deliveryPreference.DROPSHIP) {
                _this.getPudoLocations();
            }
        }, 500);
    };
    /**
     * @description this method used for to prepoluate delais from personal info
     * @memberof OrderCreateFPCComponent
     */
    OrderCreateFBOComponent.prototype.prePopulateDetails = function () {
        var _this = this;
        if (this.liveFormPersonalInfo) {
            var address = {
                firstName: this.liveFormPersonalInfo.firstName,
                lastName: this.liveFormPersonalInfo.lastName,
                middleName: this.liveFormPersonalInfo.middleName,
                phoneNumber: this.liveFormPersonalInfo.phoneNumber || this.liveFormPersonalInfo.phone,
                phoneType: this.liveFormPersonalInfo.phoneType,
                email: this.liveFormPersonalInfo.email ? this.liveFormPersonalInfo.email : null,
                countryId: this.orderFormGroup.value.countryId
            };
            this.address = address;
        }
        this.showAddressForm = false;
        this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
            + environment.templateVersion;
        setTimeout(function () {
            _this.showAddressForm = true;
        }, 500);
    };
    /**
     * @description Clear the out of stock items and update the tax
     * @memberof OrderCreateFBOComponent
     */
    OrderCreateFBOComponent.prototype.clearOutOfStockItems = function () {
        var items = this.orderFormGroup.get('items');
        if (this.outOfStockItems && this.outOfStockItems.length) {
            var productIds = this.outOfStockItems.map(function (product) { return product.id; });
            this.removeOutOfStockItems(items, productIds);
            this.updateTotalsAndShipMethod();
            this.isSubmitted = false;
            this.outOfStockModal.close();
        }
    };
    /**
     * @description Remove out of stock items from cart items
     * @param {FormArray} items
     * @param {number[]} productIds
     * @memberof OrderCreateFBOComponent
     */
    OrderCreateFBOComponent.prototype.removeOutOfStockItems = function (items, productIds) {
        productIds.forEach(function (id) {
            var productIndex = items.value.findIndex(function (product) { return product.productId === id; });
            if (productIndex > -1) {
                items.removeAt(productIndex);
            }
        });
    };
    /**
* This method used to map communication preference
*/
    OrderCreateFBOComponent.prototype.checkContactSponsor = function () {
        var memberCommunicationPreferences = {
            email: this.orderFormGroup.value.isContactSponsor,
            phone: false
        };
        this.memberCommunicationPreferences = memberCommunicationPreferences;
    };
    /**
   * @description get Order Min Max Business Rules
   * @memberof OrderCreateFBOComponent
   */
    OrderCreateFBOComponent.prototype.getOrderRules = function () {
        var orderRulesRequest = {
            countryCode: this.selectedIsoCountryCode,
            memberTitleId: this._enrollmentCommonService.getMemberTitleId(this.orderFormGroup.controls['orderType'].value),
            orderType: MemberOrderType.Enrollment
        };
        this.getBusinessOrderRules(orderRulesRequest);
    };
    OrderCreateFBOComponent.prototype.getBusinessOrderRules = function (orderRulesRequest, userInfo, isFboUpgradeFlow) {
        var _this = this;
        this._orderService.getOrderBusinessRules(orderRulesRequest)
            .subscribe(function (response) {
            if (response) {
                _this.orderRules = response;
            }
        }, function (error) {
        });
    };
    OrderCreateFBOComponent.prototype.getFboDocuments = function (languageCode) {
        var _this = this;
        var customerTypeId = DocumentLibraryMemberId.Distributor;
        var displaySetionId = DisplaySectionId.FBO_Checkout_Page;
        this._documentService.getDocuments(Portal.Csp, customerTypeId, displaySetionId, this.countryCode, languageCode ? languageCode : this.storeDefaultLanguage)
            .subscribe(function (response) {
            if (response && response[0].body) {
                response[0].body = orderBy(response[0].body, ['documentUrl'], ['asc']);
                _this.agreementDocuments = response[0].body;
                if (_this.agreementDocuments && _this.agreementDocuments.length) {
                    _this.agreementDocuments.forEach(function (item) {
                        item.isSelected = false;
                    });
                }
            }
            else {
                var notification = _this._translatePipe.get('order.Unable to fetch Agreement Details');
                _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            }
        }, function (error) {
            var notification = _this._translatePipe.get('order.Unable to fetch Agreement Details');
            _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        });
    };
    OrderCreateFBOComponent.prototype.getFBOPermissions = function () {
        this.hasNewFBOOrderPermissions = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.MANAGE_FBO + ']'), AccessLevel.Customer_Service);
        this.hasMinimumOverrideLimit = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.overrideMinimumOrderLimitPermissions + ']'), AccessLevel.Customer_Service);
    };
    OrderCreateFBOComponent.prototype.buildForm = function () {
        this.orderFormGroup = this._enrollmentCommonService.buildForm(this._formbuilder, this.orderTypeFBO, this.items);
        this.buildPudoLocationSearchForm();
    };
    OrderCreateFBOComponent.prototype.getCountries = function () {
        var _this = this;
        this._customerService.getCountriesLookup().subscribe(function (response) {
            if (response) {
                _this.countries = response;
                _this._cacheService.set(CacheKey.COUNTRIES, _this.countries);
                _this.stores = _this.countries.filter(function (country) { return country.titanPlatformEnabled
                    && country.enrollmentEnabled && country.shopEnabled && _this.isLiveCountry(country.isocodeThree); });
                if (_this.isOrderSessionInfo) {
                    _this.orderFormGroup.controls['orderType'].setValue(_this.orderSession.orderType);
                    _this.orderTypeChange(_this.orderFormGroup.controls['orderType'].value);
                }
                _this.orderFromLookup = _this.isOrderSessionInfo ? _this.orderSession.orderFromLookup : _this.orderFromLookup;
                _this.onSelectNewFBOCreateFlow();
            }
        });
    };
    /**
     * @description this method will check Give country Titan Live Country Or Not
     * @author Akhil
     * @date 2021-09-16
     * @param {string} countryCode
     * @returns {boolean}
     * @memberof OrderCreateFBOComponent
     */
    OrderCreateFBOComponent.prototype.isLiveCountry = function (countryCode) {
        if (environment.liveCountries) {
            var liveCountries = environment.liveCountries.toLowerCase().split(',');
            if (liveCountries && liveCountries.length) {
                return liveCountries.some(function (liveCountryCode) { return liveCountryCode.toLowerCase() === countryCode.toLowerCase(); });
            }
        }
        return true;
    };
    /**
     * get States
     * getStates()
     */
    OrderCreateFBOComponent.prototype.getStates = function () {
        var _this = this;
        this._customerService.getStates().subscribe(function (response) {
            if (response) {
                _this.states = response;
            }
        });
    };
    OrderCreateFBOComponent.prototype.selectParticipatingCountry = function () {
        this.removeSessionGuid();
        this.onSelectParticipatingCountry();
    };
    OrderCreateFBOComponent.prototype.removeSessionGuid = function () {
        this._cacheService.removeSessionValue(CacheKey.SessionGuid);
    };
    OrderCreateFBOComponent.prototype.orderTypeChange = function (orderType) {
        this.mailAlreadyExist = false;
        this.orderFormGroup.controls['orderType'].setValue(orderType);
        if (!this.isOrderSessionInfo) {
            this.address = null;
            this.showSelectedShipMethod = false;
            this.orderFormGroup.controls['countryId'].setValue('');
            this.paymentComponentSettings.savedCards = [];
        }
        !this.isOrderSessionInfo ? this.clearAllTheForms(true, true, true) : this.clearAllTheForms();
        this.isDropShipOptionExist = false;
        this.isPickUpOptionExist = false;
    };
    /**
  * map the billing address fields
  */
    OrderCreateFBOComponent.prototype.mapBillingAddress = function () {
        var _this = this;
        if (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DELIVERY
            && (this.shippingAddressInfo && this.shippingAddressInfo.countryId)
            || (this.memberInfo && this.memberInfo.address && this.memberInfo.address.countryId) || (this.mailingAddress)) {
            var country = void 0;
            var address_1 = (this.memberInfo && this.memberInfo.address) || this.mailingAddress || this.shippingAddressInfo;
            this.paymentComponentSettings.billingAddress = address_1;
            if (address_1 && (address_1.stateCode === PaymentConstants.PuertoRico
                || address_1.stateCode === PaymentConstants.MarshallIslands
                || address_1.stateCode === PaymentConstants.VirginIslands)) {
                if (address_1.stateCode === PaymentConstants.MarshallIslands) {
                    country = this.countries.filter(function (x) { return x.isocodeThree.toLowerCase()
                        === address_1.stateCode.toLowerCase(); })[0];
                }
                else {
                    country = this.countries.filter(function (x) { return x.isocodeTwo.toLowerCase()
                        === address_1.stateCode.toLowerCase(); })[0];
                }
            }
            else {
                country = this.countries.filter(function (x) { return x.countryId === address_1.countryId; })[0];
            }
            this.paymentComponentSettings.billingAddress.countryCodeTwo = country ? country.isocodeTwo : '';
            this.paymentComponentSettings.billingAddress.zipCode = address_1.postalCode;
        }
        else if (this.memberInfo && this.memberInfo.address) {
            this.paymentComponentSettings.billingAddress = this.memberInfo.address;
            var country = this.countries.filter(function (x) { return x.countryId === _this.memberInfo.address.countryId; })[0];
            this.paymentComponentSettings.billingAddress.countryCodeTwo = country ? country.isocodeTwo : '';
            this.paymentComponentSettings.billingAddress.zipCode = this.memberInfo.address.postalCode;
        }
        else if (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.paymentComponentSettings.billingAddress = this.pudoAddress;
            var country = this.countries.filter(function (x) { return x.countryId === _this.pudoAddress.countryId; })[0];
            this.paymentComponentSettings.billingAddress.countryCodeTwo = country ? country.isocodeTwo : '';
            this.paymentComponentSettings.billingAddress.zipCode = this.pudoAddress.postalCode;
        }
    };
    OrderCreateFBOComponent.prototype.mapShippingAddress = function () {
        if (this.shippingAddressInfo) {
            this.paymentComponentSettings.shippingAddressDetail = this.shippingAddressInfo;
        }
    };
    OrderCreateFBOComponent.prototype.onSelectNewFBOCreateFlow = function () {
        var _this = this;
        this.memberTypeId = this._enrollmentCommonService.getMemberTypeId(this.orderFormGroup.controls['orderType'].value);
        this.stores.forEach(function (allowedCountry) {
            var countryObj = _this.countries.filter(function (country) {
                return allowedCountry.isocodeThree === country.isocodeThree;
            })[0];
            if (countryObj) {
                allowedCountry.id = countryObj.countryId;
                allowedCountry.name = countryObj.name;
                allowedCountry.isoCodeThree = countryObj.isocodeThree;
                allowedCountry.isoCodeTwo = countryObj.isocodeTwo;
            }
        });
        var countryId = this.stores.find(function (store) { return store.isocodeThree.toUpperCase() === IsoCodeThree.USA; }).id || this.stores[0].id;
        this.isOrderSessionInfo ? this.orderFormGroup.controls['countryId'].setValue(this.orderSession.countryId)
            : this.orderFormGroup.controls['countryId'].setValue(countryId);
        this.selectedCountry();
        this.disableDelivery = false;
        this.pickupDeliveryOptionAvailable = false;
        this.paymentComponentSettings.billingAddress = null;
        this.orderFormGroup.patchValue({
            deliveryPreference: DeliveryPreference.DELIVERY
        });
        this.showDropShipPersonAddressForm = false;
        this.isDropShipOptionExist = false;
        this.isPickUpOptionExist = false;
    };
    /**
     * @description
     * @date 2018-09-10
     * @memberof OrderPromotionFBOComponent
     */
    OrderCreateFBOComponent.prototype.getPersonalInfoOnInputChange = function (personalInfoFormValidated) {
        this.personalInfoFormValidated = personalInfoFormValidated;
    };
    /**
     * @description
     * @date 2018-09-10
     * @memberof OrderPromotionFBOComponent
     */
    OrderCreateFBOComponent.prototype.submitInformation = function () {
        var _this = this;
        setTimeout(function () {
            if (!_this.dataService.isEmailValidating && !_this.dataService.isGovernmentIdValidating && !_this.dataService.isVatIDValidating) {
                if (!_this._chRef['destroyed']) {
                    _this._chRef.detectChanges();
                }
            }
        }, 100);
    };
    /**
     * @description this method is used
     * to set bonus information form
     * @date 2020-10-19
     * @memberof OrderPromotionFBOComponent
     */
    OrderCreateFBOComponent.prototype.setBonusInformation = function () {
        this._personalMessageService.setSubmitBonusInfoForm(true);
    };
    OrderCreateFBOComponent.prototype.getZipCodePatterns = function () {
        var _this = this;
        this._commonService.getZipCodePatterns().subscribe(function (response) {
            var zipCodePatterns = response;
            var pattern = zipCodePatterns.filter(function (x) { return x.isoCodeThree
                === _this.selectedIsoCountryCode.toUpperCase(); })[0];
            _this.zipPattern = pattern ? pattern.zipPattern : null;
        });
        return Validators.pattern(new RegExp(this.zipPattern));
    };
    OrderCreateFBOComponent.prototype.buildPudoLocationSearchForm = function (zipCode, city, addressLine1, country, externalId) {
        if (zipCode === void 0) { zipCode = ''; }
        if (city === void 0) { city = ''; }
        if (addressLine1 === void 0) { addressLine1 = ''; }
        if (country === void 0) { country = ''; }
        if (externalId === void 0) { externalId = ''; }
        this.pudoLocationSearchForm = this._formbuilder.group({
            zipCode: [zipCode, [Validators.required, this.getZipCodePatterns()]],
            externalId: [externalId],
            city: [city, [Validators.required]],
            country: [country],
            addressLine1: [addressLine1]
        });
        var countryCode = this.selectedIsoCountryCode || '';
        this.pudoLocationSearchForm.patchValue({
            country: countryCode.toUpperCase()
        });
    };
    /**
     * @description this method is used
     * to set bonus information form
     * @date 2020-10-19
     * @memberof OrderPromotionFBOComponent
     */
    OrderCreateFBOComponent.prototype.getPersonalInfoFrom = function (personalInformation) {
        this.personalInformation = personalInformation;
        this.liveFormPersonalInfo = personalInformation;
        if (this.mailingAddress && !this.shippingAddressInfo) {
            if ((!this.participatingCountry || this.isParticipatingCountrySameAsStore) || this.checkoutConfig.isParticipatingCountryShippingEnabled) {
                this.prepopulateShippingAddress();
            }
            else {
                this.prePopulateDetails();
            }
        }
        if (this.personalInformation) {
            this.paymentComponentSettings.memberEmail = this.personalInformation.email;
        }
        this.verifyAccountExistence();
    };
    /**
     * @description this method is used
     * to set bonus information form
     * @date 2020-10-19
     * @memberof OrderPromotionFBOComponent
     */
    OrderCreateFBOComponent.prototype.getBonusInfo = function (bonusInformation) {
        this.bonusInformation = bonusInformation;
        if (this.bonusInformation) {
            this.isSubmitted = false;
        }
    };
    OrderCreateFBOComponent.prototype.selectedAgreements = function (agreement) {
        var agreementObj = this.bonusInfoAgreements.find(function (agreement) { return agreement.documentLibraryId === agreement.documentLibraryId; });
        if (agreementObj) {
            agreementObj.isSelected = !agreementObj.isSelected;
            if (agreementObj.isSelected) {
                this.displayIBANAckError = false;
            }
        }
    };
    OrderCreateFBOComponent.prototype.getBonusInfoOnInputChange = function (bonusInfoFormValidated) {
        var _this = this;
        this.bonusInfoFormValidated = bonusInfoFormValidated;
        var IBANNumber;
        this._messageService.accountNumber.subscribe(function (accountNumber) {
            if (!accountNumber) {
                _this.displayIBANAckError = false;
            }
            IBANNumber = accountNumber ? accountNumber : '';
            _this.disableBonusInfoChecks = IBANNumber ? false : true;
        });
    };
    /**
     * @description this method is used
     * to get selected sponsorinfo from sposor component
     * @memberof OrderCreateFBOComponent
     */
    OrderCreateFBOComponent.prototype.getSelectedSponserInfo = function (sponsorInformation) {
        this.sponsorInformation = sponsorInformation;
        if (this.sponsorInformation) {
            this.isSubmitted = false;
        }
        else {
            this.isSubmitted = true;
        }
    };
    /**
     * @description to rebind the selected sponsor wizard options and values
     * @param {string} requestUrl
     * @memberof OrderCreateFBOComponent
     */
    OrderCreateFBOComponent.prototype.rebindSponsorOptions = function (rebindSponsorData) {
        this.rebindSponsorData = rebindSponsorData;
    };
    OrderCreateFBOComponent.prototype.getDepositFeeProduct = function (searchProduct, loadProducts) {
        var _this = this;
        var depositFeeProduct = null;
        var productAssociation = this.productAssociationInfo.find(function (x) { return x.productId === searchProduct.id; });
        if (productAssociation) {
            depositFeeProduct = this.depsoitFeeProductsInfo.find(function (x) { return x.id === productAssociation.depositFeeProductId; });
            if (depositFeeProduct) {
                depositFeeProduct.productQuantity = 1;
                if (!loadProducts) {
                    this.onItemSelect(false, depositFeeProduct);
                }
            }
        }
        else {
            this._customerService.getRelatedProducts(this.storeId, searchProduct.id, 2, MemberTypeId.DISTRIBUTOR, this.countryCode, this.storeDefaultLanguage, PurchaseFlows.ENROLLMENT, this.storeInfo.taxInclusive, false, false)
                .subscribe(function (response) {
                if (response && response.length) {
                    depositFeeProduct = response[0];
                    var depositFeeProductInfo = _this.depsoitFeeProductsInfo.find(function (x) { return x.id === depositFeeProduct.id; });
                    _this.productAssociationInfo.push({
                        productId: searchProduct.id,
                        depositFeeProductId: depositFeeProduct.id
                    });
                    if (!depositFeeProductInfo) {
                        _this.depsoitFeeProductsInfo.push(depositFeeProduct);
                    }
                    if (!loadProducts) {
                        _this.onItemSelect(false, depositFeeProduct);
                    }
                }
            });
        }
    };
    /**
     * @description auto complete search
 * @memberof OrderCreateFBOComponent
     */
    OrderCreateFBOComponent.prototype.onItemSelect = function (isFeaturePackOrEnrollmentKit, depositFeeProduct) {
        var _this = this;
        var searchProduct;
        if (isFeaturePackOrEnrollmentKit) {
            var productId_2 = parseInt(this.orderFormGroup.controls['fboEligibleProducts'].value);
            searchProduct = this.featuredPacks.find(function (pack) { return pack.id === productId_2; });
            if (!searchProduct) {
                searchProduct = this.enrollmentKits.find(function (enrollmentProduct) { return enrollmentProduct.id === productId_2; });
            }
            this.fboEligibleProducts = searchProduct;
            if (searchProduct && searchProduct.display && searchProduct.display.fboEligible && searchProduct.productTypeMasterId !== ProductType.Variable) {
                this.isFBOEnrollmentEligible = true;
                this.selectedFboEligibleProduct = true;
            }
            if (searchProduct && searchProduct.productTypeMasterId === ProductType.Variable) {
                this.showOptions = true;
                if (searchProduct.options && searchProduct.options.length > 0) {
                    this.options = searchProduct.options.filter(function (option) { return option.name != null && option.productOptionValueMasterId != null; });
                    for (var i = 0; i < this.options.length; i++) {
                        this.optionValues = this.options[i].values;
                        this.optionName = this.options[i].name;
                    }
                    if (searchProduct.optionCombinationValues && searchProduct.optionCombinationValues.length > 0) {
                        this.optionCombinationValues = searchProduct.optionCombinationValues;
                    }
                }
                else {
                    this.showOptions = false;
                    this.optionValues = [];
                    var fboEligibleNotification = this._translatePipe.get('order.Selected product is not available. Please try different product');
                    this._commonService.createNotification('', fboEligibleNotification.value, NotificationType.ERROR);
                }
                return;
            }
            this.orderFormGroup.controls['fboEligibleProducts'].setValue('');
        }
        else {
            searchProduct = depositFeeProduct ? depositFeeProduct : this.orderFormGroup.controls['itemSearch'].value;
        }
        if (searchProduct && searchProduct.id) {
            var isStockAvailable = this._enrollmentCommonService.stockAvailable(searchProduct);
            if (isStockAvailable) {
                var items_2 = this.orderFormGroup.get('items');
                if (items_2 && items_2.length >= 0) {
                    this.taxCalculationStatus = true;
                    var sameProductIndex = items_2.controls.findIndex(function (item) {
                        return item.controls['productNumber'].value === searchProduct.itemNumber;
                    });
                    var isDepositFeeProductEnabled = searchProduct.productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED && x.metaKeyWords === '1'; });
                    if (isDepositFeeProductEnabled) {
                        this.getDepositFeeProduct(searchProduct);
                    }
                    if (sameProductIndex >= 0) {
                        if (+items_2.controls[sameProductIndex].controls['quantity'].value < 999 &&
                            (this.appConfig && !this.appConfig.displayOnlyEnrollmentItem)) {
                            items_2.controls[sameProductIndex].controls['quantity'].setValue(+items_2.controls[sameProductIndex].controls['quantity'].value + 1);
                            this.updateTotalsAndShipMethod();
                            this.orderFormGroup.controls['itemSearch'].setValue('');
                            this.setFocusbyID('quantity-' + (sameProductIndex));
                            items_2.controls[sameProductIndex].controls['disableDecrement'].setValue(false);
                        }
                    }
                    else {
                        this.addItemNumber();
                        var fboEligibilty = searchProduct.productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.DISTRIBUTORELIGIBLE; });
                        if (fboEligibilty && fboEligibilty.metaKeyWords === '1') {
                            searchProduct.display.fboEligible = true;
                            this.isFBOEnrollmentEligible = true;
                            this.selectedFboEligibleProduct = true;
                            var fboEligibleNotification = this._translatePipe.get('order.Selected product is 2CC eligible');
                            this._commonService.createNotification('', fboEligibleNotification.value, NotificationType.INFO);
                        }
                        var index = (items_2.length - 1);
                        items_2.controls[index].controls['quantity'].setValidators([Validators.required]);
                        if (!items_2.controls[index].controls['quantity'].value) {
                            items_2.controls[index].controls['quantity'].setValue(1);
                        }
                        items_2.controls[index].controls['quantity'].updateValueAndValidity();
                        if (this.orderFormGroup.controls['itemSearch'].value) {
                            var typHeadItem = this.orderFormGroup.controls['itemSearch'].value;
                            this.orderFormGroup.controls['itemSearch'].setValue('');
                            items_2 = this._enrollmentCommonService.addNewProductItem(items_2, index, typHeadItem, environment.uiTemplateBaseUrl, environment.cdnURL, this.appConfig && this.appConfig.displayOnlyEnrollmentItem ? this.appConfig.displayOnlyEnrollmentItem
                                : false);
                        }
                        else {
                            items_2 = this._enrollmentCommonService.addNewProductItem(items_2, index, searchProduct, environment.uiTemplateBaseUrl, environment.cdnURL, this.appConfig && this.appConfig.displayOnlyEnrollmentItem ? this.appConfig.displayOnlyEnrollmentItem
                                : false);
                        }
                        clearTimeout(this.clickTimeout[items_2.controls[index].controls['productId'].value]);
                        this.updateTotalsAndShipMethod(false);
                        this.clickTimeout[items_2.controls[index].controls['productId'].value] =
                            setTimeout(function () {
                                //New logic to bind promtoion product from promotion engine
                                var freeProductsInfo = _this.validatePromotionCriteria(searchProduct);
                                var productIds = _this._commonService.updateCartAfterPromotion(freeProductsInfo, items_2, _this.orderFormGroup, _this.promotionIds);
                                //const productIds: number[] = freeProductsInfo.map((product) => product = product.productId);
                                if (productIds && productIds.length) {
                                    _this.addPromotionEngineProducts(productIds, freeProductsInfo);
                                }
                                else {
                                    _this.updateTotalsAndShipMethod();
                                }
                            }, 500);
                        this.isFocused = true;
                        this.setFocusbyID('quantity-' + (items_2.length - 1));
                    }
                }
            }
            else {
                this._commonService.createNotification('', 'Out of stock - '
                    + (this.orderFormGroup.controls['itemSearch'].value.name || ''), NotificationType.ERROR);
                this.orderFormGroup.controls['itemSearch'].setValue('');
                setTimeout(function () {
                    if (_this.seachItemElement && _this.seachItemElement.nativeElement) {
                        _this.seachItemElement.nativeElement.focus();
                    }
                }, 500);
            }
        }
    };
    OrderCreateFBOComponent.prototype.productOptionSelected = function () {
        var _this = this;
        var productId = parseInt(this.orderFormGroup.controls['productOptions'].value);
        var optionProductDetail = this.optionValues.filter(function (selectedOption) { return selectedOption.id === productId; });
        var selectedProd = this.optionCombinationValues.filter(function (optionCombo) { return optionCombo['' + _this.optionName] === optionProductDetail[0].name; });
        if (selectedProd && selectedProd[0]) {
            this.addProductOption(selectedProd[0].productId);
        }
    };
    OrderCreateFBOComponent.prototype.addProductOption = function (optionProduct) {
        var _this = this;
        var items = this.orderFormGroup.get('items');
        var notification = this._translatePipe.get('order.Invalid Item Number');
        var productIds = [];
        productIds.push(optionProduct);
        if (items && items.length >= 0) {
            var sameProductIndex = items.controls.findIndex(function (item) {
                return item.controls['productId'].value === parseInt(optionProduct);
            });
            if (sameProductIndex < 0) {
                this._orderService.getProductsByIds(productIds, this.storeDefaultLanguage, this.storeInfo.id, this.getMemberTitleId(), this._enrollmentCommonService.getPurchaseFlow(this.orderFormGroup.controls['orderType'].value), this.selectedIsoCountryCode, false, false, this.storeInfo.taxInclusive).subscribe(function (products) {
                    if (products && products.length > 0) {
                        var product = products[0];
                        if (items && items.length >= 0) {
                            _this.addItemNumber();
                            var index = (items.length - 1);
                            items.controls[index].controls['quantity'].setValidators([Validators.required]);
                            if (!items.controls[index].controls['quantity'].value) {
                                items.controls[index].controls['quantity'].setValue(1);
                            }
                            items.controls[index].controls['quantity'].updateValueAndValidity();
                            items = _this._enrollmentCommonService.addNewProductItem(items, index, product, environment.uiTemplateBaseUrl, environment.cdnURL);
                            _this.setFocusbyID('quantity-' + (items.length - 1));
                            var fboEligibilty = product.productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.DISTRIBUTORELIGIBLE; });
                            if (fboEligibilty && fboEligibilty.metaKeyWords === '1') {
                                product.display.fboEligible = true;
                                _this.isFBOEnrollmentEligible = true;
                                _this.selectedFboEligibleProduct = true;
                                var fboEligibleNotification = _this._translatePipe.get('order.Selected product is 2CC eligible');
                                _this._commonService.createNotification('', fboEligibleNotification.value, NotificationType.INFO);
                            }
                        }
                        _this.updateTotalsAndShipMethod();
                        _this.orderFormGroup.controls['fboEligibleProducts'].setValue('');
                        _this.orderFormGroup.controls['productOptions'].setValue('');
                        _this.showOptions = false;
                    }
                    else {
                        if (_this.itemLevelSearch && _this.itemLevelSearch.nativeElement) {
                            _this.itemLevelSearch.nativeElement.focus();
                        }
                        _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                    }
                    _this.itemLevelSearch.nativeElement.value = '';
                });
            }
            else {
                if (+items.controls[sameProductIndex].controls['quantity'].value < 999) {
                    var product = items.controls[sameProductIndex].controls['productItem'].value;
                    items.controls[sameProductIndex].controls['quantity'].setValue(+items.controls[sameProductIndex].controls['quantity'].value + 1);
                    this.orderFormGroup.controls['itemSearch'].setValue('');
                    this.setFocusbyID('quantity-' + (sameProductIndex));
                    this.updateTotalsAndShipMethod();
                    this.orderFormGroup.controls['fboEligibleProducts'].setValue('');
                    this.orderFormGroup.controls['productOptions'].setValue('');
                    this.showOptions = false;
                    if (this.itemLevelSearch && this.itemLevelSearch.nativeElement) {
                        this.itemLevelSearch.nativeElement.focus();
                    }
                }
                this.itemLevelSearch.nativeElement.value = '';
            }
        }
    };
    OrderCreateFBOComponent.prototype.setFocusbyID = function (id) {
        setTimeout(function () {
            var element = document.getElementById(id);
            if (element) {
                element.focus();
                element.select();
            }
        }, 500);
    };
    OrderCreateFBOComponent.prototype.addItemNumber = function () {
        this.items = this.orderFormGroup.get('items');
        this.items.push(this.createItemNumberGroup());
    };
    /**
 * create item number
 * createItemNumberGroup()
 * @returns FormGroup
 * @memberof OrderCreateFBOComponent
 */
    OrderCreateFBOComponent.prototype.createItemNumberGroup = function () {
        return this._enrollmentCommonService.createItemNumberGroup(this._formbuilder);
    };
    /**
    * @description this method will calculate shipping cost that has to be used for calculating order summary
    * @memberof OrderCreateFBOComponent
    */
    OrderCreateFBOComponent.prototype.getShippingCostForOrderSummary = function () {
        var shippingCostWaived = this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.isWaiveShippingCost ?
            this.shippingAddressInfoConfig.isWaiveShippingCost : false;
        var isVATRegistered = (this.bonusInformation && this.bonusInformation.vatId) || (this.checkoutConfig && this.checkoutConfig.vatInPersonalInfo && this.personalInformation && this.personalInformation.vatId) ? true : false;
        this.itemShippingCost = this._enrollmentCommonService.getShippingCostForOrderSummary(this.shippingCost, this.shippingTax, this.orderFormGroup, shippingCostWaived, isVATRegistered, (this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice), this.appConfig, true);
        return this.itemShippingCost;
    };
    /**
     * get shipping cost in percentage
     */
    OrderCreateFBOComponent.prototype.getShippingCostInPercentage = function () {
        var shippingOriginalCost = this.originalShippingCost;
        if (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.firstOption.toString()) {
            if (this.appConfig && this.appConfig.enableVatItemizationForNonVat) {
                this.shippingCost = this.orderFormGroup.controls['originalShippingCost'].value - this.orderFormGroup.controls['originalShippingTax'].value;
            }
            else {
                this.shippingCost = (this.bonusInformation && this.bonusInformation.vatId) || (this.checkoutConfig && this.checkoutConfig.vatInPersonalInfo && this.personalInformation && this.personalInformation.vatId)
                    ? this.orderFormGroup.controls['originalShippingCost'].value : this.orderFormGroup.controls['originalShippingCost'].value - this.orderFormGroup.controls['originalShippingTax'].value;
            }
            this.shippingTax = this.orderFormGroup.controls['originalShippingTax'].value;
        }
        else if (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.secondOption.toString()) {
            this.shippingCost = this.orderFormGroup.controls['shippingCost'].value;
            if (this.shippingCost === 0) {
                this.shippingTax = 0;
            }
        }
        else if (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.thirdOption.toString()) {
            var discountPercentage = this.orderFormGroup.controls['shippingCostPercentage'].value || 0;
            // if(this.appConfig && this.appConfig.enableVatItemizationForNonVat){
            //     shippingOriginalCost= this.originalShippingCost - this.originalShippingTax;
            //    }
            shippingOriginalCost = (this.bonusInformation && this.bonusInformation.vatId) || (this.checkoutConfig && this.checkoutConfig.vatInPersonalInfo && this.personalInformation && this.personalInformation.vatId) ? this.originalShippingCost : this.originalShippingCost - this.originalShippingTax;
            var shippingcost = +shippingOriginalCost * (100 - (+discountPercentage)) / 100;
            this.shippingCost = shippingcost;
            if (discountPercentage === 0) {
                this.shippingTax = this.originalShippingTax;
                this.shippingCost = (this.bonusInformation && this.bonusInformation.vatId) || (this.checkoutConfig && this.checkoutConfig.vatInPersonalInfo && this.personalInformation && this.personalInformation.vatId) ? this.originalShippingCost
                    : this.originalShippingCost - this.originalShippingTax;
            }
            else if (discountPercentage === 100) {
                this.shippingTax = 0;
            }
        }
        this.shippingCost = this._currencyPipe.getFormatedCurrency(this.shippingCost, this.storeInfo);
        this.getShippingCost();
    };
    /**
    *
    * @param items
    */
    OrderCreateFBOComponent.prototype.getItemVolumeSum = function (items) {
        return this._enrollmentCommonService.getItemVolumeSum(items);
    };
    OrderCreateFBOComponent.prototype.calculateOrderTotal = function () {
        var requestObject = {
            products: this.products,
            memberInfo: null,
            countryTaxInclusive: this.countryTaxInclusive,
            storeInfo: this.storeInfo,
            checkoutConfig: this.checkoutConfig,
            importFeeValue: this.importFeeValue,
            taxableAmount: this.taxableAmount,
            orderFormGroup: this.orderFormGroup,
            shippingCost: this.shippingCost,
            shippingTax: (this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice) ? 0 : this.shippingTax,
            isShippingCostWaived: this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.isWaiveShippingCost ?
                this.shippingAddressInfoConfig.isWaiveShippingCost : false,
            isVATRegistered: (this.bonusInformation && this.bonusInformation.vatId) || (this.checkoutConfig && this.checkoutConfig.vatInPersonalInfo && this.personalInformation && this.personalInformation.vatId) ? true : false,
            isEnableVATCalculation: this.appConfig && this.appConfig.enableVATCalculation === true ? true : false,
            calculateTaxExclusivePrice: (this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice) ? true : false,
            appConfig: this.appConfig,
            isFbo: true
        };
        this.totalCost = this._enrollmentCommonService.calculateOrderTotal(requestObject, this.iscalculateTax);
        this.itemTotal = this.totalCost - this.itemShippingCost;
        return this.totalCost;
    };
    /**
     * @description item number search in table
     * @param {*} event
     * @memberof OrderCreateFBOComponent
     */
    OrderCreateFBOComponent.prototype.itemLevelSearchEvent = function (event) {
        var _this = this;
        if (event && event.currentTarget.value) {
            this.taxCalculationStatus = true;
            this.observableSource(event.currentTarget.value, true).subscribe(function (products) {
                var responseproducts = products;
                if (responseproducts && responseproducts.length > 0) {
                    var product_2 = responseproducts[0];
                    var isStockAvailable = _this._enrollmentCommonService.stockAvailable(product_2);
                    var productIndex = -1;
                    if (isStockAvailable) {
                        var items_3 = _this.orderFormGroup.get('items');
                        if (items_3 && items_3.length >= 0) {
                            var sameProductIndex = items_3.controls.findIndex(function (item) {
                                return item.controls['productNumber'].value === product_2.itemNumber;
                            });
                            productIndex = sameProductIndex;
                            if (sameProductIndex >= 0) {
                                if (+items_3.controls[sameProductIndex].controls['quantity'].value < 999) {
                                    items_3.controls[sameProductIndex].controls['quantity']
                                        .setValue(+items_3.controls[sameProductIndex].controls['quantity'].value + 1);
                                    _this.setFocusbyID('quantity-' + (sameProductIndex));
                                }
                            }
                            else {
                                _this.addItemNumber();
                                var fboEligibilty = product_2.productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.DISTRIBUTORELIGIBLE; });
                                if (fboEligibilty && fboEligibilty.metaKeyWords === '1') {
                                    product_2.display.fboEligible = true;
                                    _this.isFBOEnrollmentEligible = true;
                                    _this.selectedFboEligibleProduct = true;
                                    var fboEligibleNotification = _this._translatePipe.get('order.Selected product is 2CC eligible');
                                    _this._commonService.createNotification('', fboEligibleNotification.value, NotificationType.INFO);
                                }
                                var index = (items_3.length - 1);
                                productIndex = index;
                                items_3.controls[index].controls['quantity'].setValidators([Validators.required]);
                                if (!items_3.controls[index].controls['quantity'].value) {
                                    items_3.controls[index].controls['quantity'].setValue(1);
                                }
                                items_3.controls[index].controls['quantity'].updateValueAndValidity();
                                items_3 = _this._enrollmentCommonService.addNewProductItem(items_3, index, product_2, environment.uiTemplateBaseUrl, environment.cdnURL);
                                _this.setFocusbyID('quantity-' + (items_3.length - 1));
                            }
                        }
                        var isDepositFeeProductEnabled = product_2.productMetaData.find(function (x) { return x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED && x.metaKeyWords === '1'; });
                        if (isDepositFeeProductEnabled) {
                            _this.getDepositFeeProduct(product_2);
                        }
                        _this.updateTotalsAndShipMethod(false);
                        //New Promotion Engine logic
                        _this.clickTimeout[items_3.controls[productIndex].controls['productId'].value] =
                            setTimeout(function () {
                                //New logic to bind promtoion product from promotion engine
                                var freeProductsInfo = _this.validatePromotionCriteria(product_2);
                                var productIds = _this._commonService.updateCartAfterPromotion(freeProductsInfo, items_3, _this.orderFormGroup, _this.promotionIds);
                                //const productIds: number[] = freeProductsInfo.map((product) => product = product.productId);
                                if (productIds && productIds.length) {
                                    _this.addPromotionEngineProducts(productIds, freeProductsInfo);
                                }
                                else {
                                    _this.updateTotalsAndShipMethod();
                                }
                            }, 500);
                    }
                    else {
                        _this._commonService.createNotification('', 'Out of stock - '
                            + (product_2.name || ''), NotificationType.ERROR);
                        if (_this.itemLevelSearch && _this.itemLevelSearch.nativeElement) {
                            _this.itemLevelSearch.nativeElement.focus();
                        }
                        _this.taxCalculationStatus = false;
                    }
                }
                else {
                    if (_this.itemLevelSearch && _this.itemLevelSearch.nativeElement) {
                        _this.itemLevelSearch.nativeElement.focus();
                    }
                    var notification = _this._translatePipe.get('order.Invalid Item Number');
                    _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                }
                _this.itemLevelSearch.nativeElement.value = '';
            });
        }
    };
    /**
     * @description This method used to get form controls for product line items
     * getFormControls()
     * @memberof OrderCreateFBOComponent
     */
    OrderCreateFBOComponent.prototype.getFormControls = function () {
        var items = this.orderFormGroup.get('items');
        return items.controls;
    };
    /**
* Delivery Preference On Change
* @param value delivery preference
*/
    OrderCreateFBOComponent.prototype.deliveryPreferenceOnChange = function () {
        this.deliveryPreferenceType = this.orderFormGroup.value.deliveryPreference;
        this.taxCalculationStatus = true;
        this.taxableAmount = 0;
        this.retailDeliveryFee = 0;
        this.orderTaxResponse = null;
        this.shippingAddressChanged = false;
        this.dropShipAddress = null;
        this.dropLoactionSelected = false;
        if (this.countryCode.toUpperCase() == IsoCodeThree.USA && this.deliveryPreferenceType === ShippingType.DELIVERY && this.enableNexioPaymentForPickUpCenter) {
            this.getDeliveryOptionsPayment();
        }
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.enablePudoShippingSchemaUrl && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-pudo-schema-form.json?templateVersion='
                + environment.templateVersion;
        }
        else {
            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
                + environment.templateVersion;
        }
        if (this.shippingAddressInfoConfig && (this.shippingAddressInfoConfig.pudoLocationsEnabled || this.isDropShipOptionExist) && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.showPudoPickupPersonAddressForm = true;
            this.displayPudoAddress = true;
        }
        else if (this.shippingAddressInfoConfig && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.PICKUP) {
            this.showPudoPickupPersonAddressForm = true;
            this.displayPudoAddress = true;
        }
        else {
            this.showPudoPickupPersonAddressForm = false;
            this.displayPudoAddress = false;
        }
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.showDropShipPersonAddressForm = true;
            this.displayDropAddress = true;
        }
        else {
            this.showDropShipPersonAddressForm = false;
        }
        this.getShipMethods();
        this.validationsOnDeliveryPreference();
        this.clearPudoLocationSearchData();
    };
    /**
     * update validations on delivery preference
     */
    OrderCreateFBOComponent.prototype.validationsOnDeliveryPreference = function () {
        if (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.PICKUP) {
            this.shippingAddressInfo = null;
            this.orderFormGroup.controls['shipMethodId'].setValue('');
            this.orderFormGroup.controls['shippingCostSelector'].disable();
            this.orderFormGroup.controls['deliveryPreference'].updateValueAndValidity();
            this.getShipMethods(true);
        }
        else if (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DELIVERY) {
            this.selectedPickup = undefined;
            this.orderFormGroup.controls['shippingCostSelector'].enable();
            this.shippingAddressSelectionChange();
            this.shipMethod = {};
            this.updateTotalsAndShipMethod();
        }
        else if (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.orderFormGroup.controls['deliveryPreference'].updateValueAndValidity();
            this.shippingAddressSelectionChange();
            this.updateTotalsAndShipMethod();
            this.pudoShippingMethod = this.orderSession && this.orderSession.pudoShippingMethod ? this.orderSession.pudoShippingMethod : this.pudoShippingMethod;
            if (this.orderSession && this.orderSession.buildPudoLocationSearchForm) {
                this.pudoLocationSearchForm.controls['zipCode'].setValue(this.orderSession.buildPudoLocationSearchForm.zipCode);
                this.pudoLocationSearchForm.controls['city'].setValue(this.orderSession.buildPudoLocationSearchForm.city);
                this.pudoLocationSearchForm.controls['externalId'].setValue(this.orderSession.buildPudoLocationSearchForm.externalId);
                this.pudoLocationSearchForm.controls['zipCode'].updateValueAndValidity();
                this.pudoLocationSearchForm.controls['city'].updateValueAndValidity();
                this.pudoLocationSearchForm.controls['externalId'].updateValueAndValidity();
                if (this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                    this.showPudoPickupPersonAddressForm = true;
                    this.displayPudoAddress = true;
                }
                else if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                    this.showDropShipPersonAddressForm = true;
                    this.displayDropAddress = true;
                    this.pudoShippingAddressInfo = this.orderSession.pudoShippingAddressInfo ? this.orderSession.pudoShippingAddressInfo : null;
                }
                this.pudoAddress = this.orderSession.pudoaddress ? this.orderSession.pudoaddress : this.pudoAddress;
            }
            this.selectedPudoCollectionPoint = this.orderSession && this.orderSession.selectedPudoCollectionPoint ? this.orderSession.selectedPudoCollectionPoint : this.selectedPudoCollectionPoint;
            // this.getPudoLocations();
        }
    };
    OrderCreateFBOComponent.prototype.shippingAddressSelectionChange = function () {
        this.shippingAddressInfo = this.address && this.address.isSavedAddress ? this.address : null;
        this.address = this.address && this.address.isSavedAddress ? this.address : null;
        this.getShipMethods();
    };
    /**
 * Get Ship Methods By Products and Store
 */
    OrderCreateFBOComponent.prototype.getShipMethods = function (isDeliveryOptionChange) {
        var _this = this;
        if (isDeliveryOptionChange === void 0) { isDeliveryOptionChange = false; }
        var shippingOptions;
        var items;
        this.taxCalculationStatus = true;
        this.shippingMethods = [];
        this.shippingCost = 0;
        this.importFeeValue = 0;
        this.showSelectedShipMethod = false;
        this.shipMethodValidation = null;
        this.restrictedProducts = [];
        this.orderFormGroup.controls['shipMethodId'].setValidators([Validators.required]);
        this.orderFormGroup.controls['shipMethodId'].updateValueAndValidity();
        this.orderFormGroup.controls['shipMethodId'].setValue('');
        this.orderFormGroup.controls['shippingCost'].setValidators([Validators.required, Utils.amountValidation]);
        this.orderFormGroup.controls['shippingCost'].updateValueAndValidity();
        this.orderFormGroup.controls['shippingCost'].setValue('');
        if (!this.pudoShippingAddressInfo) {
            this.getPudoPickupPersonAddress();
        }
        if (this.storeInfo && this.products && this.products.length > 0
            && (this.shippingAddressInfo || this.shippingAddressInfoConfig)) {
            if (this.orderFormGroup.value.deliveryPreference === ShippingType.PICKUP && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                shippingOptions = this.prepareShippingOptionsRequest();
                if (!shippingOptions.toAddress && this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                    shippingOptions.toAddress = this._enrollmentCommonService.getWarehouseAddress(this.storeInfo, this.selectedIsoCountryCode);
                }
            }
            if (this.orderFormGroup.value.deliveryPreference === ShippingType.DROPSHIP) {
                shippingOptions = this.prepareShippingOptionsRequest();
                if (!shippingOptions.toAddress) {
                    shippingOptions.toAddress = this._enrollmentCommonService.getWarehouseAddress(this.storeInfo, this.selectedIsoCountryCode);
                }
            }
            if (this.orderFormGroup.value.deliveryPreference === ShippingType.DELIVERY || this.orderFormGroup.value.deliveryPreference === ShippingType.PICKUP) {
                shippingOptions = this.prepareShippingOptionsRequest();
                if (!shippingOptions.toAddress && this.shippingAddressInfoConfig) {
                    shippingOptions.toAddress = this._enrollmentCommonService.getWarehouseAddress(this.storeInfo, this.selectedIsoCountryCode);
                }
            }
            // const shippingOptions: ShippingOptionsRequest = {
            //     productModels: this._enrollmentCommonService.getProductModels(this.products),
            //     orderSourceId: OrderSourceType.Web,
            //     languageCode: this.storeDefaultLanguage,
            //     orderTypeId: ShippingOrderType.Personal,
            //     fromAddress: this._enrollmentCommonService.getWarehouseAddress(this.storeInfo, this.selectedIsoCountryCode),
            //     toAddress: this.orderFormGroup.value.deliveryPreference ===
            //         this.deliveryPreference.DELIVERY ?
            //         this._enrollmentCommonService.getShippingAddress(this.shippingAddressInfo, this.selectedCountryCodeTwo, this.orderFormGroup.value.saveForFutureUse) : {},
            //     storeId: this.storeInfo.id,
            //     requestID: 2, // for now we are using two once config is done we will drive from enum
            //     memberTypeId: ShippingMemberType.DISTRIBUTOR,
            //     priceTypeId: this._enrollmentCommonService.getPriceTypeId(),
            //     memberLevelId: ShippingMemberTitle.ASSISTANTMANAGER,
            //     orderSubTotal: this.calculateItemsSubTotal(this.storeInfo),
            //     orderCaseCredits: this.totalCommissionableVolume,
            //     purchaseFlowId: PurchaseFlowType.WholeSale,
            //     shippingTypeId: this.orderFormGroup.value.deliveryPreference ===
            //         this.deliveryPreference.DELIVERY ? ShippingType.DELIVERY : ShippingType.PICKUP,
            //     storeHomeCountryCode: this.selectedIsoCountryCode,
            //     vatInclusive: this.bonusInformation && this.bonusInformation.vatId ? true : false,
            //     initialOrder: true,
            //     vatRegistered: this.bonusInformation && this.bonusInformation.vatId ? true : false
            // };
            this._orderService.getShipmentService(shippingOptions).subscribe(function (response) {
                if (response && response.shippingMethods && response.shippingMethods.length > 0) {
                    if (_this.shippingAddressInfo || (_this.shippingAddressInfoConfig && (_this.shippingAddressInfoConfig.pudoLocationsEnabled || _this.shippingAddressInfoConfig.dropShipLocationsEnabled)) || (_this.orderFormGroup.value.deliveryPreference === ShippingType.PICKUP || _this.orderFormGroup.value.deliveryPreference === ShippingType.DROPSHIP)) {
                        _this.shipMethods = response;
                        _this.shippingMethods = response.shippingMethods;
                        //Process the free shipping based on promotions
                        items = _this.orderFormGroup.get('items') ? _this.orderFormGroup.get('items') : null;
                        _this._commonService.applyPromotionFreeShipping(_this.shippingMethods, _this.promotionModels, _this.items, _this.totalCommissionableVolume);
                        _this.importFeeEnabled = response.importFeeEnabled;
                        if (_this.shippingMethods.length > 0) {
                            _this.shippingMethods.forEach(function (shipMethod) {
                                if (shipMethod.shippingCharge && shipMethod.shippingCharge > shipMethod.shippingTax) {
                                    shipMethod.shippingCharge = shipMethod.shippingCharge - shipMethod.shippingTax;
                                }
                                else {
                                    shipMethod.shippingCharge = 0;
                                }
                                shipMethod.shippingCharge = _this._currencyPipe
                                    .getFormatedCurrency(shipMethod.shippingCharge, _this.storeInfo);
                                shipMethod.importFeeEnabled = response.importFeeEnabled;
                            });
                            if (_this.isOrderSessionInfo) {
                                _this.orderFormGroup.patchValue({
                                    shippingCostSelector: _this.orderSession.shippingCostSelector,
                                    originalShippingCost: _this.orderSession.originalShippingCost,
                                    shipMethodId: _this.orderSession.shipMethodId,
                                    shippingCost: _this.orderSession.shippingCost,
                                    shippingCostPercentage: _this.orderSession.shippingCostPercentage,
                                    isShippingDiscountApplied: _this.orderSession.isShippingDiscountApplied
                                });
                                var shipMethodId_1 = _this.orderFormGroup.value.shipMethodId;
                                if (shipMethodId_1 && _this.shippingMethods) {
                                    var shippingObj = _this.shippingMethods.filter(function (shipMethod) { return shipMethod.shippingMethodId === +shipMethodId_1; })[0];
                                    if (shippingObj) {
                                        _this.selectShippingMethod(shippingObj, isDeliveryOptionChange);
                                        _this.getShippingCost();
                                    }
                                }
                                else {
                                    _this.orderFormGroup.patchValue({
                                        shippingCost: 0,
                                        originalShippingCost: 0,
                                        shippingCostPercentage: 0,
                                        isShippingDiscountApplied: false,
                                        originalShippingTax: 0
                                    });
                                    if (_this.shippingMethods[0].shippingMethodId) {
                                        if (_this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                                            _this.orderFormGroup.controls['shipMethodId']
                                                .setValue(_this.shippingMethods[0].shippingMethodId.toString());
                                        }
                                        else {
                                            _this.orderFormGroup.controls['shipMethodId'].setValue(_this.shippingMethods[0].shippingMethodId);
                                        }
                                        _this.selectShippingMethod(_this.shippingMethods[0], isDeliveryOptionChange);
                                    }
                                }
                            }
                            else {
                                _this.orderFormGroup.patchValue({
                                    shippingCost: 0,
                                    originalShippingCost: 0,
                                    shippingCostPercentage: 0,
                                    isShippingDiscountApplied: false,
                                    originalShippingTax: 0
                                });
                                if (_this.shippingMethods[0].shippingMethodId) {
                                    var shippingInfoObj = void 0;
                                    if (_this.shippingAddressInfoConfig && _this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                                        if (_this.orderFormGroup.value.deliveryPreference === ShippingType.DELIVERY) {
                                            shippingInfoObj = response.shippingMethods.find(function (x) { return !x.pudoEnabled; });
                                        }
                                        if (_this.orderFormGroup.value.deliveryPreference === ShippingType.DROPSHIP) {
                                            shippingInfoObj = response.shippingMethods.find(function (x) { return x.pudoEnabled; });
                                        }
                                        if (_this.selectedPickup && _this.isPickUpOptionExist && _this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                                            shippingInfoObj = _this.shippingMethods.filter(function (shipMethod) { return shipMethod.shippingMethodId === +_this.selectedPickup; })[0];
                                        }
                                        else {
                                            if (!shippingInfoObj) {
                                                shippingInfoObj = _this.shippingMethods[0];
                                            }
                                        }
                                        // if (this.orderFormGroup.value.deliveryPreference === ShippingType.DELIVERY ) {
                                        _this.pudoShippingMethod = response.shippingMethods.find(function (x) { return x.pudoEnabled; });
                                        if (!_this.pudoShippingMethod) {
                                            _this.getPudoShippingMethods(shippingOptions, response.shippingMethods, false);
                                        }
                                        else {
                                            //          this.getPudoLocations();
                                        }
                                        // }
                                        // if (this.orderFormGroup.value.deliveryPreference === ShippingType.PICKUP) {
                                        //     shippingInfoObj = this.shippingMethods[0];
                                        //     this.getPudoShippingMethods(shippingOptions, response.shippingMethods);
                                        // }
                                    }
                                    else {
                                        if (_this.selectedPickup && _this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                                            shippingInfoObj = _this.shippingMethods.filter(function (shipMethod) {
                                                return shipMethod.shippingMethodId === +_this.selectedPickup;
                                            })[0];
                                        }
                                        else {
                                            shippingInfoObj = _this.shippingMethods[0];
                                        }
                                    }
                                    if (shippingInfoObj) {
                                        if (_this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                                            _this.orderFormGroup.controls['shipMethodId']
                                                .setValue(shippingInfoObj.shippingMethodId.toString());
                                        }
                                        else {
                                            _this.orderFormGroup.controls['shipMethodId'].setValue(shippingInfoObj.shippingMethodId);
                                        }
                                        _this.selectShippingMethod(shippingInfoObj, isDeliveryOptionChange);
                                    }
                                }
                            }
                            setTimeout(function () {
                                _this.orderSession = null;
                                _this.isOrderSessionInfo = false;
                            }, 2000);
                        }
                    }
                }
                else if (response && response.productModels && response.productModels.length > 0) {
                    _this.getRestrictedProducts(response.productModels);
                }
                else if (response && response.validations.length > 0) {
                    _this.shipMethodValidation = response.validations[0];
                }
                else if (response && !(response.success)) {
                    _this.shippingMethods = [];
                    _this.shippingCost = 0;
                    _this.orderFormGroup.patchValue({
                        shippingCost: 0,
                        originalShippingCost: 0,
                        shippingCostPercentage: 0,
                        isShippingDiscountApplied: false,
                        originalShippingTax: 0
                    });
                }
                if (_this.isDropShipOptionExist && !_this.pudoShippingMethod) {
                    _this.getDropShipPudoShippingMethods(shippingOptions, response.shippingMethods, false);
                }
            }, function (error) {
                var notification = _this._translatePipe.get('order.Unable to fetch Ship Methods');
                _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            });
        }
        else {
            this.orderFormGroup.patchValue({
                shippingCost: 0,
                originalShippingCost: 0,
                shippingCostPercentage: 0,
                isShippingDiscountApplied: false,
                originalShippingTax: 0
            });
        }
    };
    // region #Start ShipMethods Section
    /**
       * on Shipping Method Change
       */
    OrderCreateFBOComponent.prototype.selectShippingMethod = function (shippingMethod, isDeliveryOptionChange) {
        if (isDeliveryOptionChange === void 0) { isDeliveryOptionChange = false; }
        if (shippingMethod) {
            if (this.countryCode == IsoCodeThree.USA && this.deliveryPreferenceType === ShippingType.PICKUP && this.enableNexioPaymentForPickUpCenter) {
                this.getPickupDetailsForUSA(shippingMethod);
            }
            if (shippingMethod && (shippingMethod.pickUpLocation && (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP))) {
                this.getProcuctRestrictions(shippingMethod, shippingMethod.pickUpLocation, isDeliveryOptionChange);
                if (this.orderFormGroup.value.shipMethodId) {
                    this.selectedPickup = this.orderFormGroup.value.shipMethodId;
                }
            }
            else {
                this.taxCalculationStatus = true;
                this.shipMethod = shippingMethod;
                this.showSelectedShipMethod = true;
                this.importFeeValue = this._currencyPipe.getFormatedCurrency(shippingMethod.importFeeValue || 0, this.storeInfo);
                this.shippingCost = this.isOrderSessionInfo && this.orderSession.shippingCostValue >= 0 ?
                    this.orderSession.shippingCostValue : shippingMethod.shippingCharge || 0;
                this.originalShippingTax = shippingMethod.shippingTax || 0;
                this.shippingTax = shippingMethod.shippingTax || 0;
                this.originalShippingCost = (this.bonusInformation && this.bonusInformation.vatId) || (this.checkoutConfig && this.checkoutConfig.vatInPersonalInfo && this.personalInformation && this.personalInformation.vatId) ? shippingMethod.shippingCharge
                    : shippingMethod.shippingCharge + this.shippingTax;
                this.orderFormGroup.patchValue({
                    originalShippingCost: this.originalShippingCost,
                    originalShippingTax: shippingMethod.shippingTax
                });
                // this.calculateOrderTax();
                if (!this.isOrderSessionInfo) {
                    this.orderFormGroup.controls['shippingCostSelector'].setValue(this.selectEnum.firstOption.toString());
                    this.shippingCostChange();
                }
                else {
                    this.getShippingCostInPercentage();
                }
                if (isDeliveryOptionChange) {
                    this.updateTotalsAndShipMethod();
                }
            }
            if (this.deliveryPreferenceType === this.deliveryPreference.PICKUP) {
                this.setPickupAddress = this._enrollmentCommonService.getPickUpAddress(shippingMethod, this.orderFormGroup.value.deliveryPreference, this.countries, this.states, this.selectedIsoCountryCode);
            }
        }
    };
    OrderCreateFBOComponent.prototype.getShippingCost = function () {
        this.calculateOrderTax();
    };
    /**
 * get restricted products
 */
    OrderCreateFBOComponent.prototype.getRestrictedProducts = function (productModels) {
        var _this = this;
        this.getShippingRestrictionError();
        this.restrictedProducts = [];
        productModels.forEach(function (product) {
            var itemNumber = product.itemNumber.substring(product.itemNumber.indexOf('#') + 1);
            var item = _this.products.find(function (productItem) { return productItem.itemNumber === itemNumber; });
            if (item) {
                _this.restrictedProducts.push(item.name + ' - #' + itemNumber);
            }
        });
        this.showRestrictedProducts.open();
    };
    OrderCreateFBOComponent.prototype.selectPudoCollectionPoint = function (collectionPoint) {
        this.dropShipAddress = null;
        this.selectedPudoCollectionPoint = collectionPoint;
        if (this.orderFormGroup.value.deliveryPreference === ShippingType.DROPSHIP) {
            this.getPudoDropShipPersonAddress(collectionPoint);
            this.dropLoactionSelected = true;
            this.getShipMethods();
        }
        this.dropLoactionSelected = false;
        this.calculateOrderTax();
    };
    OrderCreateFBOComponent.prototype.getProcuctRestrictions = function (shippingMethod, pickupAddress, isDeliveryOptionChange) {
        var _this = this;
        if (isDeliveryOptionChange === void 0) { isDeliveryOptionChange = false; }
        var productRestrictionModel = this._enrollmentCommonService.prepareProductRestrictionModelRequest(pickupAddress, this.products);
        this._commonService.getProductRestrictions(productRestrictionModel).subscribe(function (response) {
            if (response && response.success && response.productModels) {
                _this.getRestrictedProducts(response.productModels);
                _this.taxCalculationStatus = true;
            }
            else {
                _this.taxCalculationStatus = true;
                _this.shipMethod = shippingMethod;
                _this.showSelectedShipMethod = true;
                _this.importFeeValue = _this._currencyPipe.getFormatedCurrency(shippingMethod.importFeeValue || 0, _this.storeInfo);
                _this.shippingCost = _this.isOrderSessionInfo ? _this.orderSession.shippingCostValue : shippingMethod.shippingCharge || 0;
                _this.originalShippingTax = shippingMethod.shippingTax || 0;
                _this.shippingTax = shippingMethod.shippingTax || 0;
                _this.originalShippingCost = (_this.bonusInformation && _this.bonusInformation.vatId) || (_this.checkoutConfig && _this.checkoutConfig.vatInPersonalInfo && _this.personalInformation && _this.personalInformation.vatId) ? shippingMethod.shippingCharge
                    : shippingMethod.shippingCharge + _this.shippingTax;
                _this.orderFormGroup.patchValue({
                    originalShippingCost: _this.originalShippingCost,
                    originalShippingTax: shippingMethod.shippingTax
                });
                _this.calculateOrderTax();
                if (!_this.isOrderSessionInfo) {
                    _this.orderFormGroup.controls['shippingCostSelector'].setValue(_this.selectEnum.firstOption.toString());
                    _this.shippingCostChange();
                }
                else {
                    _this.getShippingCostInPercentage();
                }
                if (isDeliveryOptionChange) {
                    _this.updateTotalsAndShipMethod();
                }
            }
        });
    };
    /**
     * on chnage on shipping charge selector
     */
    OrderCreateFBOComponent.prototype.shippingCostChange = function () {
        var _this = this;
        var shippingObj = this.shippingMethods.find(function (shipMethod) { return shipMethod.shippingMethodId == _this.orderFormGroup.value.shipMethodId; });
        if (shippingObj && shippingObj.freeShippingEligible && (this.orderFormGroup.controls['shippingCostSelector'].value !== this.selectEnum.firstOption.toString())) {
            this.orderFormGroup.get('shippingCostSelector').setValue(this.selectEnum.firstOption.toString());
            var notification = this._translatePipe.get('order.Free shipping is already available for this order, No more discounts allowed');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        }
        if (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.firstOption.toString()) {
            if (this.showSelectedShipMethod) {
                this.orderFormGroup.controls['originalShippingCost'].setValue(this.originalShippingCost);
                this.orderFormGroup.controls['originalShippingTax'].setValue(this.originalShippingTax);
                this.shippingTax = this.originalShippingTax;
                this.shippingCost = (this.bonusInformation && this.bonusInformation.vatId) || (this.checkoutConfig && this.checkoutConfig.vatInPersonalInfo && this.personalInformation && this.personalInformation.vatId)
                    ? this.originalShippingCost : this.originalShippingCost - this.originalShippingTax;
            }
            else {
                this.orderFormGroup.controls['originalShippingCost'].setValue(0);
                this.orderFormGroup.controls['originalShippingTax'].setValue(0);
            }
            this.orderFormGroup.controls['originalShippingCost'].setValidators([Validators.required]);
            this.orderFormGroup.controls['shippingCost'].setValidators([]);
            this.orderFormGroup.controls['shippingCostPercentage'].setValidators([]);
            this.orderFormGroup.controls['originalShippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCostPercentage'].updateValueAndValidity();
            this.orderFormGroup.controls['isShippingDiscountApplied'].setValue(false);
        }
        else if (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.secondOption.toString()) {
            this.shippingCost = this.orderFormGroup.controls['shippingCost'].value;
            this.orderFormGroup.controls['originalShippingCost'].setValue('');
            this.orderFormGroup.controls['originalShippingCost'].setValidators([]);
            this.orderFormGroup.controls['originalShippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCost'].setValidators([Validators.required, Utils.amountValidation]);
            this.orderFormGroup.controls['shippingCostPercentage'].setValidators([]);
            this.orderFormGroup.controls['shippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCostPercentage'].updateValueAndValidity();
            this.orderFormGroup.controls['isShippingDiscountApplied'].setValue(true);
            if (this.shippingCost === 0) {
                this.shippingTax = 0;
            }
        }
        else {
            this.orderFormGroup.controls['originalShippingCost'].setValue('');
            this.orderFormGroup.controls['originalShippingCost'].setValidators([]);
            this.orderFormGroup.controls['originalShippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCost'].setValidators([]);
            this.orderFormGroup.controls['shippingCostPercentage'].setValidators([Validators.required]);
            this.orderFormGroup.controls['shippingCostPercentage'].updateValueAndValidity();
            var shippingOriginalCost = this.originalShippingCost;
            var discountPercentage = this.orderFormGroup.controls['shippingCostPercentage'].value || 0;
            shippingOriginalCost = (this.bonusInformation && this.bonusInformation.vatId) || (this.checkoutConfig && this.checkoutConfig.vatInPersonalInfo && this.personalInformation && this.personalInformation.vatId) ? this.originalShippingCost : this.originalShippingCost - this.originalShippingTax;
            var shippingcost = +shippingOriginalCost * (100 - (+discountPercentage)) / 100;
            this.shippingCost = shippingcost;
            this.orderFormGroup.controls['isShippingDiscountApplied'].setValue(true);
            if (discountPercentage === 0) {
                this.shippingTax = this.originalShippingTax;
                this.shippingCost = (this.bonusInformation && this.bonusInformation.vatId) || (this.checkoutConfig && this.checkoutConfig.vatInPersonalInfo && this.personalInformation && this.personalInformation.vatId)
                    ? this.originalShippingCost : this.originalShippingCost - this.originalShippingTax;
            }
            else if (discountPercentage === 100) {
                this.shippingTax = 0;
            }
        }
        this.shippingCost = this._currencyPipe.getFormatedCurrency(this.shippingCost, this.storeInfo);
        this.calculateOrderTax();
    };
    /**
         * @description To Show Shipping Restriction Error message
         * @private
         * @returns {string}
         * @memberof OrderCreateFBOComponent
         */
    OrderCreateFBOComponent.prototype.getShippingRestrictionError = function () {
        var _this = this;
        if (this.shippingAddressInfo
            && this.shippingAddressInfo.stateCode && this.shippingAddressInfo.countryId && this.states && this.states.length > 0) {
            var stateName = this.states.find(function (x) { return x.stateCode === _this.shippingAddressInfo.stateCode; }).stateName;
            var error = this._translatePipe.get('order.' + Translations.SHIPPING_RESTRICTION_ERROR, { stateName: stateName });
            this.productErrorMsg = error.value;
        }
        else {
            var error = this._translatePipe.get('order.Following products are not allowed for selected shipping address.');
            this.productErrorMsg = error.value;
        }
        return this.productErrorMsg;
    };
    /**
* @param  {any} shippingInfo
* @returns void
*/
    OrderCreateFBOComponent.prototype.calculateOrderTax = function () {
        var _this = this;
        this.taxCalculationStatus = true;
        this.orderTaxResponse = null;
        if (this.storeInfo && this.products && this.products.length > 0 && this.orderFormGroup.value.shipMethodId) {
            var taxRequest = this.prepareTaxRequest();
            if (taxRequest && taxRequest.fromAddress && taxRequest.toAddress) {
                this._orderService.calculateOrderTax(taxRequest)
                    .subscribe(function (taxResponse) {
                    if (taxResponse && taxResponse.success) {
                        _this.isTaxMetaDataAvailable = taxResponse.taxMetaData ? true : false;
                        if (taxResponse.cart && taxResponse.cart.totalTax >= 0) {
                            taxResponse.cart.totalTax = _this._currencyPipe.getFormatedCurrency(taxResponse.cart.totalTax, _this.storeInfo);
                            _this.orderTaxResponse = taxResponse;
                            _this.iscalculateTax = taxResponse ? true : false;
                            _this.taxableAmount = taxResponse.cart.totalTax;
                            _this.retailDeliveryFee = taxResponse.cart.retailDeliveryFee ? taxResponse.cart.retailDeliveryFee : 0;
                            if (_this.orderTaxResponse && _this.orderTaxResponse.taxMetaData
                                && _this.orderTaxResponse.taxMetaData.orderTaxCharges
                                && _this.orderTaxResponse.taxMetaData.orderTaxCharges.length > 0) {
                                var gst = _this.orderTaxResponse.taxMetaData
                                    .orderTaxCharges.find(function (tax) { return tax.taxChargeType === TaxType.GST_TAX; });
                                var pst = _this.orderTaxResponse.taxMetaData
                                    .orderTaxCharges.find(function (tax) { return tax.taxChargeType === TaxType.PST_TAX; });
                                _this.gstTax = gst ? gst.taxAmount : 0;
                                _this.pstTax = pst ? pst.taxAmount : 0;
                                if (_this.countryTaxInclusive) {
                                    var shippingLineItem = _this.orderTaxResponse.taxMetaData
                                        .orderTaxCharges.find(function (tax) { return tax.taxChargeType === TaxType.NOR && tax.lineNo === 0; });
                                    if (shippingLineItem && _this.orderFormGroup.controls['shippingCostSelector'].value != _this.selectEnum.secondOption.toString() && _this.orderFormGroup.controls['shippingCostSelector'].value != _this.selectEnum.thirdOption.toString()) {
                                        _this.shippingTax = shippingLineItem.taxAmount;
                                    }
                                }
                                if (_this.appConfig && _this.appConfig.enableVatItemizationForNonVat) {
                                    var isEnableVATCalculation = _this.appConfig && _this.appConfig.enableVATCalculation;
                                    var taxCalculated = _this.appConfig.displayTaxInclusivePrice ? false : true;
                                    _this.displayPriceConfig = _this._memberDisplayPriceConfigService
                                        .getDisplayPriceConfig(PortalDisplayPage.PlaceOrder, _this.storeInfo.taxInclusive, null, taxCalculated, _this.countryTaxInclusive, _this.storeInfo.homeIsocodeThree, isEnableVATCalculation, _this.iscalculateTax);
                                }
                            }
                        }
                        setTimeout(function () {
                            _this.taxCalculationStatus = false;
                        }, 500);
                    }
                }, function (error) {
                    if (error) {
                        var taxResponse = error;
                        if (taxResponse && taxResponse.validations && taxResponse.validations.length > 0) {
                            if ((taxResponse.validations.map(function (validation) { return validation.name; }).indexOf(CommonConstant.Order_Tax)) > -1) {
                                var notification = _this._translatePipe.get('order.Tax cannot be calculated now. Please try again later.');
                                _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                            }
                            else {
                                var notification = _this._translatePipe.get('order.' + taxResponse.validations[0].message);
                                _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                            }
                        }
                    }
                });
            }
        }
    };
    OrderCreateFBOComponent.prototype.prepareTaxRequest = function () {
        var taxRequest = {
            orderID: 0,
            memberID: 0,
            shopingCart: this.mapCartToTaxCart(),
            fromAddress: (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) ?
                this._enrollmentCommonService.getPickUpAddress(this.shipMethod, this.orderFormGroup.value.deliveryPreference, this.countries, this.states, this.selectedIsoCountryCode) : this._enrollmentCommonService.getShippingMethodWarehouseAddress(this.shipMethod),
            toAddress: (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP)
                ? this._enrollmentCommonService.getPickUpAddress(this.shipMethod, this.orderFormGroup.value.deliveryPreference, this.countries, this.states, this.selectedIsoCountryCode) : (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP) ? this.getPudoCollectPointAddress() : this._enrollmentCommonService.getShippingAddress(this.shippingAddressInfo, this.pudoShippingAddressInfo, this.selectedCountryCodeTwo, this.orderFormGroup.value, this.countries),
            memberNumber: 0,
            orderNumber: 0,
            storeID: this.storeInfo.id,
            priceTierName: this._enrollmentCommonService.getPriceTier(this.products),
            currencyCode: this.storeInfo.currencyCode,
            countryCode: this.selectedIsoCountryCode.toLowerCase(),
            deliveryTypeId: (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) ?
                ShippingType.PICKUP : ShippingType.DELIVERY,
            orderSource: 'CUSTOMER SERVICE',
            orderTypeId: this._enrollmentCommonService.getOrderTypeId(this.orderFormGroup.controls['orderType'].value),
            conversionRate: 1,
            memberLevelId: this._enrollmentCommonService.getMemberTitleId(this.orderFormGroup.controls['orderType'].value),
            wholesaleQualified: false,
            vatRegistered: (this.bonusInformation && this.bonusInformation.vatId) || (this.checkoutConfig && this.checkoutConfig.vatInPersonalInfo && this.personalInformation && this.personalInformation.vatId) ? true : false,
            isDiscountedShipping: this.orderFormGroup.value.isShippingDiscountApplied,
            memberType: MemberTypeEnum[5],
        };
        return taxRequest;
    };
    /**
      * @returns TaxCart
      */
    OrderCreateFBOComponent.prototype.mapCartToTaxCart = function () {
        var shippingCostWaived = this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.isWaiveShippingCost ?
            this.shippingAddressInfoConfig.isWaiveShippingCost : false;
        var taxCart = {
            shippingTax: 0,
            shipMethodId: this.orderFormGroup.value.shipMethodId,
            shippingCost: this._enrollmentCommonService.getTaxExclusiveShippingCost(this.shippingCost, this.orderFormGroup.value.isShippingDiscountApplied, this.orderFormGroup, shippingCostWaived),
            importFeeValue: this.importFeeValue || 0,
            importFeeEnabled: this.importFeeEnabled,
            orderLineItems: this.mapItemstoTaxItems()
        };
        return taxCart;
    };
    OrderCreateFBOComponent.prototype.getItemTotalSum = function (item) {
        return this._enrollmentCommonService.calculateSubTotal(this.storeInfo, this.countryTaxInclusive, item, this.checkoutConfig, this.appConfig, this.iscalculateTax);
    };
    /**
     * @returns CartItems
     */
    OrderCreateFBOComponent.prototype.mapItemstoTaxItems = function () {
        var address = (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP && this.shipMethod
            && this.shipMethod.pickUpLocation) ?
            this._enrollmentCommonService.getPickUpAddress(this.shipMethod, this.orderFormGroup.value.deliveryPreference, this.countries, this.states, this.selectedIsoCountryCode) :
            this._enrollmentCommonService.getShippingAddress(this.shippingAddressInfo, this.pudoShippingAddressInfo, this.selectedCountryCodeTwo, this.orderFormGroup.value, this.countries);
        if (this.products && this.products.length > 0) {
            if (address && address.countryId && this.countries && this.countries.length > 0) {
                var country = this.countries.find(function (x) { return x.countryId === address.countryId; });
                this.countryTaxInclusive = this._enrollmentCommonService.getCountryTaxInclusiveInfo(country);
            }
        }
        var mapCartToTaxCartObject = {
            products: this.products,
            countryTaxInclusive: this.countryTaxInclusive,
            checkoutConfig: this.checkoutConfig,
            address: address
        };
        return this._enrollmentCommonService.mapItemstoTaxItems(mapCartToTaxCartObject);
    };
    /**
     * Save Shipping Address
     */
    OrderCreateFBOComponent.prototype.saveShippingAddress = function (address) {
        this.address = this.mapVerifiedAddressToFormFields(address);
        address.isShowStateCode = this.checkoutConfig.showStateCode;
        if (this.memberInfo && this.orderFormGroup.controls['saveForFutureUse'].value) {
            if (!this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.DROPSHIP) {
                this.saveAddress(address);
            }
        }
        else if (this.address && this.address.isSavedAddress) {
            this.messageService.setAddressSaved(true);
        }
        if (address && address.countryId && this.countries && this.countries.length > 0) {
            var country = this.countries.find(function (x) { return x.countryId === address.countryId; });
            this.countryTaxInclusive = this._enrollmentCommonService.getCountryTaxInclusiveInfo(country);
        }
        this.useNewShippingAddress(this.address);
        setTimeout(function () {
            var addtoSavedAddressesElement = document.getElementById('addtoSavedAddresses');
            if (addtoSavedAddressesElement) {
                addtoSavedAddressesElement.focus();
            }
        }, 200);
    };
    /**
     * To Map Address
     */
    OrderCreateFBOComponent.prototype.mapVerifiedAddressToFormFields = function (address) {
        if (address) {
            var countryObj = this._enrollmentCommonService.getCountryDetailsByCountryIdOrCode(this.countries, null, address.country);
            var stateObj = this._enrollmentCommonService.getStateDetailsByStateIdOrCode(this.states, null, address.state, address.country);
            var data = {
                'saveForFutureUse': this.orderFormGroup.value.saveForFutureUse,
                'countryObj': countryObj,
                'stateObj': stateObj,
                'addressVerified': (this.appConfig && this.appConfig.skipAddressVerification) ? true : address.addressVerified
            };
            var mappedAddress = this._enrollmentCommonService.mapVerifiedAddressToFormFields(address, data);
            return mappedAddress;
        }
        return null;
    };
    /**
     * save address method
     */
    OrderCreateFBOComponent.prototype.saveAddress = function (addressDetails) {
        var _this = this;
        var saveForFutureUse = this.orderFormGroup.value.saveForFutureUse;
        var saveAddressRequest = this._enrollmentCommonService.prepareRequestToSaveAddress(this.memberInfo, addressDetails, saveForFutureUse);
        this._orderService.saveVerifiedAddress(saveAddressRequest).subscribe(function (response) {
            if (response && response.addressDetail) {
                if (_this.shippingAddressInfoConfig && _this.shippingAddressInfoConfig.pudoLocationsEnabled && _this.orderFormGroup.value.deliveryPreference === _this.deliveryPreference.PICKUP) {
                    _this.pudoAddress = addressDetails;
                    _this.pudoAddress.id = response.addressDetail.id;
                    _this.savedPudoAddressId = response.addressDetail.id;
                }
                else {
                    _this.verifiedShippingAddressId = response.addressDetail.id;
                    _this.address = addressDetails;
                    _this.address.id = response.addressDetail.id;
                    // this.address.country = this.address.countryCode;
                    _this.orderFormGroup.controls['shippingAddressId'].setValue(response.addressDetail.id, { onlySelf: true });
                    _this.savedAddressId = response.addressDetail.id;
                    if (_this.shipMethodId) {
                        _this.shipMethodId.nativeElement.focus();
                    }
                }
                if (saveAddressRequest && saveAddressRequest.saveForFutureUse) {
                    _this.messageService.setAddressSaved(true);
                    _this.orderFormGroup.controls['saveForFutureUse'].setValue(false);
                }
            }
        }, function (error) {
            var notification = _this._translatePipe.get('order.Unable to Save Member Address');
            _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        });
    };
    /**
    * Add new Shipping Address
    * @param shippingAddressForm
    */
    OrderCreateFBOComponent.prototype.useNewShippingAddress = function (addressInfo) {
        if (addressInfo) {
            var countryObj = this._enrollmentCommonService.getCountryDetailsByCountryIdOrCode(this.countries, addressInfo.countryId, null);
            var stateObj = this._enrollmentCommonService.getStateDetailsByStateIdOrCode(this.states, addressInfo.stateId, null);
            var saveForFutureUse = this.orderFormGroup.value.saveForFutureUse;
            this.shippingAddressInfo = this._enrollmentCommonService.mapNewShippingAddress(addressInfo, stateObj, countryObj, saveForFutureUse);
            if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.PICKUP) {
                this.pudoShippingAddressInfo = this.shippingAddressInfo;
                this.showPudoPickupPersonAddressForm = false;
            }
            else {
                this.shippingAddressInfo = this.shippingAddressInfo;
            }
            this.isNewCard = false;
            this.updateTotalsAndShipMethod();
        }
    };
    OrderCreateFBOComponent.prototype.onPaymentMethodChnage = function () {
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        this.selectedPayvisionCardInfo = null;
        this.echeckRequest = null;
        var options = [this.paymentTypeEnum.Money_order, this.paymentTypeEnum.Bank_Transfer, this.paymentTypeEnum.Wire_Transfer,
            this.paymentTypeEnum.Cash_On_Delivery, this.paymentTypeEnum.Orange_Money, this.paymentTypeEnum.MisterCash_and_Maestro, this.paymentTypeEnum.BanContact_MisterCash_and_Maestro, this.paymentTypeEnum.Pay_By_Link];
        var paymentSelectorValue = +this.orderFormGroup.controls['paymentSelector'].value;
        if (options.some(function (x) { return x == paymentSelectorValue; })) {
            this.orderFormGroup.controls['paymentInstrumentId'].setValidators([]);
        }
        else {
            this.orderFormGroup.controls['paymentInstrumentId'].setValidators([Validators.required]);
        }
        if (paymentSelectorValue === this.paymentTypeEnum.Pay_By_Link) {
            var email = this.liveFormPersonalInfo && this.liveFormPersonalInfo.email ? this.liveFormPersonalInfo.email : null;
            if (email != null) {
                this.emailForm.controls['payByLinkEmail'].setValue(email);
            }
            else {
                this.emailForm.controls['payByLinkEmail'].setValue('');
            }
            this.emailForm.controls['payByLinkEmail'].updateValueAndValidity();
            if (this.emailForm.controls['payByLinkEmail'].value !== '') {
                this.isPayByLinkValid = true;
            }
            else {
                this.isPayByLinkValid = false;
            }
        }
        else {
            this.isPayByLinkValid = true;
        }
        this.orderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
        if (this.appConfig.enablePaymentReferenceNumber) {
            this.paymentReferenceNumber.reset();
            this.paymentReferenceNumberFormValidations();
        }
    };
    /**
     * @description savePayment methos
     * @memberof OrderCreateFBOComponent
     */
    OrderCreateFBOComponent.prototype.savePaymentMethodClicked = function (savePaymentMethod) {
        this.savePaymentMethod = !savePaymentMethod;
    };
    /**
     * on change of Echeck
     */
    OrderCreateFBOComponent.prototype.selectECheck = function (echeckDetails, isNewEcheck) {
        if (isNewEcheck) {
            this.buildEcheckForm();
            this.echeckSubmitted = false;
            this.eCheckValidationMessages = [];
            this.eCheckPaymentPopup.open();
            this.addNeweCheck = true;
        }
        else {
            this.selectedECheckInfo = echeckDetails;
            this.billingAddressInfo = echeckDetails.billingAddress;
            this.addNeweCheck = false;
            this.echeckRequest = {
                portalCsp: true,
                id: this.addNeweCheck ? 0 : this.selectedECheckInfo.id,
                portalType: EcheckPortalTypes.CustomerCare,
                accountNumber: this.selectedECheckInfo.accountNumber,
                routingNumber: this.selectedECheckInfo.routingNumber,
                bankName: this.selectedECheckInfo.bankName,
                accountType: this.selectedECheckInfo.accountType,
                nameOnBankAccount: this.selectedECheckInfo.nameOnBankAccount,
                reusable: this.selectedECheckInfo.reusable,
                defaultECheck: this.selectedECheckInfo.defaultECheck,
                customerId: this.memberInfo.memberId,
                billingAddress: this.getBillingAddressForECheck(),
                billingAddressId: null,
                billingAddressRequired: true,
                customMessage: '',
                storeId: this.storeInfo.id,
                email: this.selectedECheckInfo.email,
                phone: this.selectedECheckInfo.phone
            };
            if (this.paymentFormBtn && this.paymentFormBtn.nativeElement) {
                this.paymentFormBtn.nativeElement.focus();
            }
        }
    };
    /**
     * when Echeck form is closed
     */
    OrderCreateFBOComponent.prototype.onECheckFormClose = function () {
        this.eCheckPaymentPopup.close();
        this.addNeweCheck = false;
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedEcheckDdl && this.savedEcheckDdl.nativeElement) {
            this.savedEcheckDdl.nativeElement.focus();
        }
    };
    /**
     * buildEcheckForm
     */
    OrderCreateFBOComponent.prototype.buildEcheckForm = function () {
        var phone = '';
        var email = '';
        if (this.memberInfo) {
            email = this.memberInfo.email;
            if (this.phoneNumberFormat) {
                phone = this._maskPipe.transform(this.memberInfo.phone, this.phoneNumberFormat);
            }
            else {
                phone = this.memberInfo.phone;
            }
        }
        this.echeckForm = this._formbuilder.group({
            routerNumber: ['', [Validators.required, Utils.alphaNumericCharacterValidation, Validators.maxLength(9)]],
            accountNumber: ['', [Validators.required, CustomValidators.requiredNotEmpty]],
            accountType: ['', [Validators.required]],
            bankName: ['', [Validators.required, CustomValidators.requiredNotEmpty]],
            nameOnBankAccount: ['', [Validators.required, CustomValidators.requiredNotEmpty, Utils.alphaNumericCharacterValidation, Validators.maxLength(25)]],
            reuse: [false],
            billingAddressId: [''],
            customMessage: [''],
            email: [email, Validators.required],
            phone: [phone, [Validators.required, EcheckPhoneNumberValidation.PhoneNumberValidation]]
        });
    };
    OrderCreateFBOComponent.prototype.validateNewECheck = function () {
        this.echeckSubmitted = true;
        if (this.echeckForm.valid) {
            var echeckFormValue_1 = this._commonService.trimObjectValues(this.echeckForm.value);
            if (echeckFormValue_1 && echeckFormValue_1.phone) {
                var phoneCode = PhoneCodesConstants.phoneCodes.find(function (x) { return echeckFormValue_1.phone.toUpperCase().indexOf(x.name) > -1; });
                if (phoneCode) {
                    echeckFormValue_1.phone = echeckFormValue_1.phone;
                }
                else {
                    if (this.phoneNumberFormat) {
                        echeckFormValue_1.phone = this._maskPipe.transform(echeckFormValue_1.phone, this.phoneNumberFormat);
                    }
                    else {
                        echeckFormValue_1.phone = echeckFormValue_1.phone;
                    }
                }
            }
            var validateECheckReq = {
                accountNumber: echeckFormValue_1.accountNumber,
                accountType: echeckFormValue_1.accountType,
                bankName: echeckFormValue_1.bankName,
                routingNumber: echeckFormValue_1.routerNumber,
                addressOne: this.billingAddressInfo.addressLine1,
                addressTwo: this.billingAddressInfo.addressLine2,
                city: this.billingAddressInfo.city,
                country: this.paymentComponentSettings.isoTwoletterCountryCode,
                state: this.billingAddressInfo.stateCode,
                zip: this.billingAddressInfo.postalCode,
                email: echeckFormValue_1.email,
                phone: echeckFormValue_1.phone,
                paymentMethodType: this.paymentComponentSettings.paymentMethodTypes.eCheck
            };
            this.validateECheck(validateECheckReq);
        }
    };
    OrderCreateFBOComponent.prototype.validateECheck = function (validateECheckReq) {
        var _this = this;
        this.eCheckValidationMessages = [];
        this._echeckService.validateEcheck(validateECheckReq)
            .subscribe(function (response) {
            if (response && response.success) {
                _this.savePersonalEcheck(validateECheckReq);
            }
            else if (response && !response.success && response.validations.length > 0) {
                _this.eCheckValidationMessages = response.validations.map(function (validation) { return validation.message; });
            }
            else {
                _this.eCheckValidationMessages.push('Echeck validation failed.');
            }
        }, function (error) {
            _this.eCheckValidationMessages.push('Echeck validation failed.');
        });
    };
    /**
     * save personal echecks
     */
    OrderCreateFBOComponent.prototype.savePersonalEcheck = function (eCheckInfo) {
        var _this = this;
        this.echeckRequest = {
            portalCsp: true,
            id: this.addNeweCheck ? 0 : this.selectedECheckInfo.id,
            portalType: EcheckPortalTypes.CustomerCare,
            accountNumber: eCheckInfo.accountNumber,
            routingNumber: eCheckInfo.routingNumber,
            bankName: eCheckInfo.bankName,
            accountType: eCheckInfo.accountType,
            nameOnBankAccount: this.addNeweCheck ? eCheckInfo.name : this.selectedECheckInfo.nameOnBankAccount,
            reusable: this.addNeweCheck ? this.echeckForm.value.reuse : this.selectedECheckInfo.reusable,
            defaultECheck: this.addNeweCheck ? false : this.selectedECheckInfo.defaultECheck,
            customerId: this.memberInfo.memberId,
            billingAddress: this.getBillingAddressForECheck(),
            billingAddressId: null,
            billingAddressRequired: true,
            customMessage: '',
            storeId: this.storeInfo.id,
            email: eCheckInfo.email,
            phone: eCheckInfo.phone
        };
        this._echeckService.savePersonalCheck(this.memberInfo.memberId, this.echeckRequest)
            .subscribe(function (response) {
            if (response) {
                _this.eCheckTokenRes = response;
                _this.echeckSubmitted = false;
                if (_this.addNeweCheck) {
                    _this.eCheckPaymentPopup.close();
                    var savedEChecks = JSON.parse(_this.savedEChecks);
                    _this.paymentComponentSettings.savedEChecks = savedEChecks;
                    if (_this.echeckRequest) {
                        _this.echeckRequest.id = +(atob(_this.eCheckTokenRes));
                    }
                    if (_this.echeckRequest && _this.echeckRequest.reusable) {
                        _this.orderFormGroup.controls['paymentInstrumentId'].setValue(+(atob(_this.eCheckTokenRes)));
                        _this.getSavedEchecks();
                    }
                    else {
                        _this.orderFormGroup.controls['paymentInstrumentId'].setValue(+(atob(_this.eCheckTokenRes)));
                    }
                }
                if (_this.paymentFormBtn && _this.paymentFormBtn.nativeElement) {
                    _this.paymentFormBtn.nativeElement.focus();
                }
            }
            else {
                _this.eCheckValidationMessages.push('Echeck validation failed.');
            }
        }, function (error) {
            _this.eCheckValidationMessages.push('Echeck validation failed.');
        });
    };
    /**
     * map billing address for e-Check
     */
    OrderCreateFBOComponent.prototype.getBillingAddressForECheck = function () {
        var stateObj = this._enrollmentCommonService.getStateDetailsByStateIdOrCode(this.states, null, this.billingAddressInfo.state);
        var billingAddress = this._enrollmentCommonService.mapBillingAddressService(this.billingAddressInfo, stateObj);
        return billingAddress;
    };
    /**
     * @description add mask while chnaging phone number
     * @memberof OrderCreateFBOComponent
     */
    OrderCreateFBOComponent.prototype.onChangeEcheckPhone = function ($event) {
        var value = this.echeckForm.controls['phone'].value;
        var updatedValue = value;
        var alphaNumericValue = value.replace(/[^a-z0-9]/gi, '');
        if (value.match(/[a-zA-Z]/)) {
            if (alphaNumericValue.substr(0, 3).match(/[a-zA-Z]/)) {
                updatedValue = value.replace(/[^a-z0-9]/gi, '');
            }
            else if (alphaNumericValue.substr(3, 3).match(/[a-zA-Z]/)) {
                updatedValue = this._maskPipe.transform(value, '(000) AAAAAAA');
            }
            else if (alphaNumericValue.substr(6, 4).match(/[a-zA-Z]/)) {
                updatedValue = this._maskPipe.transform(value, '(000) 000-AAAA');
            }
        }
        else {
            if (alphaNumericValue.length !== 3) {
                if (this.phoneNumberFormat) {
                    updatedValue = this._maskPipe.transform(value, this.phoneNumberFormat);
                }
                else {
                    updatedValue = value;
                }
            }
        }
        this.echeckForm.controls['phone'].setValue(updatedValue);
    };
    OrderCreateFBOComponent.prototype.onWorldpayXMLFormClose = function () {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.showWorldpayXml = false;
        sessionStorage.removeItem(CacheKey.OrderInfo);
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedCardsDdl) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.showWorldPayXMLPopup.close();
    };
    OrderCreateFBOComponent.prototype.onAdyenPaymentFormClose = function () {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.showAdyenPayment = false;
        sessionStorage.removeItem(CacheKey.OrderInfo);
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedCardsDdl && this.savedCardsDdl.nativeElement) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.showAdyenPaymentPopup.close();
    };
    OrderCreateFBOComponent.prototype.onNIFormClose = function () {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.showNIPayment = false;
        sessionStorage.removeItem(CacheKey.OrderInfo);
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedCardsDdl) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.showNIPopup.close();
    };
    OrderCreateFBOComponent.prototype.onNexioFormClose = function () {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.showNexioPayment = false;
        sessionStorage.removeItem(CacheKey.OrderInfo);
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedCardsDdl) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.showNexioPopup.close();
    };
    /**
     * Get ECheck payment
     */
    OrderCreateFBOComponent.prototype.getSavedEchecks = function () {
        var _this = this;
        if (this.memberInfo.memberId) {
            this._achService.getSavedEchecks(this.memberInfo.memberId, this.selectedIsoCountryCode, this.eCheckTokenRes)
                .subscribe(function (response) {
                if (response && response.length > 0) {
                    _this.paymentComponentSettings.savedEChecks = response;
                    if (_this.echeckRequest && _this.echeckRequest.reusable) {
                        var selectedCard = _this.paymentComponentSettings.savedEChecks.find(function (x) { return x.id === _this.echeckRequest.id; });
                        if (selectedCard) {
                            var indexPostion = _this.paymentComponentSettings.savedEChecks
                                .findIndex(function (x) { return x.id === _this.echeckRequest.id; });
                            _this.paymentComponentSettings.savedEChecks.splice(indexPostion, 1);
                            _this.paymentComponentSettings.savedEChecks.unshift(selectedCard);
                            _this.orderFormGroup.controls['paymentInstrumentId'].setValue(_this.echeckRequest.id);
                        }
                        else {
                            var index = _this.paymentComponentSettings.savedEChecks.length - 1;
                            _this.orderFormGroup.controls['paymentInstrumentId']
                                .setValue(_this.paymentComponentSettings.savedEChecks[index].id);
                        }
                    }
                }
                else {
                    _this.paymentComponentSettings.savedEChecks = [];
                    _this.savedEChecks = '';
                }
                _this.savedEChecks = JSON.stringify(_this.paymentComponentSettings.savedEChecks);
            });
        }
    };
    /**
     * on close of payvision form popup
     */
    OrderCreateFBOComponent.prototype.onPayvisionFormClose = function () {
        this._cacheService.remove(CacheKey.IsRefreshed);
        sessionStorage.removeItem(CacheKey.OrderInfo);
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        this.addNewPayvisionCard = false;
        if (this.savedCardsDdl) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.payvisionPayment.close();
        this.paymentComponentSettings.payvisionFormLoaded = false;
        // To remove payvision Configurations
        this._commonService.unloadPayvisionWidget();
    };
    /**
 * @description submit enrollment
 * @param {string} requestUrl
 * @memberof OrderCreateFBOComponent
 */
    OrderCreateFBOComponent.prototype.submitEnrollment = function () {
        var _this = this;
        this._personalMessageService.setSubmitPersonalinfoForm(true);
        if (this.appConfig.enablePaymentReferenceNumber) {
            if (this.paymentReferenceNumber.value.referenceNumber) {
                this.paymentComponentSettings.authorizationCode = this.paymentReferenceNumber.value.referenceNumber;
            }
        }
        if (!this.validateBusinessInformation()) {
            this._personalMessageService.setSubmitBusinessInfo(true);
        }
        if (this.shippingAddressChanged) {
            this.showVerifyAddressMessage();
            return;
        }
        // if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled
        //     && this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.DROPSHIP && !this.pudoAddressSubmitted) {
        //     this.isnewcardAdded=true;
        //     this.messageService.setSubmitPudoPickupPersonAddress(true);
        //     return;
        // }
        // if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled 
        //     && this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.DROPSHIP && !this.pudoAddressSubmitted) {
        //          this.isnewcardAdded=true;
        //         this.messageService.setSubmitPudoDropShipPersonAddress(true);
        //     return;
        // }
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled && this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.DROPSHIP
            && !this.selectedPudoCollectionPoint) {
            return;
        }
        if (!this.accountVerified) {
            this.showAccountExistsMessage();
            this.isSubmitted = false;
            return;
        }
        this.isSubmitted = true;
        if (this.isBeneluxCountry) {
            this.messageService.accountNumber.subscribe(function (accountNumber) {
                if (_this.bonusInformation) {
                    _this.bonusInformation.accountNumber = accountNumber;
                }
                else {
                    var bonusInfo = {
                        accountNumber: accountNumber
                    };
                    _this.bonusInformation = bonusInfo;
                }
            });
            this.messageService.bsnNumber.subscribe(function (bsnNumber) {
                if (_this.bonusInformation && bsnNumber) {
                    _this.bonusInformation.bsnNumber = bsnNumber;
                }
            });
            if (this.bonusInformation && this.bonusInformation.accountNumber) {
                var list = this.bonusInfoAgreements.filter(function (x) { return x.isSelected === false; });
                if (list && list.length === 0) {
                    this.displayIBANAckError = false;
                    this.validatePersonalInfo();
                }
                else {
                    this.displayIBANAckError = true;
                    setTimeout(function () {
                        _this._commonService.focusInvalidElement();
                    }, 0);
                }
            }
            else {
                this.displayIBANAckError = false;
                this.validatePersonalInfo();
            }
            // else {
            //     if(this.bonusInformation.accountNumber === '') {
            //         const list = this.bonusInfoAgreements.filter(x => x.isSelected === false);
            //         if(list && list.length > 0) {
            //             this.displayIBANAckError = false;
            //             this.validatePersonalInfo(isContactSponsor);
            //         }
            //     }
            // }
        }
        else if ((this.storeSettings && this.storeSettings.bonusInfoPaymentOptions) && !(this.bonusInformation || this.bonusPaymentOptionType === BonusPaymentOption.DECIDE_LATER)) {
            setTimeout(function () {
                _this._commonService.focusInvalidElement();
            }, 0);
        }
        else {
            this.validatePersonalInfo();
        }
    };
    OrderCreateFBOComponent.prototype.validatePersonalInfo = function () {
        var _this = this;
        if (this.personalInfoFormValid
            && !this.agreementCheckError && this.personalInformation && this.sponsorInformation
            && this.mailingAddress && this.validateBusinessInformation()) {
            this.isSubmitted = true;
            this.validateOutOfStockAndSubmit();
        }
        else {
            setTimeout(function () {
                _this._commonService.focusInvalidElement();
            }, 0);
        }
    };
    OrderCreateFBOComponent.prototype.showAccountExistsMessage = function () {
        var msg = this._translatePipe.get('order.Combination of First name, Last name, Address already exist')['value'];
        this._commonService.createNotification('', msg, NotificationType.ERROR);
    };
    OrderCreateFBOComponent.prototype.validateBusinessInformation = function () {
        if (this.storeSettings.showBusinessInfoSection) {
            if (this.businessInformation && this.businessInformation.isBusinessInfoValid) {
                return true;
            }
            else
                return false;
        }
        return true;
    };
    OrderCreateFBOComponent.prototype.validateOutOfStockAndSubmit = function () {
        var _this = this;
        if (this.products && this.products.length) {
            var productIds = this.products.map(function (item) { return item.id; });
            if (productIds && productIds.length) {
                if ((this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.DELIVERY || this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.DROPSHIP) || (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.pudoLocationsEnabled)) {
                    this._orderService.getProductsByIds(productIds, this.storeDefaultLanguage, this.storeInfo.id, this.getMemberTitleId(), this._enrollmentCommonService.getPurchaseFlow(this.orderFormGroup.controls['orderType'].value), this.selectedIsoCountryCode, false, false, this.storeInfo.taxInclusive).subscribe(function (products) {
                        _this.outOfStockItems = _this.stockAvailabilityCheck(products);
                        if (_this.outOfStockItems.length) {
                            _this.outOfStockModal.open();
                            _this.isSubmitted = false;
                        }
                        else {
                            _this.placeEnrollRequest();
                        }
                    });
                }
                else if (this.orderFormGroup.value.deliveryPreference == this.deliveryPreference.PICKUP) {
                    // pickup products stock availability check
                    var shipMethodId_2 = this.orderFormGroup.value.shipMethodId;
                    if (shipMethodId_2 && this.shippingMethods) {
                        var shippingObj = this.shippingMethods.filter(function (shipMethod) { return shipMethod.shippingMethodId === +shipMethodId_2; })[0];
                        if (shippingObj && shippingObj.shippingMethodId) {
                            this.pickupStockAvailabilityCheck(productIds, shippingObj.shippingMethodId);
                        }
                        else {
                            this.isSubmitted = false;
                        }
                    }
                    else {
                        this.isSubmitted = false;
                        var notification = 'Pickup location not available, Please select.';
                        this._commonService.createNotification('', notification, NotificationType.ERROR);
                    }
                }
            }
        }
    };
    /**
 * @description To check stock available
 * @param {Product[]} products
 * @returns {Product[]}
 * @memberof OrderCreateFBOComponent
 */
    OrderCreateFBOComponent.prototype.stockAvailabilityCheck = function (products) {
        var cartProducts = this.products;
        if (cartProducts && products && products.length) {
            var noStockItems_1 = [];
            products.forEach(function (product) {
                var cartItem = cartProducts.find(function (item) { return item.id === product.id; });
                if (cartItem && !((product.stockAvailable && !product.manageStock) || (product.manageStock && product.stockQuantity >= cartItem.quantity))) {
                    cartItem.stockQuantity = product.stockQuantity;
                    noStockItems_1.push(cartItem);
                }
            });
            return noStockItems_1;
        }
        return [];
    };
    /**
     * @description checks the Pickup stock quantity availability on individual product
     * @param productIds:number[]
     * @param pickupLocationId:number
     * @memberof OrderCreateFBOComponent
     */
    OrderCreateFBOComponent.prototype.pickupStockAvailabilityCheck = function (productIds, pickUpLocationId) {
        var _this = this;
        var noStockItems = [];
        var cartProducts = this.products;
        if (pickUpLocationId && pickUpLocationId > 0 && productIds && productIds.length > 0) {
            this._customerService.getProductsByLocation(pickUpLocationId, productIds).subscribe(function (response) {
                var posProducts = response;
                if (posProducts && posProducts.length > 0) {
                    posProducts.forEach(function (pickUpProduct) {
                        var cartProduct = cartProducts.find(function (product) { return product.id === pickUpProduct.productId; });
                        if (cartProduct && pickUpProduct.manageStock && cartProduct.quantity > pickUpProduct.stockQuantity) {
                            cartProduct.stockQuantity = pickUpProduct.stockQuantity;
                            noStockItems.push(cartProduct);
                        }
                    });
                }
                _this.outOfStockItems = noStockItems;
                if (_this.outOfStockItems && _this.outOfStockItems.length > 0) {
                    _this.outOfStockModal.open();
                    _this.isSubmitted = false;
                }
                else {
                    _this.placeEnrollRequest();
                }
            }, function (error) {
                var notification = _this._translatePipe.get('orderdetails.Sorry, Something Went Wrong: Please try again later.');
                _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                _this.isSubmitted = false;
            });
        }
    };
    /**
     * @description closes the out of stock Modal popup
     * @memberof OrderCreateFBOComponent
     */
    OrderCreateFBOComponent.prototype.closeOutOfStockForm = function () {
        this.outOfStockModal.close();
    };
    /**
     * @description this method will process meber
     * enrollment request
     * @param {EnrollInfo} enrollRequest
     * @memberof OrderCreateFBOComponent
     */
    OrderCreateFBOComponent.prototype.validateOrderLimit = function (quantityUpdate) {
        var _this = this;
        var subTotal = this.calculateItemsSubTotal(this.storeInfo);
        // changes for order min/max for taxInclusive stores PS2022-1077
        if (this.storeInfo && this.storeInfo.taxInclusive) {
            subTotal = this.itemTotal;
        }
        if (this.orderRules && this.orderRules.valueType === ValueType.PRICE && !quantityUpdate
            && this.appConfig && this.appConfig.displayPurchaseLimitationMessage) {
            var literatureItems = this._enrollmentCommonService.getLiteratureItems(this.products, this.orderRules);
            if (!((subTotal >= this.orderRules.minValue && subTotal <= this.orderRules.maxValue)
                || (this.orderRules.includeLiterature && literatureItems && literatureItems.length === this.products.length
                    && subTotal <= this.orderRules.maxValue))) {
                if (subTotal > this.orderRules.maxValue) {
                    var maximumCartLimit = this._translatePipe.get('order.The order amount not including your discounts must not exceed');
                    var maxValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.maxValue, this.storeInfo);
                    var cartMaximumLimitNotification = maximumCartLimit.value + ' <b class="helvetica-bold">' +
                        maxValue + '</b>';
                    this._commonService.createNotification('', cartMaximumLimitNotification, NotificationType.ERROR, 0, Constants.ORDER_LIMIT);
                    return false;
                }
                else if (subTotal < this.orderRules.minValue && !quantityUpdate && !this.isOverrideMinimumLimit) {
                    if (this.overrideMinimumLimitIsEnabled) {
                        var overrideLimitLink = this._translatePipe.get("order.To Override Minimum Limit,click <a id='more-options'>here</a>");
                        var cartMinimumLimit = this._translatePipe.get('order.To register as an FBO the order must meet a minimum of');
                        var minValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.minValue, this.storeInfo);
                        var cartMinimumLimitNotification_3 = cartMinimumLimit.value + ' <b class="helvetica-bold">' +
                            minValue + '</b>.<b>' + overrideLimitLink.value + '</b>';
                        this.cartMessageID = setTimeout(function () {
                            var toast = _this._commonService.createNotification('', cartMinimumLimitNotification_3, NotificationType.ERROR, 0, Constants.ORDER_LIMIT);
                            toast.click.subscribe(function (event) {
                                if (event.target.getAttribute(ImpersonateUserConstants.ID) === ImpersonateUserConstants.MORE_OPTIONS) {
                                    _this.overrideMinimumLimit.open();
                                }
                            });
                        }, 100);
                    }
                    else {
                        var cartMinimumLimit = this._translatePipe.get('order.To register as an FBO the order must meet a minimum of');
                        var minValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.minValue, this.storeInfo);
                        var cartMinimumLimitNotification_4 = cartMinimumLimit.value + ' <b class="helvetica-bold">' +
                            minValue + '</b>';
                        this.cartMessageID = setTimeout(function () {
                            _this._commonService.createNotification('', cartMinimumLimitNotification_4, NotificationType.ERROR, 0, Constants.ORDER_LIMIT);
                        }, 100);
                        return false;
                    }
                }
                else {
                    this._commonService.removeNotification(Constants.ORDER_LIMIT);
                }
            }
        }
        if (this.orderRules && this.orderRules.validateProductTypes && this.orderRules.validateProductTypes.length && (!quantityUpdate || !this.checkoutConfig.enableMinAndMaxLimitRules)) {
            var isLiteratureValidation = this._enrollmentCommonService.isLiteratureValidation(this.products, this.orderRules);
            var invalidProductPopup = this._translateService.get('order.Your cart must be a minimum amount of {{min}} and  a maximum amount of {{max}}', {
                min: this._currencyPipe.getFormatedCurrencyWithSepartors(isLiteratureValidation ? this.orderRules.literatureMinValue : this.orderRules.minValue, this.storeInfo),
                max: this._currencyPipe.getFormatedCurrencyWithSepartors(isLiteratureValidation ? this.orderRules.literatureMaxValue : this.orderRules.maxValue, this.storeInfo)
            });
            if (!this.checkoutConfig.enableMinAndMaxLimitRules || this.appConfig.displayMinValidation) {
                invalidProductPopup = this._translateService.get('order.Your cart must be a minimum amount of {{min}}', {
                    min: this._currencyPipe.getFormatedCurrencyWithSepartors(isLiteratureValidation ? this.orderRules.literatureMinValue : this.orderRules.minValue, this.storeInfo)
                });
            }
            if (this._enrollmentCommonService.validateSubTotalBasedOnType(this.products, this.orderRules, subTotal, this.isOverrideMinimumLimit)) {
                this._commonService.createNotification('', invalidProductPopup.value, NotificationType.ERROR, 0, Constants.MIN_LIMIT);
                return false;
            }
            else {
                this._commonService.removeNotification(Constants.MIN_LIMIT);
            }
        }
        var totalPoints = this._enrollmentCommonService.calculateTotalPoints(this.products);
        if (this.orderRules && this.orderRules.valueType === ValueType.CC &&
            (totalPoints > this.orderRules.maxValue)) {
            var exceedPerOrderCC = this._translatePipe.get('order.Cart contains a case credit value above the limit', {
                limit: this.orderRules.maxValue
            });
            this._commonService.createNotification('', exceedPerOrderCC.value, NotificationType.ERROR, 0, Constants.MAX_EXCEEDED);
            return false;
        }
        else {
            this._commonService.removeNotification(Constants.MAX_EXCEEDED);
        }
        if (this.orderRules && this.orderRules.valueType === ValueType.BOTH) {
            var totalCC = totalPoints;
            var validations = this._commonService.validateSubTotalBasedOnBothPriceAndCC(this.orderRules, this._enrollmentCommonService.isLiteratureValidation(this.products, this.orderRules), subTotal, totalCC);
            if (validations && (validations.cartLimitExceed || validations.cartLimitNotReach) && !quantityUpdate) {
                var isLiteratureValidation = this._enrollmentCommonService.isLiteratureValidation(this.products, this.orderRules);
                var invalidProductPopup = this._translateService
                    .get('order.Your cart must be a minimum amount of {{min}} and  a maximum amount of {{max}}', {
                    min: this._currencyPipe.getFormatedCurrencyWithSepartors(isLiteratureValidation ? this.orderRules.literatureMinValue : this.orderRules.minValue, this.storeInfo),
                    max: this._currencyPipe.getFormatedCurrencyWithSepartors(isLiteratureValidation ? this.orderRules.literatureMaxValue : this.orderRules.maxValue, this.storeInfo)
                });
                this._commonService.createNotification('', invalidProductPopup.value, NotificationType.ERROR, 0, Constants.ORDER_LIMIT);
                return false;
            }
            else if (validations.monthlyCCValid || validations.thresholdCrossed) {
                var exceedMonthlyCCPopup = this._translatePipe
                    .get('order.Your cart contains a case credit value that brings your total monthly case credits above the limit');
                this._commonService.createNotification('', exceedMonthlyCCPopup.value, NotificationType.ERROR, 0, Constants.ORDER_LIMIT);
                return false;
            }
            else {
                this._commonService.removeNotification(Constants.ORDER_LIMIT);
            }
        }
        if (this.checkoutConfig.enableMonthlyCCLimitRules) {
            var totalCC = totalPoints;
            if (this.orderRules && totalCC > this.orderRules.maxCCValue) {
                var exceedMonthlyCCPopup = this._translatePipe
                    .get('order.Your cart contains a case credit value that brings your total monthly case credits above the limit');
                var monthlyCCContent = exceedMonthlyCCPopup.value + ' <b class="helvetica-bold">' + this.orderRules.maxCCValue + '</b>';
                this._commonService.createNotification('', monthlyCCContent, NotificationType.ERROR, 0, Constants.ORDER_LIMIT);
                return false;
            }
            else {
                this._commonService.removeNotification(Constants.ORDER_LIMIT);
            }
        }
        return true;
    };
    /**
     * @description this method will process meber
     * enrollment request
     * @param {EnrollInfo} enrollRequest
     * @memberof OrderCreateFBOComponent
     */
    OrderCreateFBOComponent.prototype.placeEnrollRequest = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var itemNumber, revisionNumber, new_RevisionNumber, isValid, enrollRequest, notification, notification, compareTaxValues, recentlyViewedProducts, isProductRevisionNumberMatch_1, transliteratedProps, notification, notification;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isValid = this.validateOrderLimit(false);
                        if (!isValid) {
                            this.isSubmitted = false;
                            return [2 /*return*/];
                        }
                        enrollRequest = this.prepareEnrollSessionRequest();
                        if (enrollRequest && enrollRequest.enrollInfo && enrollRequest.enrollInfo.orderInfo && (enrollRequest.enrollInfo.orderInfo.orderShippings[0].shipMethodId == null || enrollRequest.enrollInfo.orderInfo.orderShippings[0].shipMethodId == undefined)) {
                            notification = this._translatePipe.get('order.Please Select shipping method.');
                            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                            this.isSubmitted = false;
                        }
                        if (!enrollRequest.enrollInfo.orderInfo.taxMetaData && this.isTaxMetaDataAvailable) {
                            notification = this._translatePipe.get('order.Tax is not mapped. Please try again later.');
                            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                            this.isSubmitted = false;
                            return [2 /*return*/];
                        }
                        compareTaxValues = this._enrollmentCommonService.compareTax(enrollRequest.enrollInfo.orderInfo, this.storeInfo, this.appConfig);
                        if (!compareTaxValues) return [3 /*break*/, 3];
                        if (!this.personalInformation) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getRecentlyviewedProducts(enrollRequest.enrollInfo.orderInfo)];
                    case 1:
                        recentlyViewedProducts = _a.sent();
                        isProductRevisionNumberMatch_1 = true;
                        if (recentlyViewedProducts) {
                            if (recentlyViewedProducts && recentlyViewedProducts.length > 0) {
                                recentlyViewedProducts.forEach(function (recentProduct) {
                                    enrollRequest.enrollInfo.orderInfo.orderLineItems.forEach(function (product) {
                                        if (product.revisionNumber === recentProduct.revisionNumber) {
                                            // isProductRevisionNumberMatch = true;
                                        }
                                        else {
                                            isProductRevisionNumberMatch_1 = false;
                                            itemNumber = product.itemNumber;
                                            revisionNumber = product.revisionNumber;
                                            new_RevisionNumber = recentProduct.revisionNumber;
                                            return;
                                        }
                                    });
                                });
                            }
                        }
                        if (isProductRevisionNumberMatch_1) {
                            transliteratedProps = this._commonService.mapTransliterateProperties(this.storeInfo, this.orderFormGroup.get('language').value);
                            this._enrollService.createEnrollRequest(enrollRequest.enrollInfo, transliteratedProps).subscribe(function (fboCreateResponse) {
                                if (fboCreateResponse && fboCreateResponse.validations && fboCreateResponse.validations.length > 0) {
                                    _this.isSubmitted = false;
                                    _this.returningFBOUser = null;
                                    _this.mailAlreadyExist = true;
                                    _this.isnewcardAdded = false;
                                    _this._enrollmentMessageService.setIsEmailAlreadyExists(true);
                                    _this._commonService.createNotification('', fboCreateResponse.validations[0].message, NotificationType.ERROR);
                                }
                                else {
                                    _this.enrollmentSuccess(fboCreateResponse);
                                    _this.isnewcardAdded = false;
                                }
                            }, function (errorResponse) {
                                _this.displayErrorMessage(errorResponse);
                            });
                        }
                        else {
                            notification = this._translatePipe.get('order.Product revision number mismatch,' + ' Item : ' + itemNumber + ', Revision Number : ' + revisionNumber + ', New Revision Number : ' + new_RevisionNumber);
                            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                            this.isSubmitted = false;
                        }
                        _a.label = 2;
                    case 2: return [3 /*break*/, 4];
                    case 3:
                        notification = this._translatePipe.get('order.There is a mismatch in tax calculation. Please try again later.');
                        this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                        this.isSubmitted = false;
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
 * @description
 * @private
 * @returns {EnrollSession}
 * @memberof OrderCreateFBOComponent
 */
    OrderCreateFBOComponent.prototype.prepareEnrollSessionRequest = function () {
        if (this.sponsorInformation) {
            this.sponsorInformation.memberCommunicationPreferences = this.memberCommunicationPreferences;
        }
        // if(this.isBeneluxCountry) {
        //     if(this.bonusInfoAgreements && this.bonusInfoAgreements.length > 0) {
        //         this.bonusInfoAgreements.filter(x => {
        //             if(x.isSelected) {
        //                 this.agreementDocuments.push(x);
        //             }
        //         });
        //     }
        // }
        if (this.bonusInformation && this.bonusInformation.bsnNumber) {
            this.personalInformation.governmentId = this.bonusInformation.bsnNumber;
        }
        var personalInfo = this._enrollService.preparePersonalInfo(this.storeInfo, this.orderFormGroup.value.language || this.storeDefaultLanguage, this.personalInformation, this.shippingAddressInfo, this.countryCode, this.orderFormGroup.value.countryId, this.sponsorInformation, this.agreementDocuments, this.memberInfo, this.memberTypeId, null, this.mailingAddress, null, this.govtIdentificationTypes, this.bonusInformation, true, this.bonusInfoAgreements, this.businessInformation);
        personalInfo.pass_word = Randomize('A0a', 12);
        personalInfo.loginPassword = personalInfo.pass_word;
        var enrollSession = {
            enrollInfo: {
                personalInfo: personalInfo,
                orderInfo: this.products && this.products.length > 0 ? this.prepareOrderRequest() : null,
                shoppingCartInfo: null,
                sponsorId: this.sponsorInformation ? this.sponsorInformation.sponsorId : '',
                sponsorInfo: this.sponsorInformation
            },
            sponsorId: this.sponsorInformation ? this.sponsorInformation.sponsorId : ''
        };
        var sessionGuid = this._cacheService.getSessionValue(CacheKey.SessionGuid);
        if (sessionGuid) {
            enrollSession.enrollInfo.personalInfo.sessionGuid = sessionGuid;
        }
        return enrollSession;
    };
    OrderCreateFBOComponent.prototype.prepareOrderRequest = function () {
        var _this = this;
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        var shippingAddress = this._enrollmentCommonService.getShippingAddress(this.shippingAddressInfo, this.pudoShippingAddressInfo, this.selectedCountryCodeTwo, this.orderFormGroup.value, this.countries, this.storeInfo.foreverDirectEnabled);
        if (shippingAddress && shippingAddress.countryId && this.countries && this.countries.length > 0) {
            var country = this.countries.find(function (x) { return x.countryId === shippingAddress.countryId; });
            this.countryTaxInclusive = this._enrollmentCommonService.getCountryTaxInclusiveInfo(country);
        }
        var shippingTax = this._enrollService.prepareShippingTax(this.orderTaxResponse) || this.shippingTax;
        var paymentMethodType = this._enrollmentCommonService.getPaymentMethodById(+this.orderFormGroup.controls['paymentSelector'].value);
        var shippingCostWaived = this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.isWaiveShippingCost ?
            this.shippingAddressInfoConfig.isWaiveShippingCost : false;
        var vatId;
        if (this.checkoutConfig && this.checkoutConfig.vatInPersonalInfo) {
            vatId = this.personalInformation && this.personalInformation.vatId ? this.personalInformation.vatId.replace(/\s/g, '') : null;
        }
        else {
            vatId = this.bonusInformation && this.bonusInformation.vatId ? this.bonusInformation.vatId.replace(/\s/g, '') : null;
        }
        var shippingObj = this.shippingMethods.filter(function (shipMethod) { return shipMethod.shippingMethodId === _this.orderFormGroup.value.shipMethodId; })[0];
        var orderRequest = {
            countryCode: this.selectedIsoCountryCode,
            orderStatusId: OrderStatus.Pending,
            memberId: null,
            email: this.memberInfo ? this.memberInfo.email : this.personalInformation ? this.personalInformation.email : null,
            languageCode: this._enrollmentCommonService.getLanguageCultureCode(this.storeLanguages, this.orderFormGroup),
            storeId: this.storeInfo.id,
            paymentMode: paymentMethodType && paymentMethodType == PaymentMethodTypes.Pay_By_Link ? paymentMethodType : null,
            orderTypeId: this._enrollmentCommonService.getOrderTypeId(this.orderFormGroup.controls['orderType'].value),
            memberLevelId: this.getMemberTitleId(),
            shippingCost: shippingCostWaived ? 0 : this._enrollmentCommonService.getTaxExclusiveShippingCost(this.shippingCost, this.orderFormGroup.value.isShippingDiscountApplied, this.orderFormGroup, shippingCostWaived),
            importFeeValue: this.importFeeValue,
            retailDeliveryFee: this.retailDeliveryFee,
            shippingTax: (this.appConfig && this.appConfig.enableVatItemizationForNonVat) ? shippingTax : ((shippingCostWaived) || (this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice) || (this.appConfig && this.appConfig.displayTaxInclusivePrice))
                ? 0 : shippingTax,
            distrubutorId: null,
            orderSubTotal: this.calculateItemsSubTotal(this.storeInfo),
            orderTotalAfterDiscount: null,
            orderTotal: this.calculateOrderTotal(),
            orderTax: this.taxableAmount,
            currencyId: this.storeInfo.currencyId,
            source: OrderSourceTypes.CUSTOMERSERVICE,
            orderNotes: null,
            orderLineItems: this.getOrderLineItems(this.countryTaxInclusive),
            orderShippings: this.getOrderShippings(),
            orderDiscounts: null,
            orderPayments: this.getOrderPaymentInfo(),
            shippingAddressModel: shippingAddress,
            billingAddressModel: null,
            addresses: this.getAddresses(),
            currencyCode: this.storeInfo.currencyCode,
            createdBy: this.userInfo ? this.userInfo.userId : null,
            loggedInUserId: this.userInfo ? this.userInfo.userId : null,
            loggedInUserName: this.userInfo ? this.userInfo.userName : null,
            taxMetaData: this.orderTaxResponse ? this.orderTaxResponse.taxMetaData : null,
            erpTaxMetaData: this.orderTaxResponse ? this.orderTaxResponse.erpTaxMetaData : null,
            priceTierName: this._enrollmentCommonService.getPriceTier(this.products),
            wholesaleQualified: this.memberInfo && this.memberInfo.wholeSaleQualified ? this.memberInfo.wholeSaleQualified : false,
            memberTypeId: this._enrollmentCommonService.getMemberTypeId(this.orderFormGroup.controls['orderType'].value),
            sponsorId: this.memberInfo ? this.memberInfo.sponsorId : this.sponsorInformation
                ? this.sponsorInformation.sponsorId : this.returningFBOUser ? this.returningFBOUser.sponsorId : null,
            personalDiscountPercentage: this._commonService.getDiscountPerc(this.memberDiscountPercentage),
            memberLevelDiscount: this._commonService.getDiscountPerc(this.memberDiscountPercentage),
            wholesaleQualifiedDiscount: 0,
            optIn: false,
            vatRegistered: (this.bonusInformation && this.bonusInformation.vatId) || (this.checkoutConfig && this.checkoutConfig.vatInPersonalInfo && this.personalInformation && this.personalInformation.vatId) ? true : false,
            vatID: vatId,
            coldProtection: shippingObj ? shippingObj.coldProtection : false,
            firstName: this.personalInformation && this.personalInformation.firstName ? this.personalInformation.firstName : this.memberInfo.firstName,
            lastName: this.personalInformation && this.personalInformation.lastName ? this.personalInformation.lastName : this.memberInfo.lastName,
            languageCulture: this.languageCulture,
            paymentLinkEmail: this.emailForm.value.payByLinkEmail,
            overrideMinimumLimit: this.isOverrideMinimumLimit,
            sourceTypeId: 5,
            freeShippingPromotionOrder: shippingObj ? shippingObj.freeShippingEligible : false,
            retailFreeShippingOrder: 0
        };
        if (shippingObj && shippingObj.freeShippingEligible) {
            orderRequest.shippingCost = 0;
            // setting actual shipping cost
            orderRequest.retailFreeShippingCost = shippingObj.originalShippingCost;
        }
        return orderRequest;
    };
    /**
 * @description To Handle create/update enrollment success response
 * @private
 * @param {EnrollInfo} FBOResponse
 * @memberof OrderCreateFBOComponent
 */
    OrderCreateFBOComponent.prototype.enrollmentSuccess = function (fboResponse) {
        var _this = this;
        if (fboResponse && fboResponse.personalInfo && fboResponse.personalInfo.memberId) {
            var key = this.orderFormGroup.value.orderType === this.orderTypeFBO
                ? MemberActivityLogType.New_FBO_Created : MemberActivityLogType.New_FPC_Created;
            this.saveMemberActivityLog(fboResponse.personalInfo.memberId, key);
        }
        setTimeout(function () {
            _this.displayOrderSuccessDetails(fboResponse);
        }, 2000);
    };
    OrderCreateFBOComponent.prototype.saveMemberActivityLog = function (memberId, key) {
        var activityLogKeys = [];
        if (key === MemberActivityLogType.Override_Minimum_Limit) {
            activityLogKeys.push({
                key: MemberActivityLogType.Override_Minimum_Limit,
                value: Constants.OVERRIDE_MINIMUM_LIMIT
            });
        }
        else {
            activityLogKeys.push({
                key: key,
                value: this._enrollmentCommonService.prepareDocumentCheckActivityLogValue(this.agreementDocuments)
            });
        }
        this._commonService.saveMemberActivity(memberId, activityLogKeys).subscribe();
    };
    /**
 * @description this method will help
 * to close progress bar once done with request
 * @private
 * @memberof OrderCreateFBOComponent
 */
    OrderCreateFBOComponent.prototype.displayErrorMessage = function (errResponse) {
        this.isSubmitted = false;
        this.fieldErrors = [];
        if (!this.sponsorInformation) {
            var notification = this._translatePipe.get('order.Sponsor not found');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        }
        if (errResponse && (errResponse.validations && errResponse.validations.length > 0
            || errResponse.length > 0)) {
            this.fieldErrors = errResponse.validations || errResponse;
        }
    };
    /**
 * @description this method will display order details
 * @param {EnrollInfo} enrollRequest
 * @memberof OrderCreateFBOComponent
 */
    OrderCreateFBOComponent.prototype.displayOrderSuccessDetails = function (fboCreateResponse) {
        var isVATRegistered = (this.bonusInformation && this.bonusInformation.vatId) || (this.checkoutConfig && this.checkoutConfig.vatInPersonalInfo && this.personalInformation && this.personalInformation.vatId) ? true : false;
        var shippingLogInfo = this._enrollmentCommonService.getShippingLogInfo(this.storeInfo, this.orderFormGroup, this.shippingCost, this.shippingTax, this.originalShippingCost, isVATRegistered, (this.checkoutConfig ? this.checkoutConfig.calculateTaxExclusivePrice : false), this.appConfig, true);
        if (fboCreateResponse && fboCreateResponse.orderInfo && fboCreateResponse.orderInfo.webOrderId) {
            fboCreateResponse.webOrderId = fboCreateResponse.orderInfo.webOrderId;
            fboCreateResponse.id = fboCreateResponse.orderInfo.id;
            if (shippingLogInfo) {
                this.createOrderLog(fboCreateResponse, shippingLogInfo);
            }
            this.createOrderLog(fboCreateResponse);
            this.sendPasswordResetLink(fboCreateResponse);
            this.orderSuccess(fboCreateResponse);
            this.isSubmitted = false;
        }
        else if (fboCreateResponse && fboCreateResponse.personalInfo && fboCreateResponse.isSuccess) {
            if (fboCreateResponse.personalInfo.memberContacts && fboCreateResponse.personalInfo.memberContacts.length > 0) {
                this.signUpEmail = this._enrollmentCommonService.getSignupEmail(fboCreateResponse);
                this.openAccountConfirmationTab(this.signUpEmail);
            }
            this.sendPasswordResetLink(fboCreateResponse);
            this.enrollmentSuccessRefreshScreen();
        }
    };
    OrderCreateFBOComponent.prototype.getOrderLineItems = function (countryTaxInclusive) {
        var orderLineObject = {
            products: this.products,
            countryTaxInclusive: countryTaxInclusive,
            displayPriceConfig: this.displayPriceConfig,
            orderTaxResponse: this.orderTaxResponse,
            checkoutConfig: this.checkoutConfig,
            storeInfo: this.storeInfo
        };
        return this._enrollmentCommonService.getOrderLineItems(orderLineObject);
    };
    OrderCreateFBOComponent.prototype.getOrderShippings = function () {
        var _this = this;
        var orderShippingObject = {
            savedAddressId: this.savedAddressId,
            verifiedShippingAddressId: this.verifiedShippingAddressId,
            orderFormGroup: this.orderFormGroup,
            shipMethod: this.shipMethod,
            originalShippingCost: this.originalShippingCost,
            shippingCost: this.shippingCost,
            shippingTax: (this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice) ? 0 : this.shippingTax,
            distributionCenterName: this.shipMethods.distributionCenterName,
            memberShippingDiscountOfferEligible: this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.isWaiveShippingCost ? true : false,
            isVATRegistered: (this.bonusInformation && this.bonusInformation.vatId) || (this.checkoutConfig && this.checkoutConfig.vatInPersonalInfo && this.personalInformation && this.personalInformation.vatId) ? true : false
        };
        var shippingObj = this.shippingMethods.find(function (shipMethod) { return shipMethod.shippingMethodId == _this.orderFormGroup.value.shipMethodId; });
        if (shippingObj && shippingObj.freeShippingEligible && shippingObj.promotionId) {
            var orderPromotionTrackingList = [{
                    promotionID: shippingObj.promotionId
                }];
            orderShippingObject.orderPromotionTrackingList = orderPromotionTrackingList;
        }
        return this._enrollmentCommonService.getOrderShippings(orderShippingObject, this.appConfig, true);
    };
    OrderCreateFBOComponent.prototype.getOrderPaymentInfo = function () {
        var orderPaymentObject = {
            orderFormGroup: this.orderFormGroup,
            savePaymentMethod: this.savePaymentMethod,
            products: this.products,
            memberInfo: this.memberInfo,
            countryTaxInclusive: this.countryTaxInclusive,
            storeInfo: this.storeInfo,
            checkoutConfig: this.checkoutConfig,
            importFeeValue: this.importFeeValue,
            shippingCost: this.shippingCost,
            shippingTax: (this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice) ? 0 : this.shippingTax,
            taxableAmount: this.taxableAmount,
            selectedPayvisionCardInfo: this.selectedPayvisionCardInfo,
            echeckRequest: this.getAchInfo(),
            eCheckTokenRes: this.eCheckTokenRes,
            isVATRegistered: (this.bonusInformation && this.bonusInformation.vatId) || (this.checkoutConfig && this.checkoutConfig.vatInPersonalInfo && this.personalInformation && this.personalInformation.vatId) ? true : false,
            isEnableVATCalculation: this.appConfig && this.appConfig.enableVATCalculation === true ? true : false,
            authorizationCode: this.paymentComponentSettings && this.paymentComponentSettings.authorizationCode ? this.paymentComponentSettings.authorizationCode : null
        };
        return this._enrollmentCommonService.getOrderPaymentInfo(orderPaymentObject);
    };
    OrderCreateFBOComponent.prototype.getAddresses = function () {
        var _this = this;
        var countryObj = null;
        if (this.countryCode) {
            countryObj = this.countries.filter(function (x) { return x.isocodeThree === _this.countryCode; })[0];
        }
        var addressObject = {
            orderFormGroup: this.orderFormGroup,
            shipMethod: this.shipMethod,
            countries: this.countries,
            states: this.states,
            deliveryPreference: this.deliveryPreference,
            countryCode: this.countryCode,
            shippingAddressInfo: this.shippingAddressInfo,
            selectedCountryCodeTwo: this.selectedCountryCodeTwo,
            billingAddressInfo: this.billingAddressInfo ? this.billingAddressInfo : (this.mailingAddress ? this.mailingAddress : (this.shippingAddressInfo ? this.shippingAddressInfo : null)),
            selectedpudoAddress: this.selectedPudoCollectionPoint ? this.selectedPudoCollectionPoint : null,
            storeInfo: this.storeInfo ? this.storeInfo : null,
            countryId: this.selectedIsoCountryCode ? this.selectedIsoCountryCode : null,
            pudoShippingAddressInfo: this.pudoShippingAddressInfo ? this.pudoShippingAddressInfo : null
        };
        return this._enrollmentCommonService.getAddresses(addressObject, this.storeInfo.foreverDirectEnabled);
    };
    /**
 * create order log request parameter
 */
    OrderCreateFBOComponent.prototype.createOrderLog = function (res, message) {
        var orderLogRequest = {
            'messageTypeId': MessageTypeEnum.OrderLogsMessageType,
            'orderId': res.id,
            'webOrderId': res.webOrderId,
            'message': message ? message : 'Order Placed by the agent',
            'source': Constants.CUSTOMER_SERIVCE
        };
        // this._orderService.createOrderLog(orderLogRequest).subscribe((response) => {   },
        //  (error: any) =>
        //   {
        //    this._commonService.createNotification('', 'Failed to Create order log', NotificationType.ERROR);
        // });
    };
    OrderCreateFBOComponent.prototype.sendPasswordResetLink = function (fboCreateResponse) {
        if (fboCreateResponse.personalInfo.fboId) {
            this.signUpEmail = fboCreateResponse.personalInfo.fboId;
            this._enrollService.sendPasswordResetEmail(this.signUpEmail, this.countryCode, this.orderFormGroup.controls['language'].value).subscribe(function (successResponse) {
            });
        }
    };
    OrderCreateFBOComponent.prototype.orderSuccess = function (response) {
        var subTotal = this.calculateItemsSubTotal(this.storeInfo);
        this.isOverrideMinimumLimit && this.hasMinimumOverrideLimit && subTotal <= this.orderRules.minValue ? this.saveMemberActivityLog(response.personalInfo.memberId, MemberActivityLogType.Override_Minimum_Limit) : false;
        this.showSelectedShipMethod = false;
        this.paymentComponentSettings.webOrderId = response.webOrderId;
        this.paymentComponentSettings.orderReferenceId = response.id;
        this.openOrderViewTab(this.paymentComponentSettings.webOrderId);
        this.orderFromLookup = false;
        this.clearFBOFormDetails();
        this.clearAllTheForms(true, true, true);
        this.isSubmitted = false;
        this.clearFBOForm();
        this.onSelectNewFBOCreateFlow();
        this.paymentComponentSettings = new PaymentComponentSettings();
        this.removeSessionGuid();
    };
    OrderCreateFBOComponent.prototype.openAccountConfirmationTab = function (emailID) {
        var orderInfo = new OrderInfoTab();
        orderInfo.tabForOrderPromotion = true;
        orderInfo.homeCountry = this.selectedIsoCountryCode;
        orderInfo.newOrder = true;
        orderInfo.emailID = emailID;
        this.messageService.setOrderHistoryTab(orderInfo);
    };
    OrderCreateFBOComponent.prototype.enrollmentSuccessRefreshScreen = function () {
        this.showSelectedShipMethod = false;
        this.orderFromLookup = false;
        this.clearFBOFormDetails();
        this.clearAllTheForms(true, true, true);
        this.clearFBOForm();
        this.onSelectNewFBOCreateFlow();
        this.isSubmitted = false;
        this.paymentComponentSettings = new PaymentComponentSettings();
    };
    OrderCreateFBOComponent.prototype.openOrderViewTab = function (weborderID) {
        var orderInfo = new OrderInfoTab();
        orderInfo.webOrderID = weborderID;
        orderInfo.tabForOrderPromotion = true;
        orderInfo.homeCountry = this.selectedIsoCountryCode;
        orderInfo.newOrder = true;
        this.messageService.setOrderHistoryTab(orderInfo);
    };
    /**
     * @description This method used to reset FBO flow details
     * @method clearFBOFormDetails()
     * @memberof OrderCreateFBOComponent
     */
    OrderCreateFBOComponent.prototype.clearFBOFormDetails = function () {
        this.orderFormGroup.controls['orderType'].setValue(this.orderTypeFBO);
        this.personalInformation = null;
        this.sponsorInformation = null;
        this.returningFBOUser = null;
        this.mailingAddress = null;
        this.liveFormAddress = null;
        this.agreementDocuments = [];
        this.isFBOEnrollmentEligible = false;
        this.fboEligibleProducts = null;
        this.bonusInformation = null;
        this.orderFormGroup.controls['fboEligibleProducts'].setValue('');
        this.featuredPacks = [];
        this.enrollmentKits = [];
    };
    /**
     * clear form
     */
    OrderCreateFBOComponent.prototype.clearOrderForm = function (isClearRetailForm) {
        this.clearAllTheForms(true, true, true);
        this.clearFBOForm();
        var countryElement = document.getElementById('country');
        if (countryElement) {
            countryElement.focus();
        }
        this.selectedCountry();
    };
    /**
     * To clear fbo form when clicking on cancel
     */
    OrderCreateFBOComponent.prototype.clearFBOForm = function () {
        this.liveFormPersonalInfo = null;
        this.paymentComponentSettings.savedCards = [];
        this.address = null;
        this.liveFormAddress = null;
        this.mailingAddress = null;
        this.storeInfo = null;
        this._enrollmentMessageService.setStoreInfo(this.storeInfo);
        this.orderSession = null;
        this.savePaymentMethod = false;
        this.orderFormGroup.controls['isContactSponsor'].setValue(null);
        this.memberCommunicationPreferences.email = false;
        this.checkContactSponsor();
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        this.orderFormGroup.controls['paymentInstrumentId'].setValidators([Validators.required]);
        this.orderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
        this.orderTypeChange(this.orderFormGroup.value.orderType);
        this.bonusInformation = null;
    };
    OrderCreateFBOComponent.prototype.getSubmitButtonStatus = function () {
        return (!this.agreementCheckError && !this.mailAlreadyExist && ((!this.taxCalculationStatus && (this.orderFormGroup.valid))
            || (!this.products))
            && !this.isSubmitted && this.isPayByLinkValid && (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP ? ((this.selectedPudoCollectionPoint) ? true : false) : true) && this.validatePersonalInfoForm(this.personalInfoFormValid) && (this.paymentReferenceNumber && this.paymentReferenceNumber.valid) && ((this.sponsorInformation && this.mailingAddress) ? null : ''));
    };
    OrderCreateFBOComponent.prototype.validatePersonalInfoForm = function (personalInfoFormValid) {
        var customError = document.getElementsByClassName('error custom-error');
        if (!personalInfoFormValid) {
            return false;
        }
        else if (customError && customError.length) {
            return false;
        }
        return true;
    };
    /**
    * @description this method used for allow user to enter address fields
    * @memberof OrderCreateFBOComponent
    */
    OrderCreateFBOComponent.prototype.enableAddressFields = function (block) {
        var addressFieldInfo = {
            isEnableAddressFields: true,
            block: block
        };
        this.messageService.setEnableAddressFields(addressFieldInfo);
    };
    /**
    * @description this method used to get government identification types
    * @memberof OrderCreateFBOComponent
    */
    OrderCreateFBOComponent.prototype.getGovtIdentificationTypes = function () {
        var _this = this;
        this._customerService.getGovernmentIdentificationTypes()
            .subscribe(function (response) {
            if (response) {
                _this.govtIdentificationTypes = response;
            }
        });
    };
    /**
     * @description save billing address
     * @param {Address} address
     * @memberof OrderCreateFBOComponent
     */
    OrderCreateFBOComponent.prototype.saveBillingAddress = function (address) {
        if (address) {
            this.billingAddressInfo = this.mapVerifiedAddressToFormFields(address);
            if (this.saveEcheckFormBtn) {
                this.saveEcheckFormBtn.nativeElement.click();
            }
        }
    };
    OrderCreateFBOComponent.prototype.moveToItemLevelSearchBlock = function (event) {
        if (this.itemLevelSearch && this.itemLevelSearch.nativeElement) {
            this.itemLevelSearch.nativeElement.focus();
        }
    };
    OrderCreateFBOComponent.prototype.savePudoShippingAddress = function (address) {
        address = this.mapVerifiedAddressToFormFields(address);
        if (this.memberInfo && this.orderFormGroup.controls['saveForFutureUse'].value) {
            this.saveAddress(address);
        }
        else if (this.pudoAddress && this.pudoAddress.isSavedAddress) {
            this.messageService.setAddressSaved(true);
        }
        if (address && address.countryId && this.countries && this.countries.length > 0) {
            var country = this.countries.find(function (x) { return x.countryId === address.countryId; });
            this.countryTaxInclusive = this._enrollmentCommonService.getCountryTaxInclusiveInfo(country);
        }
        this.pudoShippingAddressInfo = address;
        this.pudoAddress = address;
        this.pudoAddressSubmitted = true;
        // if(this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP && !this.isnewcardAdded){
        //     this.isnewcardAdded=true;
        //     this.selectSavedCard(null,true);
        // }else{
        //     this.submitEnrollment();
        // }
    };
    /**
     * prevent +, -, e entering in shipping cost
     */
    OrderCreateFBOComponent.prototype.keyEventShippingCost = function (event) {
        if (event.keyCode === 43 || event.keyCode === 45 || event.keyCode === 101) {
            event.preventDefault();
        }
    };
    OrderCreateFBOComponent.prototype.buildAchForm = function () {
        var phone = '';
        var email = '';
        var checkNumber = "";
        if (this.memberInfo) {
            email = this.memberInfo.email;
            if (this.phoneNumberFormat) {
                phone = this._maskPipe.transform(this.memberInfo.phone, this.phoneNumberFormat);
            }
            else {
                phone = this.memberInfo.phone;
            }
        }
        this.paymentAchForm = this._formbuilder.group({
            routerNumber: ['', [Validators.required, Utils.alphaNumericCharacterValidation, Validators.maxLength(9)]],
            accountNumber: ['', [Validators.required, CustomValidators.requiredNotEmpty]],
            //  accountType: ['', [Validators.required]],
            dlNumber: ["", [Validators.required, CustomValidators.requiredNotEmpty]],
            dlState: ["", [Validators.required, CustomValidators.requiredNotEmpty]],
            secType: ['', [Validators.required, CustomValidator.checkIfAccountSelected()],
            ],
            email: [email, Validators.required],
            phone: [phone, [Validators.required, EcheckPhoneNumberValidation.PhoneNumberValidation]],
            checkNumber: [checkNumber, [Validators.required, CustomValidators.requiredNotEmpty]],
            reuse: [false],
        });
    };
    /**
     * on change of Ach
     */
    // selectAch(achDetails: PersonalAch, isNewAch: boolean) {
    //     if (isNewAch) {
    //         this.buildAchForm();
    //         this.echeckSubmitted = false;
    //         this.eCheckValidationMessages = [];
    //         this.addNewAchCard = true;
    //         this.achPaymentPopup.open();
    //     } else {
    //         this.selectedAchInfo = achDetails;
    //         this.billingAddressInfo = achDetails.billingAddress;
    //         this.addNewAchCard = false;
    //         this.achRequest = {
    //         id:  achDetails.id,
    //         accountNumber: achDetails.accountNumber,
    //         routingNumber: achDetails.routingNumber,
    //         accountType: achDetails.accountType,
    //         secType: achDetails.secType,
    //         checkNumber: achDetails.checkNumber,
    //         dlNumber: achDetails.dlNumber,
    //         dlState: achDetails.dlState,
    //         portalType: EcheckPortalTypes.CustomerCare,
    //         reusable: true,
    //         defaultECheck: false,
    //         customerId: 1,
    //         billingAddress: this.getBillingAddressForECheck(),
    //         billingAddressId: null,
    //         storeId: this.paymentComponentSettings.storeId,
    //         paymentMethodType: PaymentConstants.echeck,
    //         email: achDetails.email,
    //         phone: achDetails.phone,
    //         billingAddressRequired: true,
    //         name:this.billingAddressInfo.name
    //         };
    //         if (this.paymentFormBtn && this.paymentFormBtn.nativeElement) {
    //             this.paymentFormBtn.nativeElement.focus();
    //         }
    //     }
    //  }
    /**
* @description submit ach payment information
* @memberof NewPaymentEcheckComponent
*/
    OrderCreateFBOComponent.prototype.submitAchPaymentInformation = function (achPaymentInfo) {
        if (achPaymentInfo) {
            this.achPaymentInfo = achPaymentInfo;
            this.achToken = this.achPaymentInfo.personalCheckId;
            this.getSavedAchs();
            this.achPaymentPopup.close();
        }
    };
    /**
   * Get ACH payment details
   */
    OrderCreateFBOComponent.prototype.getSavedAchs = function () {
        var _this = this;
        var memberId = this.getUserMemberId();
        if (this.memberInfo && this.memberInfo.memberId) {
            this._achService.getSavedEchecks(memberId, this.selectedIsoCountryCode, PaymentMethodTypeConstants.eCheck, this.achToken)
                .subscribe(function (response) {
                if (response && response.length) {
                    _this.orderFormGroup.controls['paymentInstrumentId'].setValue(_this.paymentComponentSettings.savedAchs[0].id);
                    _this.paymentComponentSettings.savedAchs = response;
                    if (_this.achRequest && _this.achRequest.reusable) {
                        var selectedCard = _this.paymentComponentSettings.savedAchs.find(function (x) { return x.id === _this.achRequest.id; });
                        if (selectedCard) {
                            var indexPostion = _this.paymentComponentSettings.savedAchs
                                .findIndex(function (x) { return x.id === _this.achRequest.id; });
                            _this.paymentComponentSettings.savedAchs.splice(indexPostion, 1);
                            _this.paymentComponentSettings.savedAchs.unshift(selectedCard);
                        }
                        else {
                            var index_1 = _this.paymentComponentSettings.savedAchs.length - 1;
                            _this.orderFormGroup.controls['paymentInstrumentId'].setValue(_this.paymentComponentSettings.savedAchs[index_1].id);
                        }
                        var index = _this.paymentComponentSettings.savedAchs.length - 1;
                        //this.selectAch(this.paymentComponentSettings.savedAchs[index],false);
                    }
                    else {
                        var index = _this.paymentComponentSettings.savedAchs.length - 1;
                        // this.selectAch(this.paymentComponentSettings.savedAchs[index],false);
                    }
                    _this.savedAch = JSON.stringify(_this.paymentComponentSettings.savedAchs);
                }
            });
        }
    };
    /**
     * map Ach Info for payment
    */
    OrderCreateFBOComponent.prototype.getAchInfo = function () {
        this.achPaymentInfo = this.achPaymentInfo ? this.achPaymentInfo : this.selectedAchInfo;
        if (this.achPaymentInfo) {
            var paymentAchInfo = {
                bankName: this.achPaymentInfo.bankName,
                accountNumber: this.achPaymentInfo.accountNumber,
                routingNumber: this.achPaymentInfo.routingNumber,
                accountType: this.achPaymentInfo.accountType,
                mecTransactionID: '',
                nameOnBankAccount: this.achPaymentInfo.nameOnBankAccount,
                customMessage: '',
                reusable: this.achPaymentInfo.reusable,
                eCheckID: this.achPaymentInfo.id,
                email: this.achPaymentInfo.email,
                phone: this.achPaymentInfo.phone,
                secType: this.achPaymentInfo.secType,
                dlState: this.achPaymentInfo.dlState,
                dlNumber: this.achPaymentInfo.dlNumber,
                checkNumber: this.achPaymentInfo.checkNumber,
            };
            return paymentAchInfo;
        }
    };
    OrderCreateFBOComponent.prototype.getUserMemberId = function () {
        var memberId = null;
        if (this.memberInfo && this.memberInfo.memberId) {
            memberId = this.memberInfo.memberId;
        }
        else
            memberId = 0;
        return memberId;
    };
    OrderCreateFBOComponent.prototype.onPaymentAchFormClose = function () {
        this.addNewAchCard = false;
        this.achPaymentPopup.close();
    };
    /**
       * @description To get the list of bank details from payment service based on country
       * @date 2021-01-07
       * @param {*} countryCode
       * @memberof OrderCreateFBOComponent
       */
    OrderCreateFBOComponent.prototype.getBankDetailsByCountry = function (countryCode, paymentMethod) {
        var _this = this;
        this._achService.getBankDetailsByCountry(countryCode).subscribe(function (response) {
            if (response && response.length > 0) {
                if (paymentMethod && PaymentMethodTypes.Wire_Transfer.toLowerCase() === paymentMethod.toLowerCase()) {
                    _this.bankDetailsCountryList = response.filter(function (bankDetail) { return bankDetail.paymentMode.toLowerCase() === PaymentMethodTypes.Wire_Transfer.toLowerCase(); });
                }
                else {
                    _this.bankDetailsCountryList = response;
                }
            }
            else {
                _this.bankDetailsCountryList = [];
            }
        });
    };
    OrderCreateFBOComponent.prototype.selectBonusPaymentType = function (paymentOption) {
        this.bonusPaymentOptionType = paymentOption;
        if (paymentOption === this.bonusPaymentOption.DECIDE_LATER) {
            this.bonusInformation = null;
            this.isSubmitted = false;
        }
    };
    // Start Region Promotion
    /**
     * To Get Promotions based on store
     */
    OrderCreateFBOComponent.prototype.getStorePromotions = function (langCultureID, resetPromotion) {
        var _this = this;
        this.promotionModels = [];
        var promotionrequest = {
            memberType: MemberTypeId.DISTRIBUTOR,
            orderType: PromotionOrderType.JOIN,
            isTaxInclusive: this.countryTaxInclusive,
            memberLevel: MemberLevel.ASSISTANTSUPERVISOR,
            languageSetting: langCultureID ? langCultureID : null
        };
        this._commonService.getPromotionEngineConfigurations(this.storeId, promotionrequest).subscribe(function (response) {
            if (response && response.promotionModelList && response.promotionModelList.length > 0) {
                _this.promotionModels = response.promotionModelList;
                if (resetPromotion && _this.orderFormGroup.get('items').length > 0) {
                    _this.reUpdateCartAndPromotion();
                }
            }
            else {
                _this.promotionModels = [];
                _this.reUpdateCartAndPromotion();
            }
        }, function (error) {
            _this.promotionModels = [];
            _this.reUpdateCartAndPromotion();
        });
    };
    /**
     * Rebind the products based promotions
     */
    OrderCreateFBOComponent.prototype.reUpdateCartAndPromotion = function () {
        var items = this.orderFormGroup.get('items');
        var freeProductsInfo = this.validatePromotionCriteria(items);
        var productIds = this._commonService.updateCartAfterPromotion(freeProductsInfo, items, this.orderFormGroup, this.promotionIds);
        this._commonService.removeNonPromotionProducts(freeProductsInfo, items);
        if (productIds && productIds.length) {
            this.addPromotionEngineProducts(productIds, freeProductsInfo);
        }
        else {
            this.updateTotalsAndShipMethod();
        }
    };
    /**
     * Validate Promotions based on all criteria
     * @param product
     * @returns
     */
    OrderCreateFBOComponent.prototype.validatePromotionCriteria = function (product) {
        var items = this.orderFormGroup.get('items');
        var freeProductsInfo = [];
        if (this.promotionModels && this.promotionModels.length > 0) {
            this._commonService.setSubTotalAndOrderCC(this.itemSubTotal, this.totalCommissionableVolume, this.countryTaxInclusive);
            this._commonService.validateOrderCriteria(this.promotionModels, freeProductsInfo, items);
            this._commonService.validateOrderSubTotalCriteria(this.promotionModels, freeProductsInfo, items);
            this._commonService.validateOrderCCCriteria(this.promotionModels, freeProductsInfo, items);
            this._commonService.validateProductCriteria(this.promotionModels, freeProductsInfo, items);
            this._commonService.validateProductAtQuantityCriteria(this.promotionModels, freeProductsInfo, items);
            this._commonService.validateMultipleProductCriteria(this.promotionModels, freeProductsInfo, items);
        }
        return this._commonService.removeDuplicates(freeProductsInfo);
    };
    OrderCreateFBOComponent.prototype.shippingPercentChange = function (event) {
        if (event.keyCode !== 8) {
            var value = (this.orderFormGroup.controls['shippingCostPercentage'].value
                ? this.orderFormGroup.controls['shippingCostPercentage'].value : '') + (event.key ? event.key : '');
            var pattern = /^(?:100|[1-9]?[0-9])$/;
            if (!new RegExp(pattern).test(value)) {
                event.preventDefault();
            }
        }
    };
    /**
     * To Get Promotion Product details and bind it to order line items
     * @param productIds
     */
    OrderCreateFBOComponent.prototype.addPromotionEngineProducts = function (productIds, freeProductsInfo) {
        var _this = this;
        var items = this.orderFormGroup.get('items');
        // const notification: any = this._translatePipe.get('order.Invalid Item Number');
        if (items && items.length >= 0) {
            this._orderService.getProductsByIds(productIds, this.storeDefaultLanguage, this.storeInfo.id, this.getMemberTitleId(), this._enrollmentCommonService.getPurchaseFlow(this.orderFormGroup.controls['orderType'].value), this.selectedIsoCountryCode, false, false, this.storeInfo.taxInclusive).subscribe(function (products) {
                if (products && products.length > 0) {
                    products.forEach(function (product) {
                        var freeProductIndex = items.controls.findIndex(function (item) { return item.controls['productId'].value === product.id; });
                        if (items && items.length >= 0 && freeProductIndex < 0) {
                            var currentFreeProduct = freeProductsInfo.find(function (freeProduct) { return freeProduct.productId === product.id; });
                            var stockQuantity = _this._commonService.stockQuantityCheck(product, currentFreeProduct);
                            if (stockQuantity.currentFreeProductQuantity > 0) {
                                _this.addItemNumber();
                                var index = (items.length - 1);
                                items.controls[index].controls['quantity'].setValidators([Validators.required]);
                                if (currentFreeProduct.promotionId && currentFreeProduct.promotionId.length > 0) {
                                    currentFreeProduct.promotionId.forEach(function (promotionId) {
                                        if (_this.promotionIds.indexOf(promotionId) == -1) {
                                            _this.promotionIds.push(promotionId);
                                        }
                                    });
                                }
                                currentFreeProduct.quantity = stockQuantity.currentFreeProductQuantity;
                                items = _this._commonService.addPromoItem(items, index, product, environment.uiTemplateBaseUrl, environment.cdnURL);
                                var productItem = items.controls[index].controls['productItem'].value;
                                productItem.orderPromotionTrackings = stockQuantity.orderPromotionTrackings;
                                if (!items.controls[index].controls['quantity'].value) {
                                    items.controls[index].controls['quantity'].setValue(currentFreeProduct.quantity);
                                }
                                items.controls[index].controls['quantity'].updateValueAndValidity();
                                productItem.quantity = currentFreeProduct.quantity;
                                items.controls[index].controls['productItem'].setValue(productItem);
                            }
                        }
                    });
                }
                else {
                    if (_this.itemLevelSearch && _this.itemLevelSearch.nativeElement) {
                        _this.itemLevelSearch.nativeElement.focus();
                    }
                    // this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                }
                _this.itemLevelSearch.nativeElement.value = '';
            });
            this.updateTotalsAndShipMethod();
        }
    };
    // End Region Promotion
    OrderCreateFBOComponent.prototype.fetchTermsConditionDocument = function () {
        var _this = this;
        var customerTypeId = DocumentLibraryMemberId.Distributor;
        var displaySetionId = DisplaySectionId.Fbo_Sign_up;
        this._documentService.getDocuments(Portal.Csp, customerTypeId, displaySetionId, this.countryCode, this.storeDefaultLanguage)
            .subscribe(function (response) {
            if (response && response.length > 0 && response[0].body && response[0].body.length > 0) {
                _this.bonusInfoAgreements = response[0].body;
                _this.bonusInfoAgreements.forEach(function (agreement) {
                    return agreement.isSelected = false;
                });
            }
            else {
                var notification = _this._translatePipe.get('order.Unable to fetch Agreement Details');
                _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            }
        }, function (error) {
            var notification = _this._translatePipe.get('order.Unable to fetch Agreement Details');
            _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        });
    };
    OrderCreateFBOComponent.prototype.addNewPudoShippingAddress = function () {
        var _this = this;
        this.pudoAddress = null;
        this.showPudoPickupPersonAddressForm = true;
        setTimeout(function () {
            _this.displayPudoAddress = true;
        }, 100);
    };
    OrderCreateFBOComponent.prototype.addNewDropshipPersonAddress = function () {
        var _this = this;
        this.pudoShippingAddressInfo = null;
        this.showDropShipPersonAddressForm = true;
        setTimeout(function () {
            _this.displayDropAddress = true;
        }, 100);
    };
    OrderCreateFBOComponent.prototype.addNewAddress = function () {
        if (this.shippingAddressInfoConfig && (this.shippingAddressInfoConfig.pudoLocationsEnabled && !this.shippingAddressInfoConfig.dropShipLocationsEnabled) && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.displayPudoAddress = false;
            this.pudoAddressSubmitted = false;
            this.addNewPudoShippingAddress();
        }
        else if (this.shippingAddressInfoConfig && (!this.shippingAddressInfoConfig.pudoLocationsEnabled && this.shippingAddressInfoConfig.dropShipLocationsEnabled) && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.displayDropAddress = false;
            this.pudoAddressSubmitted = false;
            this.addNewDropshipPersonAddress();
        }
        else {
            this.address = null;
            this.isNewCard = true;
            this.shippingAddressInfo = null;
            this.shippingMethods = [];
            this.updateTotalsAndShipMethod();
        }
        this.clearPudoLocationSearchData();
    };
    OrderCreateFBOComponent.prototype.clearPudoLocationSearchForm = function () {
        this.pudoCollectionPoints = null;
        this.selectedPudoCollectionPoint = null;
        this.pudoLocationSearchForm = null;
        this.pudoLocationsNotFound = false;
        this.hidePudoPickupLocationsButton = false;
        this.buildPudoLocationSearchForm();
    };
    OrderCreateFBOComponent.prototype.clearPudoLocationSearchData = function () {
        this.pudoCollectionPoints = null;
        this.selectedPudoCollectionPoint = null;
        this.pudoLocationSearchForm = null;
        this.pudoLocationsNotFound = false;
        this.hidePudoPickupLocationsButton = true;
        this.buildPudoLocationSearchForm();
    };
    OrderCreateFBOComponent.prototype.getAddressIsValid = function (isValid) {
        this.formPickupPersonAddressValid = isValid;
        this.pudoLocationsNotFound = false;
    };
    OrderCreateFBOComponent.prototype.getPudoCollectPointAddress = function () {
        if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP) {
            var pudoaddress = null;
            pudoaddress = this._enrollmentCommonService.getWarehouseAddress(this.storeInfo, this.selectedIsoCountryCode);
            if (this.selectedPudoCollectionPoint && (this.shippingAddressInfoConfig.pudoLocationsEnabled || this.shippingAddressInfoConfig.dropShipLocationsEnabled)) {
                pudoaddress.addressLine1 = this.selectedPudoCollectionPoint.street;
                pudoaddress.addressLine2 = this.selectedPudoCollectionPoint.address2;
                pudoaddress.city = this.selectedPudoCollectionPoint.city;
                pudoaddress.addressType = AddressType.PUDO;
                pudoaddress.zip = this.selectedPudoCollectionPoint.zipCode;
                pudoaddress.postalCode = this.selectedPudoCollectionPoint.zipCode;
                pudoaddress.name = this.selectedPudoCollectionPoint.name;
                if (this.shippingAddressInfo && this.shippingAddressInfo.countryId) {
                    pudoaddress.countryId = this.shippingAddressInfo.countryId;
                }
            }
            return pudoaddress;
        }
    };
    OrderCreateFBOComponent.prototype.setBusinessInformation = function () {
        this._personalMessageService.setSubmitBusinessInfo(true);
    };
    OrderCreateFBOComponent.prototype.getBusinessInfo = function (event) {
        if (event) {
            this.businessInformation = event;
        }
    };
    OrderCreateFBOComponent.prototype.getBusinessInfoOnInputChange = function (event) {
        if (event) {
            this.businessInformation = event;
        }
    };
    OrderCreateFBOComponent.prototype.buildPayByLinkForm = function () {
        this.emailForm = this._formbuilder.group({
            payByLinkEmail: ['', [Validators.required]]
        });
    };
    OrderCreateFBOComponent.prototype.emailCheck = function () {
        if (this.emailForm.controls['payByLinkEmail'].value !== '' && this.emailForm.controls['payByLinkEmail'].valid) {
            this.isPayByLinkValid = true;
        }
        else {
            this.isPayByLinkValid = false;
        }
    };
    OrderCreateFBOComponent.prototype.onChangeLanguage = function () {
        if (this.orderFormGroup.controls['language']) {
            var cultureName_1 = this.orderFormGroup.controls['language'].value;
            var selectedLanguage = this.storeInfo.languages.find(function (language) { return language.cultureName === cultureName_1; });
            if (selectedLanguage) {
                this.getFboDocuments(cultureName_1);
                this.languageCulture = selectedLanguage.cultureName;
                this.payByLinkLanguageShortCode = selectedLanguage.languageCode;
                this.getStorePromotions(selectedLanguage.cultureId, true);
                this.orderFormGroup.get('itemSearch').setValue("");
                this.isDropShipOptionExist = false;
                this.isPickUpOptionExist = false;
            }
        }
    };
    OrderCreateFBOComponent.prototype.getPudoDropShipPersonAddress = function (collectionPoint) {
        var address = collectionPoint;
        var dropShipAddress;
        if (collectionPoint) {
            dropShipAddress = {
                addressLine1: address.street ? collectionPoint.street : this.pudoShippingAddressInfo.addressLine1,
                addressLine2: address.address2,
                addressLine3: address.address3,
                city: address.city,
                state: collectionPoint.state,
                stateCode: this.pudoShippingAddressInfo.stateCode || null,
                countryCode: this.selectedIsoCountryCode,
                country: collectionPoint.country || this.selectedIsoCountryCode,
                postalCode: this.pudoShippingAddressInfo.postalCode || null,
                zipCode: address.zipCode,
                countryId: this.pudoShippingAddressInfo.countryId,
                stateId: this.pudoShippingAddressInfo.stateId,
                externalId: address.externalId,
                name: address.name ? this.storeInfo.warehouseAddress.name : null
            };
            this.pudoAddress = dropShipAddress;
            this.messageService.setPudoPersonAddress(true);
            this.dropShipAddress = dropShipAddress;
        }
        else if (this.dropLoactionSelected) {
            return this.dropShipAddress;
        }
        else if (this.orderSession && this.orderSession.pudoaddress) {
            return this.orderSession.pudoaddress;
        }
        else {
            return;
        }
    };
    OrderCreateFBOComponent.prototype.getRecentlyviewedProducts = function (orderRequest) {
        var wholesaleQualified = orderRequest.wholesaleQualified;
        var optin = orderRequest.optin;
        var productIds = orderRequest.orderLineItems.map(function (item) { return item.productId; });
        this.purchaseFlowType = this._commonService.getPurchaseFlowType(orderRequest.memberTitleId, orderRequest.wholesaleQualified, this.appConfig.fpc5PercentEnabled, false, orderRequest.memberTitleId);
        if (productIds && productIds.length > 0) {
            return this._orderService.getProductsByIds(productIds, this.storeDefaultLanguage, this.storeInfo.id, orderRequest.memberLevelId, this.purchaseFlowType, this.selectedIsoCountryCode, wholesaleQualified ? true : false, optin ? true : false, this.storeInfo.taxInclusive).toPromise();
        }
        else {
            var notification = this._translatePipe.get('order.Products not added .');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            this.isSubmitted = false;
        }
    };
    OrderCreateFBOComponent.prototype.setPUDOSuggestedAddress = function () {
        var _this = this;
        this.pudoSuggestedAddressSubscription = this.messageService.getPUDOSuggestedAddress().subscribe(function (value) {
            if (value) {
                _this.buildPudoLocationSearchForm(value.zip, value.city, value.addressLine1);
                _this.getPudoLocations();
            }
        });
    };
    OrderCreateFBOComponent.prototype.ngOnDestroy = function () {
        if (this.customSelectSubscription) {
            this.customSelectSubscription.unsubscribe();
        }
        if (this.pudoSuggestedAddressSubscription) {
            this.pudoSuggestedAddressSubscription.unsubscribe();
        }
        this._cacheService.remove(CacheKey.COUNTRY_CODE);
        this._cacheService.remove(CacheKey.COUNTRY_ID);
    };
    /**
     * @description To get the Payment method type based on USA country pick up location.
     * @date 2023-28-06
     * @param shippingMethod
     */
    OrderCreateFBOComponent.prototype.getPickupDetailsForUSA = function (shippingMethod) {
        var _this = this;
        if (shippingMethod.shippingMethod == CommonConstant.LOS_ANGELES_PRODUCT_CENTER) {
            this.storePaymentInfo.forEach(function (paymentMethod) {
                if (paymentMethod.paymentMethodId === PaymentType.Credit_Card) {
                    _this.credit_Card_show = true;
                }
                else if (paymentMethod.paymentMethodId === PaymentType.Money_order) {
                    _this.money_Order_show = false;
                }
                else if (paymentMethod.paymentMethodId === PaymentType.Wire_Transfer) {
                    _this.wire_Transfer_show = false;
                }
                else if (paymentMethod.paymentMethodId === PaymentType.Bank_Transfer) {
                    _this.bank_transfer_show = false;
                }
                else if (paymentMethod.paymentMethodId === PaymentType.Cash_On_Delivery) {
                    _this.cash_on_delivery_show = false;
                }
                else if (paymentMethod.paymentMethodId === PaymentType.Orange_Money) {
                    _this.orange_money_show = false;
                }
                else if (paymentMethod.paymentMethodId === PaymentType.eCheck) {
                    _this.ach_show = false;
                }
                else if (paymentMethod.paymentMethodId === PaymentType.Pay_By_Link) {
                    _this.pay_by_link_show = false;
                }
            });
        }
        else {
            this.storePaymentInfo.forEach(function (paymentMethod) {
                if (paymentMethod.paymentMethodId === PaymentType.Credit_Card) {
                    _this.credit_Card_show = false;
                }
                else if (paymentMethod.paymentMethodId === PaymentType.Money_order) {
                    _this.money_Order_show = true;
                }
                else if (paymentMethod.paymentMethodId === PaymentType.Wire_Transfer) {
                    _this.wire_Transfer_show = true;
                }
                else if (paymentMethod.paymentMethodId === PaymentType.Bank_Transfer) {
                    _this.bank_transfer_show = true;
                }
                else if (paymentMethod.paymentMethodId === PaymentType.Cash_On_Delivery) {
                    _this.cash_on_delivery_show = true;
                }
                else if (paymentMethod.paymentMethodId === PaymentType.Orange_Money) {
                    _this.orange_money_show = true;
                }
                else if (paymentMethod.paymentMethodId === PaymentType.eCheck) {
                    _this.ach_show = true;
                }
                else if (paymentMethod.paymentMethodId === PaymentType.Pay_By_Link) {
                    _this.pay_by_link_show = true;
                }
            });
        }
    };
    /**
         * @description To get the Payment method type based on USA country for delivery option.
         * @date 2023-28-06
         * @param shippingMethod
         */
    OrderCreateFBOComponent.prototype.getDeliveryOptionsPayment = function () {
        var _this = this;
        this.storePaymentInfo.forEach(function (paymentMethod) {
            if (paymentMethod.paymentMethodId === PaymentType.Credit_Card) {
                _this.credit_Card_show = true;
            }
            else if (paymentMethod.paymentMethodId === PaymentType.Money_order) {
                _this.money_Order_show = true;
            }
            else if (paymentMethod.paymentMethodId === PaymentType.Wire_Transfer) {
                _this.wire_Transfer_show = true;
            }
            else if (paymentMethod.paymentMethodId === PaymentType.Bank_Transfer) {
                _this.bank_transfer_show = true;
            }
            else if (paymentMethod.paymentMethodId === PaymentType.Cash_On_Delivery) {
                _this.cash_on_delivery_show = true;
            }
            else if (paymentMethod.paymentMethodId === PaymentType.Orange_Money) {
                _this.orange_money_show = true;
            }
            else if (paymentMethod.paymentMethodId === PaymentType.eCheck) {
                _this.ach_show = true;
            }
            else if (paymentMethod.paymentMethodId === PaymentType.Pay_By_Link) {
                _this.pay_by_link_show = true;
            }
        });
    };
    OrderCreateFBOComponent.prototype.getDropShipPudoShippingMethods = function (shippingOptions, shippingMethods, mappingRequired) {
        var _this = this;
        if (mappingRequired === void 0) { mappingRequired = true; }
        if (this.shippingAddressInfoConfig && (this.shippingAddressInfoConfig.pudoLocationsEnabled || this.isDropShipOptionExist)) {
            if ((shippingOptions && shippingOptions.toAddress && shippingOptions.toAddress.countryCode && this.storeInfo && this.storeInfo.homeIsocodeThree)) {
                if (this.storeInfo.homeIsocodeThree.toUpperCase() != shippingOptions.toAddress.countryCode.toUpperCase()) {
                    shippingOptions.toAddress = this._enrollmentCommonService.getWarehouseAddress(this.storeInfo, this.selectedIsoCountryCode);
                }
            }
            else {
                shippingOptions.toAddress = this._enrollmentCommonService.getWarehouseAddress(this.storeInfo, this.selectedIsoCountryCode);
            }
            shippingOptions.shippingTypeId = ShippingType.DELIVERY;
            this._orderService.getShipmentService(shippingOptions).subscribe(function (response) {
                if (response && response.shippingMethods && response.shippingMethods.length > 0) {
                    // Testing Purpose .
                    //response.shippingMethods[0].pudoEnabled = true;
                    _this.dropshipPudoShippingMethod = response.shippingMethods.find(function (x) { return x.pudoEnabled; });
                    if (mappingRequired) {
                        if (_this.dropshipPudoShippingMethod) {
                            _this.dropshipPudoShippingMethod.pickUpLocation = shippingMethods[0].pickUpLocation;
                        }
                    }
                }
            }, function (error) {
            });
        }
    };
    return OrderCreateFBOComponent;
}());
export { OrderCreateFBOComponent };



// WEBPACK FOOTER //
// ./src/app/customerservice/components/order-promotion-fbo.components.ts.pre-build-optimizer.js